/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as Verify2faRouteImport } from './routes/verify-2fa'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as RestoreOrganizationRouteImport } from './routes/restore-organization'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CreativeLabPanelRouteImport } from './routes/creative-lab-panel'
import { Route as CreativeLabCardRouteImport } from './routes/creative-lab-card'
import { Route as CreativeLabRouteImport } from './routes/creative-lab'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as OnboardingRouteImport } from './routes/_onboarding'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WelcomeIndexRouteImport } from './routes/welcome/index'
import { Route as StartTokenRouteImport } from './routes/start/$token'
import { Route as ConnectWhatsappRouteImport } from './routes/connect/whatsapp'
import { Route as ConnectFacebookRouteImport } from './routes/connect/facebook'
import { Route as OnboardingUploadAssetsRouteImport } from './routes/_onboarding/upload-assets'
import { Route as OnboardingSetupProfileRouteImport } from './routes/_onboarding/setup-profile'
import { Route as OnboardingOnboardingRouteImport } from './routes/_onboarding/onboarding'
import { Route as AuthedWireframeFullscreenRouteImport } from './routes/_authed/wireframe-fullscreen'
import { Route as AuthedWebsitePreviewRouteImport } from './routes/_authed/website-preview'
import { Route as AuthedReviewContentRouteImport } from './routes/_authed/review-content'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedBillingRouteImport } from './routes/_authed/billing'
import { Route as AuthedAssistantRouteImport } from './routes/_authed/assistant'
import { Route as AdminAdminRouteImport } from './routes/_admin/admin'
import { Route as VenueOrganizationSlugIndexRouteImport } from './routes/venue/$organizationSlug/index'
import { Route as OptInOrganizationSlugIndexRouteImport } from './routes/opt-in/$organizationSlug/index'
import { Route as AuthedRecordIndexRouteImport } from './routes/_authed/record/index'
import { Route as AuthedDashboardIndexRouteImport } from './routes/_authed/dashboard/index'
import { Route as AuthedCreateVideoIndexRouteImport } from './routes/_authed/create-video/index'
import { Route as AdminAdminIndexRouteImport } from './routes/_admin/admin/index'
import { Route as VenueOrganizationSlugLocationSlugRouteImport } from './routes/venue/$organizationSlug/$locationSlug'
import { Route as FormsOrganizationSlugTokenRouteImport } from './routes/forms/$organizationSlug/$token'
import { Route as ConnectStripeDoneRouteImport } from './routes/connect/stripe/done'
import { Route as AuthedWireframeFullscreenScribeRouteImport } from './routes/_authed/wireframe-fullscreen/scribe'
import { Route as AuthedWireframeFullscreenConsentKioskRouteImport } from './routes/_authed/wireframe-fullscreen/consent-kiosk'
import { Route as AuthedWireframeFullscreenCompareRouteImport } from './routes/_authed/wireframe-fullscreen/compare'
import { Route as AuthedWireframeFullscreenAnnotateRouteImport } from './routes/_authed/wireframe-fullscreen/annotate'
import { Route as AuthedSettingsClaireRouteImport } from './routes/_authed/settings/claire'
import { Route as AuthedRecordVideoIdRouteImport } from './routes/_authed/record/$videoId'
import { Route as AuthedDashboardWireframesRouteImport } from './routes/_authed/dashboard/wireframes'
import { Route as AuthedDashboardWebsiteRouteImport } from './routes/_authed/dashboard/website'
import { Route as AuthedDashboardVoiceTestRouteImport } from './routes/_authed/dashboard/voice-test'
import { Route as AuthedDashboardTrainingHubRouteImport } from './routes/_authed/dashboard/training-hub'
import { Route as AuthedDashboardTemplatePreviewRouteImport } from './routes/_authed/dashboard/template-preview'
import { Route as AuthedDashboardSettingsRouteImport } from './routes/_authed/dashboard/settings'
import { Route as AuthedDashboardReviewsRouteImport } from './routes/_authed/dashboard/reviews'
import { Route as AuthedDashboardRetentionRouteImport } from './routes/_authed/dashboard/retention'
import { Route as AuthedDashboardResetRouteImport } from './routes/_authed/dashboard/reset'
import { Route as AuthedDashboardReportsRouteImport } from './routes/_authed/dashboard/reports'
import { Route as AuthedDashboardOrganisationRouteImport } from './routes/_authed/dashboard/organisation'
import { Route as AuthedDashboardOffersRouteImport } from './routes/_authed/dashboard/offers'
import { Route as AuthedDashboardNotificationsRouteImport } from './routes/_authed/dashboard/notifications'
import { Route as AuthedDashboardLocationsRouteImport } from './routes/_authed/dashboard/locations'
import { Route as AuthedDashboardLeadManagementRouteImport } from './routes/_authed/dashboard/lead-management'
import { Route as AuthedDashboardLeadFormsRouteImport } from './routes/_authed/dashboard/lead-forms'
import { Route as AuthedDashboardIntegrationsRouteImport } from './routes/_authed/dashboard/integrations'
import { Route as AuthedDashboardIntakeFormsRouteImport } from './routes/_authed/dashboard/intake-forms'
import { Route as AuthedDashboardConversationsRouteImport } from './routes/_authed/dashboard/conversations'
import { Route as AuthedDashboardChatbotsRouteImport } from './routes/_authed/dashboard/chatbots'
import { Route as AuthedDashboardBrandRouteImport } from './routes/_authed/dashboard/brand'
import { Route as AuthedDashboardAccountRouteImport } from './routes/_authed/dashboard/account'
import { Route as AuthedDashboardSplatRouteImport } from './routes/_authed/dashboard/$'
import { Route as AuthedCreateEntityRouteImport } from './routes/_authed/create.$entity'
import { Route as AdminAdminStuckSetupRouteImport } from './routes/_admin/admin/stuck-setup'
import { Route as AdminAdminStockFootageRouteImport } from './routes/_admin/admin/stock-footage'
import { Route as AdminAdminScrapingRouteImport } from './routes/_admin/admin/scraping'
import { Route as AdminAdminMusicRouteImport } from './routes/_admin/admin/music'
import { Route as AdminAdminMetaConnectionsRouteImport } from './routes/_admin/admin/meta-connections'
import { Route as AdminAdminImportsRouteImport } from './routes/_admin/admin/imports'
import { Route as AdminAdminHarnessRouteImport } from './routes/_admin/admin/harness'
import { Route as AdminAdminCrmTriggersRouteImport } from './routes/_admin/admin/crm-triggers'
import { Route as AdminAdminConversationsRouteImport } from './routes/_admin/admin/conversations'
import { Route as AdminAdminClaireRegressionsRouteImport } from './routes/_admin/admin/claire-regressions'
import { Route as AdminAdminClaireFailureGroupsRouteImport } from './routes/_admin/admin/claire-failure-groups'
import { Route as AdminAdminAuditLogRouteImport } from './routes/_admin/admin/audit-log'
import { Route as AdminAdminAdvertisingRouteImport } from './routes/_admin/admin/advertising'
import { Route as AuthedDashboardWireframesIndexRouteImport } from './routes/_authed/dashboard/wireframes/index'
import { Route as AuthedDashboardSocialsIndexRouteImport } from './routes/_authed/dashboard/socials/index'
import { Route as AuthedDashboardSettingsIndexRouteImport } from './routes/_authed/dashboard/settings/index'
import { Route as AuthedDashboardServicesIndexRouteImport } from './routes/_authed/dashboard/services/index'
import { Route as AuthedDashboardMoreIndexRouteImport } from './routes/_authed/dashboard/more/index'
import { Route as AuthedDashboardDebugIndexRouteImport } from './routes/_authed/dashboard/debug/index'
import { Route as AuthedDashboardContentIndexRouteImport } from './routes/_authed/dashboard/content/index'
import { Route as AuthedDashboardAppointmentsIndexRouteImport } from './routes/_authed/dashboard/appointments/index'
import { Route as AuthedDashboardAdvertisingIndexRouteImport } from './routes/_authed/dashboard/advertising/index'
import { Route as AuthedCreateVideoTemplateIdIndexRouteImport } from './routes/_authed/create-video/$templateId/index'
import { Route as AuthedConnectMetaAdsIndexRouteImport } from './routes/_authed/connect/meta-ads/index'
import { Route as AuthedAdsNewIndexRouteImport } from './routes/_authed/ads/new/index'
import { Route as AuthedTeamRepeatingShiftsPractitionerIdRouteImport } from './routes/_authed/team/repeating-shifts.$practitionerId'
import { Route as AuthedSettingsClaireWhatsappRouteImport } from './routes/_authed/settings/claire/whatsapp'
import { Route as AuthedSettingsClaireUsageRouteImport } from './routes/_authed/settings/claire/usage'
import { Route as AuthedEditEntityIdRouteImport } from './routes/_authed/edit.$entity.$id'
import { Route as AuthedDashboardWireframesViewShellRouteImport } from './routes/_authed/dashboard/wireframes/view-shell'
import { Route as AuthedDashboardWireframesSkinAnalysisRouteImport } from './routes/_authed/dashboard/wireframes/skin-analysis'
import { Route as AuthedDashboardWireframesSettingsRouteImport } from './routes/_authed/dashboard/wireframes/settings'
import { Route as AuthedDashboardWireframesSequencesRouteImport } from './routes/_authed/dashboard/wireframes/sequences'
import { Route as AuthedDashboardWireframesSearchRouteImport } from './routes/_authed/dashboard/wireframes/search'
import { Route as AuthedDashboardWireframesReviewsRouteImport } from './routes/_authed/dashboard/wireframes/reviews'
import { Route as AuthedDashboardWireframesRetentionRouteImport } from './routes/_authed/dashboard/wireframes/retention'
import { Route as AuthedDashboardWireframesReportsRouteImport } from './routes/_authed/dashboard/wireframes/reports'
import { Route as AuthedDashboardWireframesRemindersSettingsRouteImport } from './routes/_authed/dashboard/wireframes/reminders-settings'
import { Route as AuthedDashboardWireframesPhotosRouteImport } from './routes/_authed/dashboard/wireframes/photos'
import { Route as AuthedDashboardWireframesDepositsRouteImport } from './routes/_authed/dashboard/wireframes/deposits'
import { Route as AuthedDashboardWireframesDataPrivacyRouteImport } from './routes/_authed/dashboard/wireframes/data-privacy'
import { Route as AuthedDashboardWireframesConsentComplianceRouteImport } from './routes/_authed/dashboard/wireframes/consent-compliance'
import { Route as AuthedDashboardWireframesCalendarWeekRouteImport } from './routes/_authed/dashboard/wireframes/calendar-week'
import { Route as AuthedDashboardWireframesCalendarSidePanelRouteImport } from './routes/_authed/dashboard/wireframes/calendar-side-panel'
import { Route as AuthedDashboardWireframesCalendarDayRouteImport } from './routes/_authed/dashboard/wireframes/calendar-day'
import { Route as AuthedDashboardSocialsScheduledRouteImport } from './routes/_authed/dashboard/socials/scheduled'
import { Route as AuthedDashboardSocialsReviewRouteImport } from './routes/_authed/dashboard/socials/review'
import { Route as AuthedDashboardSocialsRecentRouteImport } from './routes/_authed/dashboard/socials/recent'
import { Route as AuthedDashboardSocialsNewRouteImport } from './routes/_authed/dashboard/socials/new'
import { Route as AuthedDashboardSettingsStyleRouteImport } from './routes/_authed/dashboard/settings/style'
import { Route as AuthedDashboardSettingsSchedulingRouteImport } from './routes/_authed/dashboard/settings/scheduling'
import { Route as AuthedDashboardSettingsRemindersRouteImport } from './routes/_authed/dashboard/settings/reminders'
import { Route as AuthedDashboardSettingsPostTreatmentReviewsRouteImport } from './routes/_authed/dashboard/settings/post-treatment-reviews'
import { Route as AuthedDashboardSettingsPaymentsRouteImport } from './routes/_authed/dashboard/settings/payments'
import { Route as AuthedDashboardSettingsNotificationsRouteImport } from './routes/_authed/dashboard/settings/notifications'
import { Route as AuthedDashboardSettingsMessageTemplatesRouteImport } from './routes/_authed/dashboard/settings/message-templates'
import { Route as AuthedDashboardSettingsIntegrationsRouteImport } from './routes/_authed/dashboard/settings/integrations'
import { Route as AuthedDashboardSettingsFormTemplatesRouteImport } from './routes/_authed/dashboard/settings/form-templates'
import { Route as AuthedDashboardSettingsExamplesRouteImport } from './routes/_authed/dashboard/settings/examples'
import { Route as AuthedDashboardSettingsDetailsRouteImport } from './routes/_authed/dashboard/settings/details'
import { Route as AuthedDashboardSettingsDeleteAccountRouteImport } from './routes/_authed/dashboard/settings/delete-account'
import { Route as AuthedDashboardSettingsConsentPrivacyRouteImport } from './routes/_authed/dashboard/settings/consent-privacy'
import { Route as AuthedDashboardSettingsConsentFormsRouteImport } from './routes/_authed/dashboard/settings/consent-forms'
import { Route as AuthedDashboardSettingsClaireWhatsappRouteImport } from './routes/_authed/dashboard/settings/claire-whatsapp'
import { Route as AuthedDashboardSettingsClaireMemoriesRouteImport } from './routes/_authed/dashboard/settings/claire-memories'
import { Route as AuthedDashboardSettingsClaireCampaignsRouteImport } from './routes/_authed/dashboard/settings/claire-campaigns'
import { Route as AuthedDashboardSettingsChatbotRouteImport } from './routes/_authed/dashboard/settings/chatbot'
import { Route as AuthedDashboardSettingsCancellationsRouteImport } from './routes/_authed/dashboard/settings/cancellations'
import { Route as AuthedDashboardSettingsBookingsRouteImport } from './routes/_authed/dashboard/settings/bookings'
import { Route as AuthedDashboardSettingsBlockedTimeTypesRouteImport } from './routes/_authed/dashboard/settings/blocked-time-types'
import { Route as AuthedDashboardSettingsBillingRouteImport } from './routes/_authed/dashboard/settings/billing'
import { Route as AuthedDashboardServicesNewRouteImport } from './routes/_authed/dashboard/services/new'
import { Route as AuthedDashboardMoreSectionRouteImport } from './routes/_authed/dashboard/more/$section'
import { Route as AuthedDashboardLLocationIdRouteImport } from './routes/_authed/dashboard/l/$locationId'
import { Route as AuthedDashboardDebugAnalysisSplitTestRouteImport } from './routes/_authed/dashboard/debug/analysis-split-test'
import { Route as AuthedDashboardContentVideosRouteImport } from './routes/_authed/dashboard/content/videos'
import { Route as AuthedDashboardContentNewRouteImport } from './routes/_authed/dashboard/content/new'
import { Route as AuthedDashboardContentLibraryRouteImport } from './routes/_authed/dashboard/content/library'
import { Route as AuthedDashboardContentImagesRouteImport } from './routes/_authed/dashboard/content/images'
import { Route as AuthedDashboardContentGalleryRouteImport } from './routes/_authed/dashboard/content/gallery'
import { Route as AuthedDashboardAppointmentsYearRouteImport } from './routes/_authed/dashboard/appointments/year'
import { Route as AuthedDashboardAppointmentsWeekRouteImport } from './routes/_authed/dashboard/appointments/week'
import { Route as AuthedDashboardAppointmentsMonthRouteImport } from './routes/_authed/dashboard/appointments/month'
import { Route as AuthedDashboardAppointmentsDayRouteImport } from './routes/_authed/dashboard/appointments/day'
import { Route as AuthedDashboardAppointmentsAgendaRouteImport } from './routes/_authed/dashboard/appointments/agenda'
import { Route as AuthedDashboardAdvertisingNewRouteImport } from './routes/_authed/dashboard/advertising/new'
import { Route as AuthedAdsNewVideoFormatRouteImport } from './routes/_authed/ads/new/video-format'
import { Route as AdminAdminOrganizationsIdRouteImport } from './routes/_admin/admin/organizations/$id'
import { Route as AuthedDashboardSettingsFormTemplatesIndexRouteImport } from './routes/_authed/dashboard/settings/form-templates/index'
import { Route as AuthedDashboardAppointmentsNewIndexRouteImport } from './routes/_authed/dashboard/appointments/new/index'
import { Route as AuthedDashboardAdvertisingIdIndexRouteImport } from './routes/_authed/dashboard/advertising/$id/index'
import { Route as AuthedDashboardSocialsPostIdRouteImport } from './routes/_authed/dashboard/socials/post.$id'
import { Route as AuthedDashboardSettingsFormTemplatesFormIdRouteImport } from './routes/_authed/dashboard/settings/form-templates/$formId'
import { Route as AuthedDashboardServicesServiceIdEditRouteImport } from './routes/_authed/dashboard/services/$serviceId/edit'
import { Route as AuthedDashboardLLocationIdVenueRouteImport } from './routes/_authed/dashboard/l/$locationId/venue'
import { Route as AuthedDashboardLLocationIdSalesRouteImport } from './routes/_authed/dashboard/l/$locationId/sales'
import { Route as AuthedDashboardLLocationIdPublicSiteRouteImport } from './routes/_authed/dashboard/l/$locationId/public-site'
import { Route as AuthedDashboardLLocationIdMarketingRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing'
import { Route as AuthedDashboardLLocationIdHomeRouteImport } from './routes/_authed/dashboard/l/$locationId/home'
import { Route as AuthedDashboardLLocationIdDepositsRouteImport } from './routes/_authed/dashboard/l/$locationId/deposits'
import { Route as AuthedDashboardLLocationIdCustomersRouteImport } from './routes/_authed/dashboard/l/$locationId/customers'
import { Route as AuthedDashboardLLocationIdContentCalendarRouteImport } from './routes/_authed/dashboard/l/$locationId/content-calendar'
import { Route as AuthedDashboardLLocationIdClientsRouteImport } from './routes/_authed/dashboard/l/$locationId/clients'
import { Route as AuthedDashboardLLocationIdCalendarRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar'
import { Route as AuthedDashboardLLocationIdAiAssistantRouteImport } from './routes/_authed/dashboard/l/$locationId/ai-assistant'
import { Route as AuthedDashboardAppointmentsNewClientRouteImport } from './routes/_authed/dashboard/appointments/new/client'
import { Route as AuthedDashboardAppointmentsNewBlockRouteImport } from './routes/_authed/dashboard/appointments/new/block'
import { Route as AuthedDashboardLLocationIdVideosIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/videos/index'
import { Route as AuthedDashboardLLocationIdTeamIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/team/index'
import { Route as AuthedDashboardLLocationIdSalesIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/sales/index'
import { Route as AuthedDashboardLLocationIdMarketingIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/index'
import { Route as AuthedDashboardLLocationIdContentCalendarIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/content-calendar/index'
import { Route as AuthedDashboardLLocationIdClientsIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/clients/index'
import { Route as AuthedDashboardLLocationIdCatalogIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/index'
import { Route as AuthedDashboardLLocationIdCalendarIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/index'
import { Route as AuthedDashboardLLocationIdTeamTimesheetsRouteImport } from './routes/_authed/dashboard/l/$locationId/team/timesheets'
import { Route as AuthedDashboardLLocationIdTeamShiftsRouteImport } from './routes/_authed/dashboard/l/$locationId/team/shifts'
import { Route as AuthedDashboardLLocationIdTeamPractitionersRouteImport } from './routes/_authed/dashboard/l/$locationId/team/practitioners'
import { Route as AuthedDashboardLLocationIdTeamMembersRouteImport } from './routes/_authed/dashboard/l/$locationId/team/members'
import { Route as AuthedDashboardLLocationIdSalesProductOrdersRouteImport } from './routes/_authed/dashboard/l/$locationId/sales/product-orders'
import { Route as AuthedDashboardLLocationIdSalesPaymentsRouteImport } from './routes/_authed/dashboard/l/$locationId/sales/payments'
import { Route as AuthedDashboardLLocationIdSalesMembershipsRouteImport } from './routes/_authed/dashboard/l/$locationId/sales/memberships'
import { Route as AuthedDashboardLLocationIdSalesListRouteImport } from './routes/_authed/dashboard/l/$locationId/sales/list'
import { Route as AuthedDashboardLLocationIdSalesGiftCardsRouteImport } from './routes/_authed/dashboard/l/$locationId/sales/gift-cards'
import { Route as AuthedDashboardLLocationIdSalesDailySummaryRouteImport } from './routes/_authed/dashboard/l/$locationId/sales/daily-summary'
import { Route as AuthedDashboardLLocationIdSalesAppointmentsRouteImport } from './routes/_authed/dashboard/l/$locationId/sales/appointments'
import { Route as AuthedDashboardLLocationIdMarketingSocialsRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/socials'
import { Route as AuthedDashboardLLocationIdMarketingSequencesRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/sequences'
import { Route as AuthedDashboardLLocationIdMarketingLeadFormsRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/lead-forms'
import { Route as AuthedDashboardLLocationIdMarketingAdvertisingRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/advertising'
import { Route as AuthedDashboardLLocationIdInventorySuppliersRouteImport } from './routes/_authed/dashboard/l/$locationId/inventory/suppliers'
import { Route as AuthedDashboardLLocationIdInventoryStocktakesRouteImport } from './routes/_authed/dashboard/l/$locationId/inventory/stocktakes'
import { Route as AuthedDashboardLLocationIdInventoryStockOrdersRouteImport } from './routes/_authed/dashboard/l/$locationId/inventory/stock-orders'
import { Route as AuthedDashboardLLocationIdInventoryCategoriesRouteImport } from './routes/_authed/dashboard/l/$locationId/inventory/categories'
import { Route as AuthedDashboardLLocationIdInventoryBrandsRouteImport } from './routes/_authed/dashboard/l/$locationId/inventory/brands'
import { Route as AuthedDashboardLLocationIdCustomersLeadIdRouteImport } from './routes/_authed/dashboard/l/$locationId/customers.$leadId'
import { Route as AuthedDashboardLLocationIdContentCalendarWeekRouteImport } from './routes/_authed/dashboard/l/$locationId/content-calendar/week'
import { Route as AuthedDashboardLLocationIdContentCalendarThreeDayRouteImport } from './routes/_authed/dashboard/l/$locationId/content-calendar/three-day'
import { Route as AuthedDashboardLLocationIdContentCalendarMonthRouteImport } from './routes/_authed/dashboard/l/$locationId/content-calendar/month'
import { Route as AuthedDashboardLLocationIdContentCalendarDayRouteImport } from './routes/_authed/dashboard/l/$locationId/content-calendar/day'
import { Route as AuthedDashboardLLocationIdClientsListRouteImport } from './routes/_authed/dashboard/l/$locationId/clients/list'
import { Route as AuthedDashboardLLocationIdClientsInboxRouteImport } from './routes/_authed/dashboard/l/$locationId/clients/inbox'
import { Route as AuthedDashboardLLocationIdClientsLeadIdRouteImport } from './routes/_authed/dashboard/l/$locationId/clients/$leadId'
import { Route as AuthedDashboardLLocationIdCatalogSuppliersRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/suppliers'
import { Route as AuthedDashboardLLocationIdCatalogStocktakesRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/stocktakes'
import { Route as AuthedDashboardLLocationIdCatalogStockOrdersRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/stock-orders'
import { Route as AuthedDashboardLLocationIdCatalogServicesRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/services'
import { Route as AuthedDashboardLLocationIdCatalogResourcesRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/resources'
import { Route as AuthedDashboardLLocationIdCatalogProductsRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/products'
import { Route as AuthedDashboardLLocationIdCatalogPackagesRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/packages'
import { Route as AuthedDashboardLLocationIdCatalogOffersRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/offers'
import { Route as AuthedDashboardLLocationIdCatalogMembershipsRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/memberships'
import { Route as AuthedDashboardLLocationIdCatalogCategoriesRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/categories'
import { Route as AuthedDashboardLLocationIdCatalogBrandsRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/brands'
import { Route as AuthedDashboardLLocationIdCalendarYearRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/year'
import { Route as AuthedDashboardLLocationIdCalendarWeekRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/week'
import { Route as AuthedDashboardLLocationIdCalendarThreeDayRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/three-day'
import { Route as AuthedDashboardLLocationIdCalendarRoomsRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/rooms'
import { Route as AuthedDashboardLLocationIdCalendarMonthRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/month'
import { Route as AuthedDashboardLLocationIdCalendarDayRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/day'
import { Route as AuthedDashboardLLocationIdCalendarAgendaRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/agenda'
import { Route as AuthedDashboardAdvertisingIdAdsAdIdRouteImport } from './routes/_authed/dashboard/advertising/$id/ads/$adId'
import { Route as AuthedDashboardLLocationIdCalendarNewRouteRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/new/route'
import { Route as AuthedDashboardLLocationIdVideosCreateFromClientIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/videos/create-from-client/index'
import { Route as AuthedDashboardLLocationIdMarketingSocialsIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/socials/index'
import { Route as AuthedDashboardLLocationIdMarketingMusicIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/music/index'
import { Route as AuthedDashboardLLocationIdMarketingGalleryIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/gallery/index'
import { Route as AuthedDashboardLLocationIdMarketingCampaignsIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/campaigns/index'
import { Route as AuthedDashboardLLocationIdMarketingAdvertisingIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/advertising/index'
import { Route as AuthedDashboardLLocationIdCatalogServicesIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/catalog/services/index'
import { Route as AuthedDashboardLLocationIdCalendarRoomsIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/rooms/index'
import { Route as AuthedDashboardLLocationIdCalendarNewIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/new/index'
import { Route as AuthedDashboardLLocationIdMarketingSocialsScheduledRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/socials/scheduled'
import { Route as AuthedDashboardLLocationIdMarketingSocialsReviewRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/socials/review'
import { Route as AuthedDashboardLLocationIdMarketingSocialsRecentRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/socials/recent'
import { Route as AuthedDashboardLLocationIdMarketingGalleryVideosRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/gallery/videos'
import { Route as AuthedDashboardLLocationIdMarketingGalleryLibraryRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/gallery/library'
import { Route as AuthedDashboardLLocationIdMarketingGalleryImagesRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/gallery/images'
import { Route as AuthedDashboardLLocationIdMarketingAdvertisingNewRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/advertising/new'
import { Route as AuthedDashboardLLocationIdCustomersLeadIdFormRouteImport } from './routes/_authed/dashboard/l/$locationId/customers.$leadId.form'
import { Route as AuthedDashboardLLocationIdCalendarRoomsWeekRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/rooms/week'
import { Route as AuthedDashboardLLocationIdCalendarRoomsThreeDayRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/rooms/three-day'
import { Route as AuthedDashboardLLocationIdCalendarRoomsMonthRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/rooms/month'
import { Route as AuthedDashboardLLocationIdCalendarRoomsDayRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/rooms/day'
import { Route as AuthedDashboardLLocationIdCalendarNewClientRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/new/client'
import { Route as AuthedDashboardLLocationIdCalendarNewBlockRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/new/block'
import { Route as AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRouteImport } from './routes/_authed/dashboard/l/$locationId/calendar/appointment.$appointmentId'
import { Route as AuthedDashboardLLocationIdMarketingSocialsNewIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/socials/new/index'
import { Route as AuthedDashboardLLocationIdMarketingGalleryNewIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/gallery/new/index'
import { Route as AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/campaigns/segments/index'
import { Route as AuthedDashboardLLocationIdMarketingCampaignsNewIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/campaigns/new/index'
import { Route as AuthedDashboardLLocationIdMarketingCampaignsIdIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/campaigns/$id/index'
import { Route as AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/advertising/$id/index'
import { Route as AuthedDashboardLLocationIdMarketingSocialsPostIdRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/socials/post.$id'
import { Route as AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/campaigns/segments/new/index'
import { Route as AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRouteImport } from './routes/_authed/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const Verify2faRoute = Verify2faRouteImport.update({
  id: '/verify-2fa',
  path: '/verify-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const RestoreOrganizationRoute = RestoreOrganizationRouteImport.update({
  id: '/restore-organization',
  path: '/restore-organization',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CreativeLabPanelRoute = CreativeLabPanelRouteImport.update({
  id: '/creative-lab-panel',
  path: '/creative-lab-panel',
  getParentRoute: () => rootRouteImport,
} as any)
const CreativeLabCardRoute = CreativeLabCardRouteImport.update({
  id: '/creative-lab-card',
  path: '/creative-lab-card',
  getParentRoute: () => rootRouteImport,
} as any)
const CreativeLabRoute = CreativeLabRouteImport.update({
  id: '/creative-lab',
  path: '/creative-lab',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeIndexRoute = WelcomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WelcomeRoute,
} as any)
const StartTokenRoute = StartTokenRouteImport.update({
  id: '/start/$token',
  path: '/start/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectWhatsappRoute = ConnectWhatsappRouteImport.update({
  id: '/connect/whatsapp',
  path: '/connect/whatsapp',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectFacebookRoute = ConnectFacebookRouteImport.update({
  id: '/connect/facebook',
  path: '/connect/facebook',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingUploadAssetsRoute = OnboardingUploadAssetsRouteImport.update({
  id: '/upload-assets',
  path: '/upload-assets',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingSetupProfileRoute = OnboardingSetupProfileRouteImport.update({
  id: '/setup-profile',
  path: '/setup-profile',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingOnboardingRoute = OnboardingOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => OnboardingRoute,
} as any)
const AuthedWireframeFullscreenRoute =
  AuthedWireframeFullscreenRouteImport.update({
    id: '/wireframe-fullscreen',
    path: '/wireframe-fullscreen',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedWebsitePreviewRoute = AuthedWebsitePreviewRouteImport.update({
  id: '/website-preview',
  path: '/website-preview',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReviewContentRoute = AuthedReviewContentRouteImport.update({
  id: '/review-content',
  path: '/review-content',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBillingRoute = AuthedBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAssistantRoute = AuthedAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => AuthedRoute,
} as any)
const AdminAdminRoute = AdminAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AdminRoute,
} as any)
const VenueOrganizationSlugIndexRoute =
  VenueOrganizationSlugIndexRouteImport.update({
    id: '/venue/$organizationSlug/',
    path: '/venue/$organizationSlug/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OptInOrganizationSlugIndexRoute =
  OptInOrganizationSlugIndexRouteImport.update({
    id: '/opt-in/$organizationSlug/',
    path: '/opt-in/$organizationSlug/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedRecordIndexRoute = AuthedRecordIndexRouteImport.update({
  id: '/record/',
  path: '/record/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardIndexRoute = AuthedDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedCreateVideoIndexRoute = AuthedCreateVideoIndexRouteImport.update({
  id: '/create-video/',
  path: '/create-video/',
  getParentRoute: () => AuthedRoute,
} as any)
const AdminAdminIndexRoute = AdminAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAdminRoute,
} as any)
const VenueOrganizationSlugLocationSlugRoute =
  VenueOrganizationSlugLocationSlugRouteImport.update({
    id: '/venue/$organizationSlug/$locationSlug',
    path: '/venue/$organizationSlug/$locationSlug',
    getParentRoute: () => rootRouteImport,
  } as any)
const FormsOrganizationSlugTokenRoute =
  FormsOrganizationSlugTokenRouteImport.update({
    id: '/forms/$organizationSlug/$token',
    path: '/forms/$organizationSlug/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConnectStripeDoneRoute = ConnectStripeDoneRouteImport.update({
  id: '/connect/stripe/done',
  path: '/connect/stripe/done',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedWireframeFullscreenScribeRoute =
  AuthedWireframeFullscreenScribeRouteImport.update({
    id: '/scribe',
    path: '/scribe',
    getParentRoute: () => AuthedWireframeFullscreenRoute,
  } as any)
const AuthedWireframeFullscreenConsentKioskRoute =
  AuthedWireframeFullscreenConsentKioskRouteImport.update({
    id: '/consent-kiosk',
    path: '/consent-kiosk',
    getParentRoute: () => AuthedWireframeFullscreenRoute,
  } as any)
const AuthedWireframeFullscreenCompareRoute =
  AuthedWireframeFullscreenCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => AuthedWireframeFullscreenRoute,
  } as any)
const AuthedWireframeFullscreenAnnotateRoute =
  AuthedWireframeFullscreenAnnotateRouteImport.update({
    id: '/annotate',
    path: '/annotate',
    getParentRoute: () => AuthedWireframeFullscreenRoute,
  } as any)
const AuthedSettingsClaireRoute = AuthedSettingsClaireRouteImport.update({
  id: '/settings/claire',
  path: '/settings/claire',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecordVideoIdRoute = AuthedRecordVideoIdRouteImport.update({
  id: '/record/$videoId',
  path: '/record/$videoId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardWireframesRoute =
  AuthedDashboardWireframesRouteImport.update({
    id: '/wireframes',
    path: '/wireframes',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardWebsiteRoute = AuthedDashboardWebsiteRouteImport.update({
  id: '/website',
  path: '/website',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardVoiceTestRoute =
  AuthedDashboardVoiceTestRouteImport.update({
    id: '/voice-test',
    path: '/voice-test',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardTrainingHubRoute =
  AuthedDashboardTrainingHubRouteImport.update({
    id: '/training-hub',
    path: '/training-hub',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardTemplatePreviewRoute =
  AuthedDashboardTemplatePreviewRouteImport.update({
    id: '/template-preview',
    path: '/template-preview',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardSettingsRoute = AuthedDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardReviewsRoute = AuthedDashboardReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardRetentionRoute =
  AuthedDashboardRetentionRouteImport.update({
    id: '/retention',
    path: '/retention',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardResetRoute = AuthedDashboardResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardReportsRoute = AuthedDashboardReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardOrganisationRoute =
  AuthedDashboardOrganisationRouteImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardOffersRoute = AuthedDashboardOffersRouteImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardNotificationsRoute =
  AuthedDashboardNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardLocationsRoute =
  AuthedDashboardLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardLeadManagementRoute =
  AuthedDashboardLeadManagementRouteImport.update({
    id: '/lead-management',
    path: '/lead-management',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardLeadFormsRoute =
  AuthedDashboardLeadFormsRouteImport.update({
    id: '/lead-forms',
    path: '/lead-forms',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardIntegrationsRoute =
  AuthedDashboardIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardIntakeFormsRoute =
  AuthedDashboardIntakeFormsRouteImport.update({
    id: '/intake-forms',
    path: '/intake-forms',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardConversationsRoute =
  AuthedDashboardConversationsRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardChatbotsRoute = AuthedDashboardChatbotsRouteImport.update({
  id: '/chatbots',
  path: '/chatbots',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardBrandRoute = AuthedDashboardBrandRouteImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardAccountRoute = AuthedDashboardAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardSplatRoute = AuthedDashboardSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedCreateEntityRoute = AuthedCreateEntityRouteImport.update({
  id: '/create/$entity',
  path: '/create/$entity',
  getParentRoute: () => AuthedRoute,
} as any)
const AdminAdminStuckSetupRoute = AdminAdminStuckSetupRouteImport.update({
  id: '/stuck-setup',
  path: '/stuck-setup',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminStockFootageRoute = AdminAdminStockFootageRouteImport.update({
  id: '/stock-footage',
  path: '/stock-footage',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminScrapingRoute = AdminAdminScrapingRouteImport.update({
  id: '/scraping',
  path: '/scraping',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminMusicRoute = AdminAdminMusicRouteImport.update({
  id: '/music',
  path: '/music',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminMetaConnectionsRoute =
  AdminAdminMetaConnectionsRouteImport.update({
    id: '/meta-connections',
    path: '/meta-connections',
    getParentRoute: () => AdminAdminRoute,
  } as any)
const AdminAdminImportsRoute = AdminAdminImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminHarnessRoute = AdminAdminHarnessRouteImport.update({
  id: '/harness',
  path: '/harness',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminCrmTriggersRoute = AdminAdminCrmTriggersRouteImport.update({
  id: '/crm-triggers',
  path: '/crm-triggers',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminConversationsRoute = AdminAdminConversationsRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminClaireRegressionsRoute =
  AdminAdminClaireRegressionsRouteImport.update({
    id: '/claire-regressions',
    path: '/claire-regressions',
    getParentRoute: () => AdminAdminRoute,
  } as any)
const AdminAdminClaireFailureGroupsRoute =
  AdminAdminClaireFailureGroupsRouteImport.update({
    id: '/claire-failure-groups',
    path: '/claire-failure-groups',
    getParentRoute: () => AdminAdminRoute,
  } as any)
const AdminAdminAuditLogRoute = AdminAdminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AdminAdminAdvertisingRoute = AdminAdminAdvertisingRouteImport.update({
  id: '/advertising',
  path: '/advertising',
  getParentRoute: () => AdminAdminRoute,
} as any)
const AuthedDashboardWireframesIndexRoute =
  AuthedDashboardWireframesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardSocialsIndexRoute =
  AuthedDashboardSocialsIndexRouteImport.update({
    id: '/socials/',
    path: '/socials/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardSettingsIndexRoute =
  AuthedDashboardSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardServicesIndexRoute =
  AuthedDashboardServicesIndexRouteImport.update({
    id: '/services/',
    path: '/services/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardMoreIndexRoute =
  AuthedDashboardMoreIndexRouteImport.update({
    id: '/more/',
    path: '/more/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardDebugIndexRoute =
  AuthedDashboardDebugIndexRouteImport.update({
    id: '/debug/',
    path: '/debug/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardContentIndexRoute =
  AuthedDashboardContentIndexRouteImport.update({
    id: '/content/',
    path: '/content/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAppointmentsIndexRoute =
  AuthedDashboardAppointmentsIndexRouteImport.update({
    id: '/appointments/',
    path: '/appointments/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdvertisingIndexRoute =
  AuthedDashboardAdvertisingIndexRouteImport.update({
    id: '/advertising/',
    path: '/advertising/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedCreateVideoTemplateIdIndexRoute =
  AuthedCreateVideoTemplateIdIndexRouteImport.update({
    id: '/create-video/$templateId/',
    path: '/create-video/$templateId/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedConnectMetaAdsIndexRoute =
  AuthedConnectMetaAdsIndexRouteImport.update({
    id: '/connect/meta-ads/',
    path: '/connect/meta-ads/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAdsNewIndexRoute = AuthedAdsNewIndexRouteImport.update({
  id: '/ads/new/',
  path: '/ads/new/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamRepeatingShiftsPractitionerIdRoute =
  AuthedTeamRepeatingShiftsPractitionerIdRouteImport.update({
    id: '/team/repeating-shifts/$practitionerId',
    path: '/team/repeating-shifts/$practitionerId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsClaireWhatsappRoute =
  AuthedSettingsClaireWhatsappRouteImport.update({
    id: '/whatsapp',
    path: '/whatsapp',
    getParentRoute: () => AuthedSettingsClaireRoute,
  } as any)
const AuthedSettingsClaireUsageRoute =
  AuthedSettingsClaireUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthedSettingsClaireRoute,
  } as any)
const AuthedEditEntityIdRoute = AuthedEditEntityIdRouteImport.update({
  id: '/edit/$entity/$id',
  path: '/edit/$entity/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardWireframesViewShellRoute =
  AuthedDashboardWireframesViewShellRouteImport.update({
    id: '/view-shell',
    path: '/view-shell',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesSkinAnalysisRoute =
  AuthedDashboardWireframesSkinAnalysisRouteImport.update({
    id: '/skin-analysis',
    path: '/skin-analysis',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesSettingsRoute =
  AuthedDashboardWireframesSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesSequencesRoute =
  AuthedDashboardWireframesSequencesRouteImport.update({
    id: '/sequences',
    path: '/sequences',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesSearchRoute =
  AuthedDashboardWireframesSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesReviewsRoute =
  AuthedDashboardWireframesReviewsRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesRetentionRoute =
  AuthedDashboardWireframesRetentionRouteImport.update({
    id: '/retention',
    path: '/retention',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesReportsRoute =
  AuthedDashboardWireframesReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesRemindersSettingsRoute =
  AuthedDashboardWireframesRemindersSettingsRouteImport.update({
    id: '/reminders-settings',
    path: '/reminders-settings',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesPhotosRoute =
  AuthedDashboardWireframesPhotosRouteImport.update({
    id: '/photos',
    path: '/photos',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesDepositsRoute =
  AuthedDashboardWireframesDepositsRouteImport.update({
    id: '/deposits',
    path: '/deposits',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesDataPrivacyRoute =
  AuthedDashboardWireframesDataPrivacyRouteImport.update({
    id: '/data-privacy',
    path: '/data-privacy',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesConsentComplianceRoute =
  AuthedDashboardWireframesConsentComplianceRouteImport.update({
    id: '/consent-compliance',
    path: '/consent-compliance',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesCalendarWeekRoute =
  AuthedDashboardWireframesCalendarWeekRouteImport.update({
    id: '/calendar-week',
    path: '/calendar-week',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesCalendarSidePanelRoute =
  AuthedDashboardWireframesCalendarSidePanelRouteImport.update({
    id: '/calendar-side-panel',
    path: '/calendar-side-panel',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardWireframesCalendarDayRoute =
  AuthedDashboardWireframesCalendarDayRouteImport.update({
    id: '/calendar-day',
    path: '/calendar-day',
    getParentRoute: () => AuthedDashboardWireframesRoute,
  } as any)
const AuthedDashboardSocialsScheduledRoute =
  AuthedDashboardSocialsScheduledRouteImport.update({
    id: '/socials/scheduled',
    path: '/socials/scheduled',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardSocialsReviewRoute =
  AuthedDashboardSocialsReviewRouteImport.update({
    id: '/socials/review',
    path: '/socials/review',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardSocialsRecentRoute =
  AuthedDashboardSocialsRecentRouteImport.update({
    id: '/socials/recent',
    path: '/socials/recent',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardSocialsNewRoute =
  AuthedDashboardSocialsNewRouteImport.update({
    id: '/socials/new',
    path: '/socials/new',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardSettingsStyleRoute =
  AuthedDashboardSettingsStyleRouteImport.update({
    id: '/style',
    path: '/style',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsSchedulingRoute =
  AuthedDashboardSettingsSchedulingRouteImport.update({
    id: '/scheduling',
    path: '/scheduling',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsRemindersRoute =
  AuthedDashboardSettingsRemindersRouteImport.update({
    id: '/reminders',
    path: '/reminders',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsPostTreatmentReviewsRoute =
  AuthedDashboardSettingsPostTreatmentReviewsRouteImport.update({
    id: '/post-treatment-reviews',
    path: '/post-treatment-reviews',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsPaymentsRoute =
  AuthedDashboardSettingsPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsNotificationsRoute =
  AuthedDashboardSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsMessageTemplatesRoute =
  AuthedDashboardSettingsMessageTemplatesRouteImport.update({
    id: '/message-templates',
    path: '/message-templates',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsIntegrationsRoute =
  AuthedDashboardSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsFormTemplatesRoute =
  AuthedDashboardSettingsFormTemplatesRouteImport.update({
    id: '/form-templates',
    path: '/form-templates',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsExamplesRoute =
  AuthedDashboardSettingsExamplesRouteImport.update({
    id: '/examples',
    path: '/examples',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsDetailsRoute =
  AuthedDashboardSettingsDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsDeleteAccountRoute =
  AuthedDashboardSettingsDeleteAccountRouteImport.update({
    id: '/delete-account',
    path: '/delete-account',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsConsentPrivacyRoute =
  AuthedDashboardSettingsConsentPrivacyRouteImport.update({
    id: '/consent-privacy',
    path: '/consent-privacy',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsConsentFormsRoute =
  AuthedDashboardSettingsConsentFormsRouteImport.update({
    id: '/consent-forms',
    path: '/consent-forms',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsClaireWhatsappRoute =
  AuthedDashboardSettingsClaireWhatsappRouteImport.update({
    id: '/claire-whatsapp',
    path: '/claire-whatsapp',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsClaireMemoriesRoute =
  AuthedDashboardSettingsClaireMemoriesRouteImport.update({
    id: '/claire-memories',
    path: '/claire-memories',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsClaireCampaignsRoute =
  AuthedDashboardSettingsClaireCampaignsRouteImport.update({
    id: '/claire-campaigns',
    path: '/claire-campaigns',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsChatbotRoute =
  AuthedDashboardSettingsChatbotRouteImport.update({
    id: '/chatbot',
    path: '/chatbot',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsCancellationsRoute =
  AuthedDashboardSettingsCancellationsRouteImport.update({
    id: '/cancellations',
    path: '/cancellations',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsBookingsRoute =
  AuthedDashboardSettingsBookingsRouteImport.update({
    id: '/bookings',
    path: '/bookings',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsBlockedTimeTypesRoute =
  AuthedDashboardSettingsBlockedTimeTypesRouteImport.update({
    id: '/blocked-time-types',
    path: '/blocked-time-types',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardSettingsBillingRoute =
  AuthedDashboardSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthedDashboardSettingsRoute,
  } as any)
const AuthedDashboardServicesNewRoute =
  AuthedDashboardServicesNewRouteImport.update({
    id: '/services/new',
    path: '/services/new',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardMoreSectionRoute =
  AuthedDashboardMoreSectionRouteImport.update({
    id: '/more/$section',
    path: '/more/$section',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardLLocationIdRoute =
  AuthedDashboardLLocationIdRouteImport.update({
    id: '/l/$locationId',
    path: '/l/$locationId',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardDebugAnalysisSplitTestRoute =
  AuthedDashboardDebugAnalysisSplitTestRouteImport.update({
    id: '/debug/analysis-split-test',
    path: '/debug/analysis-split-test',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardContentVideosRoute =
  AuthedDashboardContentVideosRouteImport.update({
    id: '/content/videos',
    path: '/content/videos',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardContentNewRoute =
  AuthedDashboardContentNewRouteImport.update({
    id: '/content/new',
    path: '/content/new',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardContentLibraryRoute =
  AuthedDashboardContentLibraryRouteImport.update({
    id: '/content/library',
    path: '/content/library',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardContentImagesRoute =
  AuthedDashboardContentImagesRouteImport.update({
    id: '/content/images',
    path: '/content/images',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardContentGalleryRoute =
  AuthedDashboardContentGalleryRouteImport.update({
    id: '/content/gallery',
    path: '/content/gallery',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAppointmentsYearRoute =
  AuthedDashboardAppointmentsYearRouteImport.update({
    id: '/appointments/year',
    path: '/appointments/year',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAppointmentsWeekRoute =
  AuthedDashboardAppointmentsWeekRouteImport.update({
    id: '/appointments/week',
    path: '/appointments/week',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAppointmentsMonthRoute =
  AuthedDashboardAppointmentsMonthRouteImport.update({
    id: '/appointments/month',
    path: '/appointments/month',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAppointmentsDayRoute =
  AuthedDashboardAppointmentsDayRouteImport.update({
    id: '/appointments/day',
    path: '/appointments/day',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAppointmentsAgendaRoute =
  AuthedDashboardAppointmentsAgendaRouteImport.update({
    id: '/appointments/agenda',
    path: '/appointments/agenda',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdvertisingNewRoute =
  AuthedDashboardAdvertisingNewRouteImport.update({
    id: '/advertising/new',
    path: '/advertising/new',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedAdsNewVideoFormatRoute = AuthedAdsNewVideoFormatRouteImport.update({
  id: '/ads/new/video-format',
  path: '/ads/new/video-format',
  getParentRoute: () => AuthedRoute,
} as any)
const AdminAdminOrganizationsIdRoute =
  AdminAdminOrganizationsIdRouteImport.update({
    id: '/organizations/$id',
    path: '/organizations/$id',
    getParentRoute: () => AdminAdminRoute,
  } as any)
const AuthedDashboardSettingsFormTemplatesIndexRoute =
  AuthedDashboardSettingsFormTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardSettingsFormTemplatesRoute,
  } as any)
const AuthedDashboardAppointmentsNewIndexRoute =
  AuthedDashboardAppointmentsNewIndexRouteImport.update({
    id: '/appointments/new/',
    path: '/appointments/new/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdvertisingIdIndexRoute =
  AuthedDashboardAdvertisingIdIndexRouteImport.update({
    id: '/advertising/$id/',
    path: '/advertising/$id/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardSocialsPostIdRoute =
  AuthedDashboardSocialsPostIdRouteImport.update({
    id: '/socials/post/$id',
    path: '/socials/post/$id',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardSettingsFormTemplatesFormIdRoute =
  AuthedDashboardSettingsFormTemplatesFormIdRouteImport.update({
    id: '/$formId',
    path: '/$formId',
    getParentRoute: () => AuthedDashboardSettingsFormTemplatesRoute,
  } as any)
const AuthedDashboardServicesServiceIdEditRoute =
  AuthedDashboardServicesServiceIdEditRouteImport.update({
    id: '/services/$serviceId/edit',
    path: '/services/$serviceId/edit',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardLLocationIdVenueRoute =
  AuthedDashboardLLocationIdVenueRouteImport.update({
    id: '/venue',
    path: '/venue',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdSalesRoute =
  AuthedDashboardLLocationIdSalesRouteImport.update({
    id: '/sales',
    path: '/sales',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdPublicSiteRoute =
  AuthedDashboardLLocationIdPublicSiteRouteImport.update({
    id: '/public-site',
    path: '/public-site',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingRoute =
  AuthedDashboardLLocationIdMarketingRouteImport.update({
    id: '/marketing',
    path: '/marketing',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdHomeRoute =
  AuthedDashboardLLocationIdHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdDepositsRoute =
  AuthedDashboardLLocationIdDepositsRouteImport.update({
    id: '/deposits',
    path: '/deposits',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCustomersRoute =
  AuthedDashboardLLocationIdCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdContentCalendarRoute =
  AuthedDashboardLLocationIdContentCalendarRouteImport.update({
    id: '/content-calendar',
    path: '/content-calendar',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdClientsRoute =
  AuthedDashboardLLocationIdClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarRoute =
  AuthedDashboardLLocationIdCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdAiAssistantRoute =
  AuthedDashboardLLocationIdAiAssistantRouteImport.update({
    id: '/ai-assistant',
    path: '/ai-assistant',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardAppointmentsNewClientRoute =
  AuthedDashboardAppointmentsNewClientRouteImport.update({
    id: '/appointments/new/client',
    path: '/appointments/new/client',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAppointmentsNewBlockRoute =
  AuthedDashboardAppointmentsNewBlockRouteImport.update({
    id: '/appointments/new/block',
    path: '/appointments/new/block',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardLLocationIdVideosIndexRoute =
  AuthedDashboardLLocationIdVideosIndexRouteImport.update({
    id: '/videos/',
    path: '/videos/',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdTeamIndexRoute =
  AuthedDashboardLLocationIdTeamIndexRouteImport.update({
    id: '/team/',
    path: '/team/',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdSalesIndexRoute =
  AuthedDashboardLLocationIdSalesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdSalesRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingIndexRoute =
  AuthedDashboardLLocationIdMarketingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdContentCalendarIndexRoute =
  AuthedDashboardLLocationIdContentCalendarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdContentCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdClientsIndexRoute =
  AuthedDashboardLLocationIdClientsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdClientsRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogIndexRoute =
  AuthedDashboardLLocationIdCatalogIndexRouteImport.update({
    id: '/catalog/',
    path: '/catalog/',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarIndexRoute =
  AuthedDashboardLLocationIdCalendarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdTeamTimesheetsRoute =
  AuthedDashboardLLocationIdTeamTimesheetsRouteImport.update({
    id: '/team/timesheets',
    path: '/team/timesheets',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdTeamShiftsRoute =
  AuthedDashboardLLocationIdTeamShiftsRouteImport.update({
    id: '/team/shifts',
    path: '/team/shifts',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdTeamPractitionersRoute =
  AuthedDashboardLLocationIdTeamPractitionersRouteImport.update({
    id: '/team/practitioners',
    path: '/team/practitioners',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdTeamMembersRoute =
  AuthedDashboardLLocationIdTeamMembersRouteImport.update({
    id: '/team/members',
    path: '/team/members',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdSalesProductOrdersRoute =
  AuthedDashboardLLocationIdSalesProductOrdersRouteImport.update({
    id: '/product-orders',
    path: '/product-orders',
    getParentRoute: () => AuthedDashboardLLocationIdSalesRoute,
  } as any)
const AuthedDashboardLLocationIdSalesPaymentsRoute =
  AuthedDashboardLLocationIdSalesPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthedDashboardLLocationIdSalesRoute,
  } as any)
const AuthedDashboardLLocationIdSalesMembershipsRoute =
  AuthedDashboardLLocationIdSalesMembershipsRouteImport.update({
    id: '/memberships',
    path: '/memberships',
    getParentRoute: () => AuthedDashboardLLocationIdSalesRoute,
  } as any)
const AuthedDashboardLLocationIdSalesListRoute =
  AuthedDashboardLLocationIdSalesListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => AuthedDashboardLLocationIdSalesRoute,
  } as any)
const AuthedDashboardLLocationIdSalesGiftCardsRoute =
  AuthedDashboardLLocationIdSalesGiftCardsRouteImport.update({
    id: '/gift-cards',
    path: '/gift-cards',
    getParentRoute: () => AuthedDashboardLLocationIdSalesRoute,
  } as any)
const AuthedDashboardLLocationIdSalesDailySummaryRoute =
  AuthedDashboardLLocationIdSalesDailySummaryRouteImport.update({
    id: '/daily-summary',
    path: '/daily-summary',
    getParentRoute: () => AuthedDashboardLLocationIdSalesRoute,
  } as any)
const AuthedDashboardLLocationIdSalesAppointmentsRoute =
  AuthedDashboardLLocationIdSalesAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthedDashboardLLocationIdSalesRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingSocialsRoute =
  AuthedDashboardLLocationIdMarketingSocialsRouteImport.update({
    id: '/socials',
    path: '/socials',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingSequencesRoute =
  AuthedDashboardLLocationIdMarketingSequencesRouteImport.update({
    id: '/sequences',
    path: '/sequences',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingLeadFormsRoute =
  AuthedDashboardLLocationIdMarketingLeadFormsRouteImport.update({
    id: '/lead-forms',
    path: '/lead-forms',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingAdvertisingRoute =
  AuthedDashboardLLocationIdMarketingAdvertisingRouteImport.update({
    id: '/advertising',
    path: '/advertising',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdInventorySuppliersRoute =
  AuthedDashboardLLocationIdInventorySuppliersRouteImport.update({
    id: '/inventory/suppliers',
    path: '/inventory/suppliers',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdInventoryStocktakesRoute =
  AuthedDashboardLLocationIdInventoryStocktakesRouteImport.update({
    id: '/inventory/stocktakes',
    path: '/inventory/stocktakes',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdInventoryStockOrdersRoute =
  AuthedDashboardLLocationIdInventoryStockOrdersRouteImport.update({
    id: '/inventory/stock-orders',
    path: '/inventory/stock-orders',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdInventoryCategoriesRoute =
  AuthedDashboardLLocationIdInventoryCategoriesRouteImport.update({
    id: '/inventory/categories',
    path: '/inventory/categories',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdInventoryBrandsRoute =
  AuthedDashboardLLocationIdInventoryBrandsRouteImport.update({
    id: '/inventory/brands',
    path: '/inventory/brands',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCustomersLeadIdRoute =
  AuthedDashboardLLocationIdCustomersLeadIdRouteImport.update({
    id: '/$leadId',
    path: '/$leadId',
    getParentRoute: () => AuthedDashboardLLocationIdCustomersRoute,
  } as any)
const AuthedDashboardLLocationIdContentCalendarWeekRoute =
  AuthedDashboardLLocationIdContentCalendarWeekRouteImport.update({
    id: '/week',
    path: '/week',
    getParentRoute: () => AuthedDashboardLLocationIdContentCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdContentCalendarThreeDayRoute =
  AuthedDashboardLLocationIdContentCalendarThreeDayRouteImport.update({
    id: '/three-day',
    path: '/three-day',
    getParentRoute: () => AuthedDashboardLLocationIdContentCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdContentCalendarMonthRoute =
  AuthedDashboardLLocationIdContentCalendarMonthRouteImport.update({
    id: '/month',
    path: '/month',
    getParentRoute: () => AuthedDashboardLLocationIdContentCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdContentCalendarDayRoute =
  AuthedDashboardLLocationIdContentCalendarDayRouteImport.update({
    id: '/day',
    path: '/day',
    getParentRoute: () => AuthedDashboardLLocationIdContentCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdClientsListRoute =
  AuthedDashboardLLocationIdClientsListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => AuthedDashboardLLocationIdClientsRoute,
  } as any)
const AuthedDashboardLLocationIdClientsInboxRoute =
  AuthedDashboardLLocationIdClientsInboxRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => AuthedDashboardLLocationIdClientsRoute,
  } as any)
const AuthedDashboardLLocationIdClientsLeadIdRoute =
  AuthedDashboardLLocationIdClientsLeadIdRouteImport.update({
    id: '/$leadId',
    path: '/$leadId',
    getParentRoute: () => AuthedDashboardLLocationIdClientsRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogSuppliersRoute =
  AuthedDashboardLLocationIdCatalogSuppliersRouteImport.update({
    id: '/catalog/suppliers',
    path: '/catalog/suppliers',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogStocktakesRoute =
  AuthedDashboardLLocationIdCatalogStocktakesRouteImport.update({
    id: '/catalog/stocktakes',
    path: '/catalog/stocktakes',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogStockOrdersRoute =
  AuthedDashboardLLocationIdCatalogStockOrdersRouteImport.update({
    id: '/catalog/stock-orders',
    path: '/catalog/stock-orders',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogServicesRoute =
  AuthedDashboardLLocationIdCatalogServicesRouteImport.update({
    id: '/catalog/services',
    path: '/catalog/services',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogResourcesRoute =
  AuthedDashboardLLocationIdCatalogResourcesRouteImport.update({
    id: '/catalog/resources',
    path: '/catalog/resources',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogProductsRoute =
  AuthedDashboardLLocationIdCatalogProductsRouteImport.update({
    id: '/catalog/products',
    path: '/catalog/products',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogPackagesRoute =
  AuthedDashboardLLocationIdCatalogPackagesRouteImport.update({
    id: '/catalog/packages',
    path: '/catalog/packages',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogOffersRoute =
  AuthedDashboardLLocationIdCatalogOffersRouteImport.update({
    id: '/catalog/offers',
    path: '/catalog/offers',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogMembershipsRoute =
  AuthedDashboardLLocationIdCatalogMembershipsRouteImport.update({
    id: '/catalog/memberships',
    path: '/catalog/memberships',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogCategoriesRoute =
  AuthedDashboardLLocationIdCatalogCategoriesRouteImport.update({
    id: '/catalog/categories',
    path: '/catalog/categories',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogBrandsRoute =
  AuthedDashboardLLocationIdCatalogBrandsRouteImport.update({
    id: '/catalog/brands',
    path: '/catalog/brands',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarYearRoute =
  AuthedDashboardLLocationIdCalendarYearRouteImport.update({
    id: '/year',
    path: '/year',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarWeekRoute =
  AuthedDashboardLLocationIdCalendarWeekRouteImport.update({
    id: '/week',
    path: '/week',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarThreeDayRoute =
  AuthedDashboardLLocationIdCalendarThreeDayRouteImport.update({
    id: '/three-day',
    path: '/three-day',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarRoomsRoute =
  AuthedDashboardLLocationIdCalendarRoomsRouteImport.update({
    id: '/rooms',
    path: '/rooms',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarMonthRoute =
  AuthedDashboardLLocationIdCalendarMonthRouteImport.update({
    id: '/month',
    path: '/month',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarDayRoute =
  AuthedDashboardLLocationIdCalendarDayRouteImport.update({
    id: '/day',
    path: '/day',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarAgendaRoute =
  AuthedDashboardLLocationIdCalendarAgendaRouteImport.update({
    id: '/agenda',
    path: '/agenda',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardAdvertisingIdAdsAdIdRoute =
  AuthedDashboardAdvertisingIdAdsAdIdRouteImport.update({
    id: '/advertising/$id/ads/$adId',
    path: '/advertising/$id/ads/$adId',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarNewRouteRoute =
  AuthedDashboardLLocationIdCalendarNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdVideosCreateFromClientIndexRoute =
  AuthedDashboardLLocationIdVideosCreateFromClientIndexRouteImport.update({
    id: '/videos/create-from-client/',
    path: '/videos/create-from-client/',
    getParentRoute: () => AuthedDashboardLLocationIdRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingSocialsIndexRoute =
  AuthedDashboardLLocationIdMarketingSocialsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingSocialsRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingMusicIndexRoute =
  AuthedDashboardLLocationIdMarketingMusicIndexRouteImport.update({
    id: '/music/',
    path: '/music/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingGalleryIndexRoute =
  AuthedDashboardLLocationIdMarketingGalleryIndexRouteImport.update({
    id: '/gallery/',
    path: '/gallery/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingCampaignsIndexRoute =
  AuthedDashboardLLocationIdMarketingCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingAdvertisingIndexRoute =
  AuthedDashboardLLocationIdMarketingAdvertisingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingAdvertisingRoute,
  } as any)
const AuthedDashboardLLocationIdCatalogServicesIndexRoute =
  AuthedDashboardLLocationIdCatalogServicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdCatalogServicesRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarRoomsIndexRoute =
  AuthedDashboardLLocationIdCalendarRoomsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoomsRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarNewIndexRoute =
  AuthedDashboardLLocationIdCalendarNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarNewRouteRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingSocialsScheduledRoute =
  AuthedDashboardLLocationIdMarketingSocialsScheduledRouteImport.update({
    id: '/scheduled',
    path: '/scheduled',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingSocialsRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingSocialsReviewRoute =
  AuthedDashboardLLocationIdMarketingSocialsReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingSocialsRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingSocialsRecentRoute =
  AuthedDashboardLLocationIdMarketingSocialsRecentRouteImport.update({
    id: '/recent',
    path: '/recent',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingSocialsRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingGalleryVideosRoute =
  AuthedDashboardLLocationIdMarketingGalleryVideosRouteImport.update({
    id: '/gallery/videos',
    path: '/gallery/videos',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingGalleryLibraryRoute =
  AuthedDashboardLLocationIdMarketingGalleryLibraryRouteImport.update({
    id: '/gallery/library',
    path: '/gallery/library',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingGalleryImagesRoute =
  AuthedDashboardLLocationIdMarketingGalleryImagesRouteImport.update({
    id: '/gallery/images',
    path: '/gallery/images',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingAdvertisingNewRoute =
  AuthedDashboardLLocationIdMarketingAdvertisingNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingAdvertisingRoute,
  } as any)
const AuthedDashboardLLocationIdCustomersLeadIdFormRoute =
  AuthedDashboardLLocationIdCustomersLeadIdFormRouteImport.update({
    id: '/form',
    path: '/form',
    getParentRoute: () => AuthedDashboardLLocationIdCustomersLeadIdRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarRoomsWeekRoute =
  AuthedDashboardLLocationIdCalendarRoomsWeekRouteImport.update({
    id: '/week',
    path: '/week',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoomsRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarRoomsThreeDayRoute =
  AuthedDashboardLLocationIdCalendarRoomsThreeDayRouteImport.update({
    id: '/three-day',
    path: '/three-day',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoomsRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarRoomsMonthRoute =
  AuthedDashboardLLocationIdCalendarRoomsMonthRouteImport.update({
    id: '/month',
    path: '/month',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoomsRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarRoomsDayRoute =
  AuthedDashboardLLocationIdCalendarRoomsDayRouteImport.update({
    id: '/day',
    path: '/day',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoomsRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarNewClientRoute =
  AuthedDashboardLLocationIdCalendarNewClientRouteImport.update({
    id: '/client',
    path: '/client',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarNewRouteRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarNewBlockRoute =
  AuthedDashboardLLocationIdCalendarNewBlockRouteImport.update({
    id: '/block',
    path: '/block',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarNewRouteRoute,
  } as any)
const AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRoute =
  AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRouteImport.update({
    id: '/appointment/$appointmentId',
    path: '/appointment/$appointmentId',
    getParentRoute: () => AuthedDashboardLLocationIdCalendarRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingSocialsNewIndexRoute =
  AuthedDashboardLLocationIdMarketingSocialsNewIndexRouteImport.update({
    id: '/new/',
    path: '/new/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingSocialsRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingGalleryNewIndexRoute =
  AuthedDashboardLLocationIdMarketingGalleryNewIndexRouteImport.update({
    id: '/gallery/new/',
    path: '/gallery/new/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRoute =
  AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRouteImport.update({
    id: '/campaigns/segments/',
    path: '/campaigns/segments/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingCampaignsNewIndexRoute =
  AuthedDashboardLLocationIdMarketingCampaignsNewIndexRouteImport.update({
    id: '/campaigns/new/',
    path: '/campaigns/new/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingCampaignsIdIndexRoute =
  AuthedDashboardLLocationIdMarketingCampaignsIdIndexRouteImport.update({
    id: '/campaigns/$id/',
    path: '/campaigns/$id/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRoute =
  AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingAdvertisingRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingSocialsPostIdRoute =
  AuthedDashboardLLocationIdMarketingSocialsPostIdRouteImport.update({
    id: '/post/$id',
    path: '/post/$id',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingSocialsRoute,
  } as any)
const AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRoute =
  AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRouteImport.update(
    {
      id: '/campaigns/segments/new/',
      path: '/campaigns/segments/new/',
      getParentRoute: () => AuthedDashboardLLocationIdMarketingRoute,
    } as any,
  )
const AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRoute =
  AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRouteImport.update({
    id: '/$id/ads/$adId',
    path: '/$id/ads/$adId',
    getParentRoute: () => AuthedDashboardLLocationIdMarketingAdvertisingRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/creative-lab': typeof CreativeLabRoute
  '/creative-lab-card': typeof CreativeLabCardRoute
  '/creative-lab-panel': typeof CreativeLabPanelRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/restore-organization': typeof RestoreOrganizationRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-2fa': typeof Verify2faRoute
  '/verify-email': typeof VerifyEmailRoute
  '/welcome': typeof WelcomeRouteWithChildren
  '/admin': typeof AdminAdminRouteWithChildren
  '/assistant': typeof AuthedAssistantRoute
  '/billing': typeof AuthedBillingRoute
  '/dashboard': typeof AuthedDashboardRouteWithChildren
  '/review-content': typeof AuthedReviewContentRoute
  '/website-preview': typeof AuthedWebsitePreviewRoute
  '/wireframe-fullscreen': typeof AuthedWireframeFullscreenRouteWithChildren
  '/onboarding': typeof OnboardingOnboardingRoute
  '/setup-profile': typeof OnboardingSetupProfileRoute
  '/upload-assets': typeof OnboardingUploadAssetsRoute
  '/connect/facebook': typeof ConnectFacebookRoute
  '/connect/whatsapp': typeof ConnectWhatsappRoute
  '/start/$token': typeof StartTokenRoute
  '/welcome/': typeof WelcomeIndexRoute
  '/admin/advertising': typeof AdminAdminAdvertisingRoute
  '/admin/audit-log': typeof AdminAdminAuditLogRoute
  '/admin/claire-failure-groups': typeof AdminAdminClaireFailureGroupsRoute
  '/admin/claire-regressions': typeof AdminAdminClaireRegressionsRoute
  '/admin/conversations': typeof AdminAdminConversationsRoute
  '/admin/crm-triggers': typeof AdminAdminCrmTriggersRoute
  '/admin/harness': typeof AdminAdminHarnessRoute
  '/admin/imports': typeof AdminAdminImportsRoute
  '/admin/meta-connections': typeof AdminAdminMetaConnectionsRoute
  '/admin/music': typeof AdminAdminMusicRoute
  '/admin/scraping': typeof AdminAdminScrapingRoute
  '/admin/stock-footage': typeof AdminAdminStockFootageRoute
  '/admin/stuck-setup': typeof AdminAdminStuckSetupRoute
  '/create/$entity': typeof AuthedCreateEntityRoute
  '/dashboard/$': typeof AuthedDashboardSplatRoute
  '/dashboard/account': typeof AuthedDashboardAccountRoute
  '/dashboard/brand': typeof AuthedDashboardBrandRoute
  '/dashboard/chatbots': typeof AuthedDashboardChatbotsRoute
  '/dashboard/conversations': typeof AuthedDashboardConversationsRoute
  '/dashboard/intake-forms': typeof AuthedDashboardIntakeFormsRoute
  '/dashboard/integrations': typeof AuthedDashboardIntegrationsRoute
  '/dashboard/lead-forms': typeof AuthedDashboardLeadFormsRoute
  '/dashboard/lead-management': typeof AuthedDashboardLeadManagementRoute
  '/dashboard/locations': typeof AuthedDashboardLocationsRoute
  '/dashboard/notifications': typeof AuthedDashboardNotificationsRoute
  '/dashboard/offers': typeof AuthedDashboardOffersRoute
  '/dashboard/organisation': typeof AuthedDashboardOrganisationRoute
  '/dashboard/reports': typeof AuthedDashboardReportsRoute
  '/dashboard/reset': typeof AuthedDashboardResetRoute
  '/dashboard/retention': typeof AuthedDashboardRetentionRoute
  '/dashboard/reviews': typeof AuthedDashboardReviewsRoute
  '/dashboard/settings': typeof AuthedDashboardSettingsRouteWithChildren
  '/dashboard/template-preview': typeof AuthedDashboardTemplatePreviewRoute
  '/dashboard/training-hub': typeof AuthedDashboardTrainingHubRoute
  '/dashboard/voice-test': typeof AuthedDashboardVoiceTestRoute
  '/dashboard/website': typeof AuthedDashboardWebsiteRoute
  '/dashboard/wireframes': typeof AuthedDashboardWireframesRouteWithChildren
  '/record/$videoId': typeof AuthedRecordVideoIdRoute
  '/settings/claire': typeof AuthedSettingsClaireRouteWithChildren
  '/wireframe-fullscreen/annotate': typeof AuthedWireframeFullscreenAnnotateRoute
  '/wireframe-fullscreen/compare': typeof AuthedWireframeFullscreenCompareRoute
  '/wireframe-fullscreen/consent-kiosk': typeof AuthedWireframeFullscreenConsentKioskRoute
  '/wireframe-fullscreen/scribe': typeof AuthedWireframeFullscreenScribeRoute
  '/connect/stripe/done': typeof ConnectStripeDoneRoute
  '/forms/$organizationSlug/$token': typeof FormsOrganizationSlugTokenRoute
  '/venue/$organizationSlug/$locationSlug': typeof VenueOrganizationSlugLocationSlugRoute
  '/admin/': typeof AdminAdminIndexRoute
  '/create-video/': typeof AuthedCreateVideoIndexRoute
  '/dashboard/': typeof AuthedDashboardIndexRoute
  '/record/': typeof AuthedRecordIndexRoute
  '/opt-in/$organizationSlug/': typeof OptInOrganizationSlugIndexRoute
  '/venue/$organizationSlug/': typeof VenueOrganizationSlugIndexRoute
  '/admin/organizations/$id': typeof AdminAdminOrganizationsIdRoute
  '/ads/new/video-format': typeof AuthedAdsNewVideoFormatRoute
  '/dashboard/advertising/new': typeof AuthedDashboardAdvertisingNewRoute
  '/dashboard/appointments/agenda': typeof AuthedDashboardAppointmentsAgendaRoute
  '/dashboard/appointments/day': typeof AuthedDashboardAppointmentsDayRoute
  '/dashboard/appointments/month': typeof AuthedDashboardAppointmentsMonthRoute
  '/dashboard/appointments/week': typeof AuthedDashboardAppointmentsWeekRoute
  '/dashboard/appointments/year': typeof AuthedDashboardAppointmentsYearRoute
  '/dashboard/content/gallery': typeof AuthedDashboardContentGalleryRoute
  '/dashboard/content/images': typeof AuthedDashboardContentImagesRoute
  '/dashboard/content/library': typeof AuthedDashboardContentLibraryRoute
  '/dashboard/content/new': typeof AuthedDashboardContentNewRoute
  '/dashboard/content/videos': typeof AuthedDashboardContentVideosRoute
  '/dashboard/debug/analysis-split-test': typeof AuthedDashboardDebugAnalysisSplitTestRoute
  '/dashboard/l/$locationId': typeof AuthedDashboardLLocationIdRouteWithChildren
  '/dashboard/more/$section': typeof AuthedDashboardMoreSectionRoute
  '/dashboard/services/new': typeof AuthedDashboardServicesNewRoute
  '/dashboard/settings/billing': typeof AuthedDashboardSettingsBillingRoute
  '/dashboard/settings/blocked-time-types': typeof AuthedDashboardSettingsBlockedTimeTypesRoute
  '/dashboard/settings/bookings': typeof AuthedDashboardSettingsBookingsRoute
  '/dashboard/settings/cancellations': typeof AuthedDashboardSettingsCancellationsRoute
  '/dashboard/settings/chatbot': typeof AuthedDashboardSettingsChatbotRoute
  '/dashboard/settings/claire-campaigns': typeof AuthedDashboardSettingsClaireCampaignsRoute
  '/dashboard/settings/claire-memories': typeof AuthedDashboardSettingsClaireMemoriesRoute
  '/dashboard/settings/claire-whatsapp': typeof AuthedDashboardSettingsClaireWhatsappRoute
  '/dashboard/settings/consent-forms': typeof AuthedDashboardSettingsConsentFormsRoute
  '/dashboard/settings/consent-privacy': typeof AuthedDashboardSettingsConsentPrivacyRoute
  '/dashboard/settings/delete-account': typeof AuthedDashboardSettingsDeleteAccountRoute
  '/dashboard/settings/details': typeof AuthedDashboardSettingsDetailsRoute
  '/dashboard/settings/examples': typeof AuthedDashboardSettingsExamplesRoute
  '/dashboard/settings/form-templates': typeof AuthedDashboardSettingsFormTemplatesRouteWithChildren
  '/dashboard/settings/integrations': typeof AuthedDashboardSettingsIntegrationsRoute
  '/dashboard/settings/message-templates': typeof AuthedDashboardSettingsMessageTemplatesRoute
  '/dashboard/settings/notifications': typeof AuthedDashboardSettingsNotificationsRoute
  '/dashboard/settings/payments': typeof AuthedDashboardSettingsPaymentsRoute
  '/dashboard/settings/post-treatment-reviews': typeof AuthedDashboardSettingsPostTreatmentReviewsRoute
  '/dashboard/settings/reminders': typeof AuthedDashboardSettingsRemindersRoute
  '/dashboard/settings/scheduling': typeof AuthedDashboardSettingsSchedulingRoute
  '/dashboard/settings/style': typeof AuthedDashboardSettingsStyleRoute
  '/dashboard/socials/new': typeof AuthedDashboardSocialsNewRoute
  '/dashboard/socials/recent': typeof AuthedDashboardSocialsRecentRoute
  '/dashboard/socials/review': typeof AuthedDashboardSocialsReviewRoute
  '/dashboard/socials/scheduled': typeof AuthedDashboardSocialsScheduledRoute
  '/dashboard/wireframes/calendar-day': typeof AuthedDashboardWireframesCalendarDayRoute
  '/dashboard/wireframes/calendar-side-panel': typeof AuthedDashboardWireframesCalendarSidePanelRoute
  '/dashboard/wireframes/calendar-week': typeof AuthedDashboardWireframesCalendarWeekRoute
  '/dashboard/wireframes/consent-compliance': typeof AuthedDashboardWireframesConsentComplianceRoute
  '/dashboard/wireframes/data-privacy': typeof AuthedDashboardWireframesDataPrivacyRoute
  '/dashboard/wireframes/deposits': typeof AuthedDashboardWireframesDepositsRoute
  '/dashboard/wireframes/photos': typeof AuthedDashboardWireframesPhotosRoute
  '/dashboard/wireframes/reminders-settings': typeof AuthedDashboardWireframesRemindersSettingsRoute
  '/dashboard/wireframes/reports': typeof AuthedDashboardWireframesReportsRoute
  '/dashboard/wireframes/retention': typeof AuthedDashboardWireframesRetentionRoute
  '/dashboard/wireframes/reviews': typeof AuthedDashboardWireframesReviewsRoute
  '/dashboard/wireframes/search': typeof AuthedDashboardWireframesSearchRoute
  '/dashboard/wireframes/sequences': typeof AuthedDashboardWireframesSequencesRoute
  '/dashboard/wireframes/settings': typeof AuthedDashboardWireframesSettingsRoute
  '/dashboard/wireframes/skin-analysis': typeof AuthedDashboardWireframesSkinAnalysisRoute
  '/dashboard/wireframes/view-shell': typeof AuthedDashboardWireframesViewShellRoute
  '/edit/$entity/$id': typeof AuthedEditEntityIdRoute
  '/settings/claire/usage': typeof AuthedSettingsClaireUsageRoute
  '/settings/claire/whatsapp': typeof AuthedSettingsClaireWhatsappRoute
  '/team/repeating-shifts/$practitionerId': typeof AuthedTeamRepeatingShiftsPractitionerIdRoute
  '/ads/new/': typeof AuthedAdsNewIndexRoute
  '/connect/meta-ads/': typeof AuthedConnectMetaAdsIndexRoute
  '/create-video/$templateId/': typeof AuthedCreateVideoTemplateIdIndexRoute
  '/dashboard/advertising/': typeof AuthedDashboardAdvertisingIndexRoute
  '/dashboard/appointments/': typeof AuthedDashboardAppointmentsIndexRoute
  '/dashboard/content/': typeof AuthedDashboardContentIndexRoute
  '/dashboard/debug/': typeof AuthedDashboardDebugIndexRoute
  '/dashboard/more/': typeof AuthedDashboardMoreIndexRoute
  '/dashboard/services/': typeof AuthedDashboardServicesIndexRoute
  '/dashboard/settings/': typeof AuthedDashboardSettingsIndexRoute
  '/dashboard/socials/': typeof AuthedDashboardSocialsIndexRoute
  '/dashboard/wireframes/': typeof AuthedDashboardWireframesIndexRoute
  '/dashboard/appointments/new/block': typeof AuthedDashboardAppointmentsNewBlockRoute
  '/dashboard/appointments/new/client': typeof AuthedDashboardAppointmentsNewClientRoute
  '/dashboard/l/$locationId/ai-assistant': typeof AuthedDashboardLLocationIdAiAssistantRoute
  '/dashboard/l/$locationId/calendar': typeof AuthedDashboardLLocationIdCalendarRouteWithChildren
  '/dashboard/l/$locationId/clients': typeof AuthedDashboardLLocationIdClientsRouteWithChildren
  '/dashboard/l/$locationId/content-calendar': typeof AuthedDashboardLLocationIdContentCalendarRouteWithChildren
  '/dashboard/l/$locationId/customers': typeof AuthedDashboardLLocationIdCustomersRouteWithChildren
  '/dashboard/l/$locationId/deposits': typeof AuthedDashboardLLocationIdDepositsRoute
  '/dashboard/l/$locationId/home': typeof AuthedDashboardLLocationIdHomeRoute
  '/dashboard/l/$locationId/marketing': typeof AuthedDashboardLLocationIdMarketingRouteWithChildren
  '/dashboard/l/$locationId/public-site': typeof AuthedDashboardLLocationIdPublicSiteRoute
  '/dashboard/l/$locationId/sales': typeof AuthedDashboardLLocationIdSalesRouteWithChildren
  '/dashboard/l/$locationId/venue': typeof AuthedDashboardLLocationIdVenueRoute
  '/dashboard/services/$serviceId/edit': typeof AuthedDashboardServicesServiceIdEditRoute
  '/dashboard/settings/form-templates/$formId': typeof AuthedDashboardSettingsFormTemplatesFormIdRoute
  '/dashboard/socials/post/$id': typeof AuthedDashboardSocialsPostIdRoute
  '/dashboard/advertising/$id/': typeof AuthedDashboardAdvertisingIdIndexRoute
  '/dashboard/appointments/new/': typeof AuthedDashboardAppointmentsNewIndexRoute
  '/dashboard/settings/form-templates/': typeof AuthedDashboardSettingsFormTemplatesIndexRoute
  '/dashboard/l/$locationId/calendar/new': typeof AuthedDashboardLLocationIdCalendarNewRouteRouteWithChildren
  '/dashboard/advertising/$id/ads/$adId': typeof AuthedDashboardAdvertisingIdAdsAdIdRoute
  '/dashboard/l/$locationId/calendar/agenda': typeof AuthedDashboardLLocationIdCalendarAgendaRoute
  '/dashboard/l/$locationId/calendar/day': typeof AuthedDashboardLLocationIdCalendarDayRoute
  '/dashboard/l/$locationId/calendar/month': typeof AuthedDashboardLLocationIdCalendarMonthRoute
  '/dashboard/l/$locationId/calendar/rooms': typeof AuthedDashboardLLocationIdCalendarRoomsRouteWithChildren
  '/dashboard/l/$locationId/calendar/three-day': typeof AuthedDashboardLLocationIdCalendarThreeDayRoute
  '/dashboard/l/$locationId/calendar/week': typeof AuthedDashboardLLocationIdCalendarWeekRoute
  '/dashboard/l/$locationId/calendar/year': typeof AuthedDashboardLLocationIdCalendarYearRoute
  '/dashboard/l/$locationId/catalog/brands': typeof AuthedDashboardLLocationIdCatalogBrandsRoute
  '/dashboard/l/$locationId/catalog/categories': typeof AuthedDashboardLLocationIdCatalogCategoriesRoute
  '/dashboard/l/$locationId/catalog/memberships': typeof AuthedDashboardLLocationIdCatalogMembershipsRoute
  '/dashboard/l/$locationId/catalog/offers': typeof AuthedDashboardLLocationIdCatalogOffersRoute
  '/dashboard/l/$locationId/catalog/packages': typeof AuthedDashboardLLocationIdCatalogPackagesRoute
  '/dashboard/l/$locationId/catalog/products': typeof AuthedDashboardLLocationIdCatalogProductsRoute
  '/dashboard/l/$locationId/catalog/resources': typeof AuthedDashboardLLocationIdCatalogResourcesRoute
  '/dashboard/l/$locationId/catalog/services': typeof AuthedDashboardLLocationIdCatalogServicesRouteWithChildren
  '/dashboard/l/$locationId/catalog/stock-orders': typeof AuthedDashboardLLocationIdCatalogStockOrdersRoute
  '/dashboard/l/$locationId/catalog/stocktakes': typeof AuthedDashboardLLocationIdCatalogStocktakesRoute
  '/dashboard/l/$locationId/catalog/suppliers': typeof AuthedDashboardLLocationIdCatalogSuppliersRoute
  '/dashboard/l/$locationId/clients/$leadId': typeof AuthedDashboardLLocationIdClientsLeadIdRoute
  '/dashboard/l/$locationId/clients/inbox': typeof AuthedDashboardLLocationIdClientsInboxRoute
  '/dashboard/l/$locationId/clients/list': typeof AuthedDashboardLLocationIdClientsListRoute
  '/dashboard/l/$locationId/content-calendar/day': typeof AuthedDashboardLLocationIdContentCalendarDayRoute
  '/dashboard/l/$locationId/content-calendar/month': typeof AuthedDashboardLLocationIdContentCalendarMonthRoute
  '/dashboard/l/$locationId/content-calendar/three-day': typeof AuthedDashboardLLocationIdContentCalendarThreeDayRoute
  '/dashboard/l/$locationId/content-calendar/week': typeof AuthedDashboardLLocationIdContentCalendarWeekRoute
  '/dashboard/l/$locationId/customers/$leadId': typeof AuthedDashboardLLocationIdCustomersLeadIdRouteWithChildren
  '/dashboard/l/$locationId/inventory/brands': typeof AuthedDashboardLLocationIdInventoryBrandsRoute
  '/dashboard/l/$locationId/inventory/categories': typeof AuthedDashboardLLocationIdInventoryCategoriesRoute
  '/dashboard/l/$locationId/inventory/stock-orders': typeof AuthedDashboardLLocationIdInventoryStockOrdersRoute
  '/dashboard/l/$locationId/inventory/stocktakes': typeof AuthedDashboardLLocationIdInventoryStocktakesRoute
  '/dashboard/l/$locationId/inventory/suppliers': typeof AuthedDashboardLLocationIdInventorySuppliersRoute
  '/dashboard/l/$locationId/marketing/advertising': typeof AuthedDashboardLLocationIdMarketingAdvertisingRouteWithChildren
  '/dashboard/l/$locationId/marketing/lead-forms': typeof AuthedDashboardLLocationIdMarketingLeadFormsRoute
  '/dashboard/l/$locationId/marketing/sequences': typeof AuthedDashboardLLocationIdMarketingSequencesRoute
  '/dashboard/l/$locationId/marketing/socials': typeof AuthedDashboardLLocationIdMarketingSocialsRouteWithChildren
  '/dashboard/l/$locationId/sales/appointments': typeof AuthedDashboardLLocationIdSalesAppointmentsRoute
  '/dashboard/l/$locationId/sales/daily-summary': typeof AuthedDashboardLLocationIdSalesDailySummaryRoute
  '/dashboard/l/$locationId/sales/gift-cards': typeof AuthedDashboardLLocationIdSalesGiftCardsRoute
  '/dashboard/l/$locationId/sales/list': typeof AuthedDashboardLLocationIdSalesListRoute
  '/dashboard/l/$locationId/sales/memberships': typeof AuthedDashboardLLocationIdSalesMembershipsRoute
  '/dashboard/l/$locationId/sales/payments': typeof AuthedDashboardLLocationIdSalesPaymentsRoute
  '/dashboard/l/$locationId/sales/product-orders': typeof AuthedDashboardLLocationIdSalesProductOrdersRoute
  '/dashboard/l/$locationId/team/members': typeof AuthedDashboardLLocationIdTeamMembersRoute
  '/dashboard/l/$locationId/team/practitioners': typeof AuthedDashboardLLocationIdTeamPractitionersRoute
  '/dashboard/l/$locationId/team/shifts': typeof AuthedDashboardLLocationIdTeamShiftsRoute
  '/dashboard/l/$locationId/team/timesheets': typeof AuthedDashboardLLocationIdTeamTimesheetsRoute
  '/dashboard/l/$locationId/calendar/': typeof AuthedDashboardLLocationIdCalendarIndexRoute
  '/dashboard/l/$locationId/catalog/': typeof AuthedDashboardLLocationIdCatalogIndexRoute
  '/dashboard/l/$locationId/clients/': typeof AuthedDashboardLLocationIdClientsIndexRoute
  '/dashboard/l/$locationId/content-calendar/': typeof AuthedDashboardLLocationIdContentCalendarIndexRoute
  '/dashboard/l/$locationId/marketing/': typeof AuthedDashboardLLocationIdMarketingIndexRoute
  '/dashboard/l/$locationId/sales/': typeof AuthedDashboardLLocationIdSalesIndexRoute
  '/dashboard/l/$locationId/team/': typeof AuthedDashboardLLocationIdTeamIndexRoute
  '/dashboard/l/$locationId/videos/': typeof AuthedDashboardLLocationIdVideosIndexRoute
  '/dashboard/l/$locationId/calendar/appointment/$appointmentId': typeof AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRoute
  '/dashboard/l/$locationId/calendar/new/block': typeof AuthedDashboardLLocationIdCalendarNewBlockRoute
  '/dashboard/l/$locationId/calendar/new/client': typeof AuthedDashboardLLocationIdCalendarNewClientRoute
  '/dashboard/l/$locationId/calendar/rooms/day': typeof AuthedDashboardLLocationIdCalendarRoomsDayRoute
  '/dashboard/l/$locationId/calendar/rooms/month': typeof AuthedDashboardLLocationIdCalendarRoomsMonthRoute
  '/dashboard/l/$locationId/calendar/rooms/three-day': typeof AuthedDashboardLLocationIdCalendarRoomsThreeDayRoute
  '/dashboard/l/$locationId/calendar/rooms/week': typeof AuthedDashboardLLocationIdCalendarRoomsWeekRoute
  '/dashboard/l/$locationId/customers/$leadId/form': typeof AuthedDashboardLLocationIdCustomersLeadIdFormRoute
  '/dashboard/l/$locationId/marketing/advertising/new': typeof AuthedDashboardLLocationIdMarketingAdvertisingNewRoute
  '/dashboard/l/$locationId/marketing/gallery/images': typeof AuthedDashboardLLocationIdMarketingGalleryImagesRoute
  '/dashboard/l/$locationId/marketing/gallery/library': typeof AuthedDashboardLLocationIdMarketingGalleryLibraryRoute
  '/dashboard/l/$locationId/marketing/gallery/videos': typeof AuthedDashboardLLocationIdMarketingGalleryVideosRoute
  '/dashboard/l/$locationId/marketing/socials/recent': typeof AuthedDashboardLLocationIdMarketingSocialsRecentRoute
  '/dashboard/l/$locationId/marketing/socials/review': typeof AuthedDashboardLLocationIdMarketingSocialsReviewRoute
  '/dashboard/l/$locationId/marketing/socials/scheduled': typeof AuthedDashboardLLocationIdMarketingSocialsScheduledRoute
  '/dashboard/l/$locationId/calendar/new/': typeof AuthedDashboardLLocationIdCalendarNewIndexRoute
  '/dashboard/l/$locationId/calendar/rooms/': typeof AuthedDashboardLLocationIdCalendarRoomsIndexRoute
  '/dashboard/l/$locationId/catalog/services/': typeof AuthedDashboardLLocationIdCatalogServicesIndexRoute
  '/dashboard/l/$locationId/marketing/advertising/': typeof AuthedDashboardLLocationIdMarketingAdvertisingIndexRoute
  '/dashboard/l/$locationId/marketing/campaigns/': typeof AuthedDashboardLLocationIdMarketingCampaignsIndexRoute
  '/dashboard/l/$locationId/marketing/gallery/': typeof AuthedDashboardLLocationIdMarketingGalleryIndexRoute
  '/dashboard/l/$locationId/marketing/music/': typeof AuthedDashboardLLocationIdMarketingMusicIndexRoute
  '/dashboard/l/$locationId/marketing/socials/': typeof AuthedDashboardLLocationIdMarketingSocialsIndexRoute
  '/dashboard/l/$locationId/videos/create-from-client/': typeof AuthedDashboardLLocationIdVideosCreateFromClientIndexRoute
  '/dashboard/l/$locationId/marketing/socials/post/$id': typeof AuthedDashboardLLocationIdMarketingSocialsPostIdRoute
  '/dashboard/l/$locationId/marketing/advertising/$id/': typeof AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRoute
  '/dashboard/l/$locationId/marketing/campaigns/$id/': typeof AuthedDashboardLLocationIdMarketingCampaignsIdIndexRoute
  '/dashboard/l/$locationId/marketing/campaigns/new/': typeof AuthedDashboardLLocationIdMarketingCampaignsNewIndexRoute
  '/dashboard/l/$locationId/marketing/campaigns/segments/': typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRoute
  '/dashboard/l/$locationId/marketing/gallery/new/': typeof AuthedDashboardLLocationIdMarketingGalleryNewIndexRoute
  '/dashboard/l/$locationId/marketing/socials/new/': typeof AuthedDashboardLLocationIdMarketingSocialsNewIndexRoute
  '/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId': typeof AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRoute
  '/dashboard/l/$locationId/marketing/campaigns/segments/new/': typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/creative-lab': typeof CreativeLabRoute
  '/creative-lab-card': typeof CreativeLabCardRoute
  '/creative-lab-panel': typeof CreativeLabPanelRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/restore-organization': typeof RestoreOrganizationRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-2fa': typeof Verify2faRoute
  '/verify-email': typeof VerifyEmailRoute
  '/assistant': typeof AuthedAssistantRoute
  '/billing': typeof AuthedBillingRoute
  '/review-content': typeof AuthedReviewContentRoute
  '/website-preview': typeof AuthedWebsitePreviewRoute
  '/wireframe-fullscreen': typeof AuthedWireframeFullscreenRouteWithChildren
  '/onboarding': typeof OnboardingOnboardingRoute
  '/setup-profile': typeof OnboardingSetupProfileRoute
  '/upload-assets': typeof OnboardingUploadAssetsRoute
  '/connect/facebook': typeof ConnectFacebookRoute
  '/connect/whatsapp': typeof ConnectWhatsappRoute
  '/start/$token': typeof StartTokenRoute
  '/welcome': typeof WelcomeIndexRoute
  '/admin/advertising': typeof AdminAdminAdvertisingRoute
  '/admin/audit-log': typeof AdminAdminAuditLogRoute
  '/admin/claire-failure-groups': typeof AdminAdminClaireFailureGroupsRoute
  '/admin/claire-regressions': typeof AdminAdminClaireRegressionsRoute
  '/admin/conversations': typeof AdminAdminConversationsRoute
  '/admin/crm-triggers': typeof AdminAdminCrmTriggersRoute
  '/admin/harness': typeof AdminAdminHarnessRoute
  '/admin/imports': typeof AdminAdminImportsRoute
  '/admin/meta-connections': typeof AdminAdminMetaConnectionsRoute
  '/admin/music': typeof AdminAdminMusicRoute
  '/admin/scraping': typeof AdminAdminScrapingRoute
  '/admin/stock-footage': typeof AdminAdminStockFootageRoute
  '/admin/stuck-setup': typeof AdminAdminStuckSetupRoute
  '/create/$entity': typeof AuthedCreateEntityRoute
  '/dashboard/$': typeof AuthedDashboardSplatRoute
  '/dashboard/account': typeof AuthedDashboardAccountRoute
  '/dashboard/brand': typeof AuthedDashboardBrandRoute
  '/dashboard/chatbots': typeof AuthedDashboardChatbotsRoute
  '/dashboard/conversations': typeof AuthedDashboardConversationsRoute
  '/dashboard/intake-forms': typeof AuthedDashboardIntakeFormsRoute
  '/dashboard/integrations': typeof AuthedDashboardIntegrationsRoute
  '/dashboard/lead-forms': typeof AuthedDashboardLeadFormsRoute
  '/dashboard/lead-management': typeof AuthedDashboardLeadManagementRoute
  '/dashboard/locations': typeof AuthedDashboardLocationsRoute
  '/dashboard/notifications': typeof AuthedDashboardNotificationsRoute
  '/dashboard/offers': typeof AuthedDashboardOffersRoute
  '/dashboard/organisation': typeof AuthedDashboardOrganisationRoute
  '/dashboard/reports': typeof AuthedDashboardReportsRoute
  '/dashboard/reset': typeof AuthedDashboardResetRoute
  '/dashboard/retention': typeof AuthedDashboardRetentionRoute
  '/dashboard/reviews': typeof AuthedDashboardReviewsRoute
  '/dashboard/template-preview': typeof AuthedDashboardTemplatePreviewRoute
  '/dashboard/training-hub': typeof AuthedDashboardTrainingHubRoute
  '/dashboard/voice-test': typeof AuthedDashboardVoiceTestRoute
  '/dashboard/website': typeof AuthedDashboardWebsiteRoute
  '/record/$videoId': typeof AuthedRecordVideoIdRoute
  '/settings/claire': typeof AuthedSettingsClaireRouteWithChildren
  '/wireframe-fullscreen/annotate': typeof AuthedWireframeFullscreenAnnotateRoute
  '/wireframe-fullscreen/compare': typeof AuthedWireframeFullscreenCompareRoute
  '/wireframe-fullscreen/consent-kiosk': typeof AuthedWireframeFullscreenConsentKioskRoute
  '/wireframe-fullscreen/scribe': typeof AuthedWireframeFullscreenScribeRoute
  '/connect/stripe/done': typeof ConnectStripeDoneRoute
  '/forms/$organizationSlug/$token': typeof FormsOrganizationSlugTokenRoute
  '/venue/$organizationSlug/$locationSlug': typeof VenueOrganizationSlugLocationSlugRoute
  '/admin': typeof AdminAdminIndexRoute
  '/create-video': typeof AuthedCreateVideoIndexRoute
  '/dashboard': typeof AuthedDashboardIndexRoute
  '/record': typeof AuthedRecordIndexRoute
  '/opt-in/$organizationSlug': typeof OptInOrganizationSlugIndexRoute
  '/venue/$organizationSlug': typeof VenueOrganizationSlugIndexRoute
  '/admin/organizations/$id': typeof AdminAdminOrganizationsIdRoute
  '/ads/new/video-format': typeof AuthedAdsNewVideoFormatRoute
  '/dashboard/advertising/new': typeof AuthedDashboardAdvertisingNewRoute
  '/dashboard/appointments/agenda': typeof AuthedDashboardAppointmentsAgendaRoute
  '/dashboard/appointments/day': typeof AuthedDashboardAppointmentsDayRoute
  '/dashboard/appointments/month': typeof AuthedDashboardAppointmentsMonthRoute
  '/dashboard/appointments/week': typeof AuthedDashboardAppointmentsWeekRoute
  '/dashboard/appointments/year': typeof AuthedDashboardAppointmentsYearRoute
  '/dashboard/content/gallery': typeof AuthedDashboardContentGalleryRoute
  '/dashboard/content/images': typeof AuthedDashboardContentImagesRoute
  '/dashboard/content/library': typeof AuthedDashboardContentLibraryRoute
  '/dashboard/content/new': typeof AuthedDashboardContentNewRoute
  '/dashboard/content/videos': typeof AuthedDashboardContentVideosRoute
  '/dashboard/debug/analysis-split-test': typeof AuthedDashboardDebugAnalysisSplitTestRoute
  '/dashboard/l/$locationId': typeof AuthedDashboardLLocationIdRouteWithChildren
  '/dashboard/more/$section': typeof AuthedDashboardMoreSectionRoute
  '/dashboard/services/new': typeof AuthedDashboardServicesNewRoute
  '/dashboard/settings/billing': typeof AuthedDashboardSettingsBillingRoute
  '/dashboard/settings/blocked-time-types': typeof AuthedDashboardSettingsBlockedTimeTypesRoute
  '/dashboard/settings/bookings': typeof AuthedDashboardSettingsBookingsRoute
  '/dashboard/settings/cancellations': typeof AuthedDashboardSettingsCancellationsRoute
  '/dashboard/settings/chatbot': typeof AuthedDashboardSettingsChatbotRoute
  '/dashboard/settings/claire-campaigns': typeof AuthedDashboardSettingsClaireCampaignsRoute
  '/dashboard/settings/claire-memories': typeof AuthedDashboardSettingsClaireMemoriesRoute
  '/dashboard/settings/claire-whatsapp': typeof AuthedDashboardSettingsClaireWhatsappRoute
  '/dashboard/settings/consent-forms': typeof AuthedDashboardSettingsConsentFormsRoute
  '/dashboard/settings/consent-privacy': typeof AuthedDashboardSettingsConsentPrivacyRoute
  '/dashboard/settings/delete-account': typeof AuthedDashboardSettingsDeleteAccountRoute
  '/dashboard/settings/details': typeof AuthedDashboardSettingsDetailsRoute
  '/dashboard/settings/examples': typeof AuthedDashboardSettingsExamplesRoute
  '/dashboard/settings/integrations': typeof AuthedDashboardSettingsIntegrationsRoute
  '/dashboard/settings/message-templates': typeof AuthedDashboardSettingsMessageTemplatesRoute
  '/dashboard/settings/notifications': typeof AuthedDashboardSettingsNotificationsRoute
  '/dashboard/settings/payments': typeof AuthedDashboardSettingsPaymentsRoute
  '/dashboard/settings/post-treatment-reviews': typeof AuthedDashboardSettingsPostTreatmentReviewsRoute
  '/dashboard/settings/reminders': typeof AuthedDashboardSettingsRemindersRoute
  '/dashboard/settings/scheduling': typeof AuthedDashboardSettingsSchedulingRoute
  '/dashboard/settings/style': typeof AuthedDashboardSettingsStyleRoute
  '/dashboard/socials/new': typeof AuthedDashboardSocialsNewRoute
  '/dashboard/socials/recent': typeof AuthedDashboardSocialsRecentRoute
  '/dashboard/socials/review': typeof AuthedDashboardSocialsReviewRoute
  '/dashboard/socials/scheduled': typeof AuthedDashboardSocialsScheduledRoute
  '/dashboard/wireframes/calendar-day': typeof AuthedDashboardWireframesCalendarDayRoute
  '/dashboard/wireframes/calendar-side-panel': typeof AuthedDashboardWireframesCalendarSidePanelRoute
  '/dashboard/wireframes/calendar-week': typeof AuthedDashboardWireframesCalendarWeekRoute
  '/dashboard/wireframes/consent-compliance': typeof AuthedDashboardWireframesConsentComplianceRoute
  '/dashboard/wireframes/data-privacy': typeof AuthedDashboardWireframesDataPrivacyRoute
  '/dashboard/wireframes/deposits': typeof AuthedDashboardWireframesDepositsRoute
  '/dashboard/wireframes/photos': typeof AuthedDashboardWireframesPhotosRoute
  '/dashboard/wireframes/reminders-settings': typeof AuthedDashboardWireframesRemindersSettingsRoute
  '/dashboard/wireframes/reports': typeof AuthedDashboardWireframesReportsRoute
  '/dashboard/wireframes/retention': typeof AuthedDashboardWireframesRetentionRoute
  '/dashboard/wireframes/reviews': typeof AuthedDashboardWireframesReviewsRoute
  '/dashboard/wireframes/search': typeof AuthedDashboardWireframesSearchRoute
  '/dashboard/wireframes/sequences': typeof AuthedDashboardWireframesSequencesRoute
  '/dashboard/wireframes/settings': typeof AuthedDashboardWireframesSettingsRoute
  '/dashboard/wireframes/skin-analysis': typeof AuthedDashboardWireframesSkinAnalysisRoute
  '/dashboard/wireframes/view-shell': typeof AuthedDashboardWireframesViewShellRoute
  '/edit/$entity/$id': typeof AuthedEditEntityIdRoute
  '/settings/claire/usage': typeof AuthedSettingsClaireUsageRoute
  '/settings/claire/whatsapp': typeof AuthedSettingsClaireWhatsappRoute
  '/team/repeating-shifts/$practitionerId': typeof AuthedTeamRepeatingShiftsPractitionerIdRoute
  '/ads/new': typeof AuthedAdsNewIndexRoute
  '/connect/meta-ads': typeof AuthedConnectMetaAdsIndexRoute
  '/create-video/$templateId': typeof AuthedCreateVideoTemplateIdIndexRoute
  '/dashboard/advertising': typeof AuthedDashboardAdvertisingIndexRoute
  '/dashboard/appointments': typeof AuthedDashboardAppointmentsIndexRoute
  '/dashboard/content': typeof AuthedDashboardContentIndexRoute
  '/dashboard/debug': typeof AuthedDashboardDebugIndexRoute
  '/dashboard/more': typeof AuthedDashboardMoreIndexRoute
  '/dashboard/services': typeof AuthedDashboardServicesIndexRoute
  '/dashboard/settings': typeof AuthedDashboardSettingsIndexRoute
  '/dashboard/socials': typeof AuthedDashboardSocialsIndexRoute
  '/dashboard/wireframes': typeof AuthedDashboardWireframesIndexRoute
  '/dashboard/appointments/new/block': typeof AuthedDashboardAppointmentsNewBlockRoute
  '/dashboard/appointments/new/client': typeof AuthedDashboardAppointmentsNewClientRoute
  '/dashboard/l/$locationId/ai-assistant': typeof AuthedDashboardLLocationIdAiAssistantRoute
  '/dashboard/l/$locationId/customers': typeof AuthedDashboardLLocationIdCustomersRouteWithChildren
  '/dashboard/l/$locationId/deposits': typeof AuthedDashboardLLocationIdDepositsRoute
  '/dashboard/l/$locationId/home': typeof AuthedDashboardLLocationIdHomeRoute
  '/dashboard/l/$locationId/public-site': typeof AuthedDashboardLLocationIdPublicSiteRoute
  '/dashboard/l/$locationId/venue': typeof AuthedDashboardLLocationIdVenueRoute
  '/dashboard/services/$serviceId/edit': typeof AuthedDashboardServicesServiceIdEditRoute
  '/dashboard/settings/form-templates/$formId': typeof AuthedDashboardSettingsFormTemplatesFormIdRoute
  '/dashboard/socials/post/$id': typeof AuthedDashboardSocialsPostIdRoute
  '/dashboard/advertising/$id': typeof AuthedDashboardAdvertisingIdIndexRoute
  '/dashboard/appointments/new': typeof AuthedDashboardAppointmentsNewIndexRoute
  '/dashboard/settings/form-templates': typeof AuthedDashboardSettingsFormTemplatesIndexRoute
  '/dashboard/advertising/$id/ads/$adId': typeof AuthedDashboardAdvertisingIdAdsAdIdRoute
  '/dashboard/l/$locationId/calendar/agenda': typeof AuthedDashboardLLocationIdCalendarAgendaRoute
  '/dashboard/l/$locationId/calendar/day': typeof AuthedDashboardLLocationIdCalendarDayRoute
  '/dashboard/l/$locationId/calendar/month': typeof AuthedDashboardLLocationIdCalendarMonthRoute
  '/dashboard/l/$locationId/calendar/three-day': typeof AuthedDashboardLLocationIdCalendarThreeDayRoute
  '/dashboard/l/$locationId/calendar/week': typeof AuthedDashboardLLocationIdCalendarWeekRoute
  '/dashboard/l/$locationId/calendar/year': typeof AuthedDashboardLLocationIdCalendarYearRoute
  '/dashboard/l/$locationId/catalog/brands': typeof AuthedDashboardLLocationIdCatalogBrandsRoute
  '/dashboard/l/$locationId/catalog/categories': typeof AuthedDashboardLLocationIdCatalogCategoriesRoute
  '/dashboard/l/$locationId/catalog/memberships': typeof AuthedDashboardLLocationIdCatalogMembershipsRoute
  '/dashboard/l/$locationId/catalog/offers': typeof AuthedDashboardLLocationIdCatalogOffersRoute
  '/dashboard/l/$locationId/catalog/packages': typeof AuthedDashboardLLocationIdCatalogPackagesRoute
  '/dashboard/l/$locationId/catalog/products': typeof AuthedDashboardLLocationIdCatalogProductsRoute
  '/dashboard/l/$locationId/catalog/resources': typeof AuthedDashboardLLocationIdCatalogResourcesRoute
  '/dashboard/l/$locationId/catalog/stock-orders': typeof AuthedDashboardLLocationIdCatalogStockOrdersRoute
  '/dashboard/l/$locationId/catalog/stocktakes': typeof AuthedDashboardLLocationIdCatalogStocktakesRoute
  '/dashboard/l/$locationId/catalog/suppliers': typeof AuthedDashboardLLocationIdCatalogSuppliersRoute
  '/dashboard/l/$locationId/clients/$leadId': typeof AuthedDashboardLLocationIdClientsLeadIdRoute
  '/dashboard/l/$locationId/clients/inbox': typeof AuthedDashboardLLocationIdClientsInboxRoute
  '/dashboard/l/$locationId/clients/list': typeof AuthedDashboardLLocationIdClientsListRoute
  '/dashboard/l/$locationId/content-calendar/day': typeof AuthedDashboardLLocationIdContentCalendarDayRoute
  '/dashboard/l/$locationId/content-calendar/month': typeof AuthedDashboardLLocationIdContentCalendarMonthRoute
  '/dashboard/l/$locationId/content-calendar/three-day': typeof AuthedDashboardLLocationIdContentCalendarThreeDayRoute
  '/dashboard/l/$locationId/content-calendar/week': typeof AuthedDashboardLLocationIdContentCalendarWeekRoute
  '/dashboard/l/$locationId/customers/$leadId': typeof AuthedDashboardLLocationIdCustomersLeadIdRouteWithChildren
  '/dashboard/l/$locationId/inventory/brands': typeof AuthedDashboardLLocationIdInventoryBrandsRoute
  '/dashboard/l/$locationId/inventory/categories': typeof AuthedDashboardLLocationIdInventoryCategoriesRoute
  '/dashboard/l/$locationId/inventory/stock-orders': typeof AuthedDashboardLLocationIdInventoryStockOrdersRoute
  '/dashboard/l/$locationId/inventory/stocktakes': typeof AuthedDashboardLLocationIdInventoryStocktakesRoute
  '/dashboard/l/$locationId/inventory/suppliers': typeof AuthedDashboardLLocationIdInventorySuppliersRoute
  '/dashboard/l/$locationId/marketing/lead-forms': typeof AuthedDashboardLLocationIdMarketingLeadFormsRoute
  '/dashboard/l/$locationId/marketing/sequences': typeof AuthedDashboardLLocationIdMarketingSequencesRoute
  '/dashboard/l/$locationId/sales/appointments': typeof AuthedDashboardLLocationIdSalesAppointmentsRoute
  '/dashboard/l/$locationId/sales/daily-summary': typeof AuthedDashboardLLocationIdSalesDailySummaryRoute
  '/dashboard/l/$locationId/sales/gift-cards': typeof AuthedDashboardLLocationIdSalesGiftCardsRoute
  '/dashboard/l/$locationId/sales/list': typeof AuthedDashboardLLocationIdSalesListRoute
  '/dashboard/l/$locationId/sales/memberships': typeof AuthedDashboardLLocationIdSalesMembershipsRoute
  '/dashboard/l/$locationId/sales/payments': typeof AuthedDashboardLLocationIdSalesPaymentsRoute
  '/dashboard/l/$locationId/sales/product-orders': typeof AuthedDashboardLLocationIdSalesProductOrdersRoute
  '/dashboard/l/$locationId/team/members': typeof AuthedDashboardLLocationIdTeamMembersRoute
  '/dashboard/l/$locationId/team/practitioners': typeof AuthedDashboardLLocationIdTeamPractitionersRoute
  '/dashboard/l/$locationId/team/shifts': typeof AuthedDashboardLLocationIdTeamShiftsRoute
  '/dashboard/l/$locationId/team/timesheets': typeof AuthedDashboardLLocationIdTeamTimesheetsRoute
  '/dashboard/l/$locationId/calendar': typeof AuthedDashboardLLocationIdCalendarIndexRoute
  '/dashboard/l/$locationId/catalog': typeof AuthedDashboardLLocationIdCatalogIndexRoute
  '/dashboard/l/$locationId/clients': typeof AuthedDashboardLLocationIdClientsIndexRoute
  '/dashboard/l/$locationId/content-calendar': typeof AuthedDashboardLLocationIdContentCalendarIndexRoute
  '/dashboard/l/$locationId/marketing': typeof AuthedDashboardLLocationIdMarketingIndexRoute
  '/dashboard/l/$locationId/sales': typeof AuthedDashboardLLocationIdSalesIndexRoute
  '/dashboard/l/$locationId/team': typeof AuthedDashboardLLocationIdTeamIndexRoute
  '/dashboard/l/$locationId/videos': typeof AuthedDashboardLLocationIdVideosIndexRoute
  '/dashboard/l/$locationId/calendar/appointment/$appointmentId': typeof AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRoute
  '/dashboard/l/$locationId/calendar/new/block': typeof AuthedDashboardLLocationIdCalendarNewBlockRoute
  '/dashboard/l/$locationId/calendar/new/client': typeof AuthedDashboardLLocationIdCalendarNewClientRoute
  '/dashboard/l/$locationId/calendar/rooms/day': typeof AuthedDashboardLLocationIdCalendarRoomsDayRoute
  '/dashboard/l/$locationId/calendar/rooms/month': typeof AuthedDashboardLLocationIdCalendarRoomsMonthRoute
  '/dashboard/l/$locationId/calendar/rooms/three-day': typeof AuthedDashboardLLocationIdCalendarRoomsThreeDayRoute
  '/dashboard/l/$locationId/calendar/rooms/week': typeof AuthedDashboardLLocationIdCalendarRoomsWeekRoute
  '/dashboard/l/$locationId/customers/$leadId/form': typeof AuthedDashboardLLocationIdCustomersLeadIdFormRoute
  '/dashboard/l/$locationId/marketing/advertising/new': typeof AuthedDashboardLLocationIdMarketingAdvertisingNewRoute
  '/dashboard/l/$locationId/marketing/gallery/images': typeof AuthedDashboardLLocationIdMarketingGalleryImagesRoute
  '/dashboard/l/$locationId/marketing/gallery/library': typeof AuthedDashboardLLocationIdMarketingGalleryLibraryRoute
  '/dashboard/l/$locationId/marketing/gallery/videos': typeof AuthedDashboardLLocationIdMarketingGalleryVideosRoute
  '/dashboard/l/$locationId/marketing/socials/recent': typeof AuthedDashboardLLocationIdMarketingSocialsRecentRoute
  '/dashboard/l/$locationId/marketing/socials/review': typeof AuthedDashboardLLocationIdMarketingSocialsReviewRoute
  '/dashboard/l/$locationId/marketing/socials/scheduled': typeof AuthedDashboardLLocationIdMarketingSocialsScheduledRoute
  '/dashboard/l/$locationId/calendar/new': typeof AuthedDashboardLLocationIdCalendarNewIndexRoute
  '/dashboard/l/$locationId/calendar/rooms': typeof AuthedDashboardLLocationIdCalendarRoomsIndexRoute
  '/dashboard/l/$locationId/catalog/services': typeof AuthedDashboardLLocationIdCatalogServicesIndexRoute
  '/dashboard/l/$locationId/marketing/advertising': typeof AuthedDashboardLLocationIdMarketingAdvertisingIndexRoute
  '/dashboard/l/$locationId/marketing/campaigns': typeof AuthedDashboardLLocationIdMarketingCampaignsIndexRoute
  '/dashboard/l/$locationId/marketing/gallery': typeof AuthedDashboardLLocationIdMarketingGalleryIndexRoute
  '/dashboard/l/$locationId/marketing/music': typeof AuthedDashboardLLocationIdMarketingMusicIndexRoute
  '/dashboard/l/$locationId/marketing/socials': typeof AuthedDashboardLLocationIdMarketingSocialsIndexRoute
  '/dashboard/l/$locationId/videos/create-from-client': typeof AuthedDashboardLLocationIdVideosCreateFromClientIndexRoute
  '/dashboard/l/$locationId/marketing/socials/post/$id': typeof AuthedDashboardLLocationIdMarketingSocialsPostIdRoute
  '/dashboard/l/$locationId/marketing/advertising/$id': typeof AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRoute
  '/dashboard/l/$locationId/marketing/campaigns/$id': typeof AuthedDashboardLLocationIdMarketingCampaignsIdIndexRoute
  '/dashboard/l/$locationId/marketing/campaigns/new': typeof AuthedDashboardLLocationIdMarketingCampaignsNewIndexRoute
  '/dashboard/l/$locationId/marketing/campaigns/segments': typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRoute
  '/dashboard/l/$locationId/marketing/gallery/new': typeof AuthedDashboardLLocationIdMarketingGalleryNewIndexRoute
  '/dashboard/l/$locationId/marketing/socials/new': typeof AuthedDashboardLLocationIdMarketingSocialsNewIndexRoute
  '/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId': typeof AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRoute
  '/dashboard/l/$locationId/marketing/campaigns/segments/new': typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/_authed': typeof AuthedRouteWithChildren
  '/_onboarding': typeof OnboardingRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/creative-lab': typeof CreativeLabRoute
  '/creative-lab-card': typeof CreativeLabCardRoute
  '/creative-lab-panel': typeof CreativeLabPanelRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/restore-organization': typeof RestoreOrganizationRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-2fa': typeof Verify2faRoute
  '/verify-email': typeof VerifyEmailRoute
  '/welcome': typeof WelcomeRouteWithChildren
  '/_admin/admin': typeof AdminAdminRouteWithChildren
  '/_authed/assistant': typeof AuthedAssistantRoute
  '/_authed/billing': typeof AuthedBillingRoute
  '/_authed/dashboard': typeof AuthedDashboardRouteWithChildren
  '/_authed/review-content': typeof AuthedReviewContentRoute
  '/_authed/website-preview': typeof AuthedWebsitePreviewRoute
  '/_authed/wireframe-fullscreen': typeof AuthedWireframeFullscreenRouteWithChildren
  '/_onboarding/onboarding': typeof OnboardingOnboardingRoute
  '/_onboarding/setup-profile': typeof OnboardingSetupProfileRoute
  '/_onboarding/upload-assets': typeof OnboardingUploadAssetsRoute
  '/connect/facebook': typeof ConnectFacebookRoute
  '/connect/whatsapp': typeof ConnectWhatsappRoute
  '/start/$token': typeof StartTokenRoute
  '/welcome/': typeof WelcomeIndexRoute
  '/_admin/admin/advertising': typeof AdminAdminAdvertisingRoute
  '/_admin/admin/audit-log': typeof AdminAdminAuditLogRoute
  '/_admin/admin/claire-failure-groups': typeof AdminAdminClaireFailureGroupsRoute
  '/_admin/admin/claire-regressions': typeof AdminAdminClaireRegressionsRoute
  '/_admin/admin/conversations': typeof AdminAdminConversationsRoute
  '/_admin/admin/crm-triggers': typeof AdminAdminCrmTriggersRoute
  '/_admin/admin/harness': typeof AdminAdminHarnessRoute
  '/_admin/admin/imports': typeof AdminAdminImportsRoute
  '/_admin/admin/meta-connections': typeof AdminAdminMetaConnectionsRoute
  '/_admin/admin/music': typeof AdminAdminMusicRoute
  '/_admin/admin/scraping': typeof AdminAdminScrapingRoute
  '/_admin/admin/stock-footage': typeof AdminAdminStockFootageRoute
  '/_admin/admin/stuck-setup': typeof AdminAdminStuckSetupRoute
  '/_authed/create/$entity': typeof AuthedCreateEntityRoute
  '/_authed/dashboard/$': typeof AuthedDashboardSplatRoute
  '/_authed/dashboard/account': typeof AuthedDashboardAccountRoute
  '/_authed/dashboard/brand': typeof AuthedDashboardBrandRoute
  '/_authed/dashboard/chatbots': typeof AuthedDashboardChatbotsRoute
  '/_authed/dashboard/conversations': typeof AuthedDashboardConversationsRoute
  '/_authed/dashboard/intake-forms': typeof AuthedDashboardIntakeFormsRoute
  '/_authed/dashboard/integrations': typeof AuthedDashboardIntegrationsRoute
  '/_authed/dashboard/lead-forms': typeof AuthedDashboardLeadFormsRoute
  '/_authed/dashboard/lead-management': typeof AuthedDashboardLeadManagementRoute
  '/_authed/dashboard/locations': typeof AuthedDashboardLocationsRoute
  '/_authed/dashboard/notifications': typeof AuthedDashboardNotificationsRoute
  '/_authed/dashboard/offers': typeof AuthedDashboardOffersRoute
  '/_authed/dashboard/organisation': typeof AuthedDashboardOrganisationRoute
  '/_authed/dashboard/reports': typeof AuthedDashboardReportsRoute
  '/_authed/dashboard/reset': typeof AuthedDashboardResetRoute
  '/_authed/dashboard/retention': typeof AuthedDashboardRetentionRoute
  '/_authed/dashboard/reviews': typeof AuthedDashboardReviewsRoute
  '/_authed/dashboard/settings': typeof AuthedDashboardSettingsRouteWithChildren
  '/_authed/dashboard/template-preview': typeof AuthedDashboardTemplatePreviewRoute
  '/_authed/dashboard/training-hub': typeof AuthedDashboardTrainingHubRoute
  '/_authed/dashboard/voice-test': typeof AuthedDashboardVoiceTestRoute
  '/_authed/dashboard/website': typeof AuthedDashboardWebsiteRoute
  '/_authed/dashboard/wireframes': typeof AuthedDashboardWireframesRouteWithChildren
  '/_authed/record/$videoId': typeof AuthedRecordVideoIdRoute
  '/_authed/settings/claire': typeof AuthedSettingsClaireRouteWithChildren
  '/_authed/wireframe-fullscreen/annotate': typeof AuthedWireframeFullscreenAnnotateRoute
  '/_authed/wireframe-fullscreen/compare': typeof AuthedWireframeFullscreenCompareRoute
  '/_authed/wireframe-fullscreen/consent-kiosk': typeof AuthedWireframeFullscreenConsentKioskRoute
  '/_authed/wireframe-fullscreen/scribe': typeof AuthedWireframeFullscreenScribeRoute
  '/connect/stripe/done': typeof ConnectStripeDoneRoute
  '/forms/$organizationSlug/$token': typeof FormsOrganizationSlugTokenRoute
  '/venue/$organizationSlug/$locationSlug': typeof VenueOrganizationSlugLocationSlugRoute
  '/_admin/admin/': typeof AdminAdminIndexRoute
  '/_authed/create-video/': typeof AuthedCreateVideoIndexRoute
  '/_authed/dashboard/': typeof AuthedDashboardIndexRoute
  '/_authed/record/': typeof AuthedRecordIndexRoute
  '/opt-in/$organizationSlug/': typeof OptInOrganizationSlugIndexRoute
  '/venue/$organizationSlug/': typeof VenueOrganizationSlugIndexRoute
  '/_admin/admin/organizations/$id': typeof AdminAdminOrganizationsIdRoute
  '/_authed/ads/new/video-format': typeof AuthedAdsNewVideoFormatRoute
  '/_authed/dashboard/advertising/new': typeof AuthedDashboardAdvertisingNewRoute
  '/_authed/dashboard/appointments/agenda': typeof AuthedDashboardAppointmentsAgendaRoute
  '/_authed/dashboard/appointments/day': typeof AuthedDashboardAppointmentsDayRoute
  '/_authed/dashboard/appointments/month': typeof AuthedDashboardAppointmentsMonthRoute
  '/_authed/dashboard/appointments/week': typeof AuthedDashboardAppointmentsWeekRoute
  '/_authed/dashboard/appointments/year': typeof AuthedDashboardAppointmentsYearRoute
  '/_authed/dashboard/content/gallery': typeof AuthedDashboardContentGalleryRoute
  '/_authed/dashboard/content/images': typeof AuthedDashboardContentImagesRoute
  '/_authed/dashboard/content/library': typeof AuthedDashboardContentLibraryRoute
  '/_authed/dashboard/content/new': typeof AuthedDashboardContentNewRoute
  '/_authed/dashboard/content/videos': typeof AuthedDashboardContentVideosRoute
  '/_authed/dashboard/debug/analysis-split-test': typeof AuthedDashboardDebugAnalysisSplitTestRoute
  '/_authed/dashboard/l/$locationId': typeof AuthedDashboardLLocationIdRouteWithChildren
  '/_authed/dashboard/more/$section': typeof AuthedDashboardMoreSectionRoute
  '/_authed/dashboard/services/new': typeof AuthedDashboardServicesNewRoute
  '/_authed/dashboard/settings/billing': typeof AuthedDashboardSettingsBillingRoute
  '/_authed/dashboard/settings/blocked-time-types': typeof AuthedDashboardSettingsBlockedTimeTypesRoute
  '/_authed/dashboard/settings/bookings': typeof AuthedDashboardSettingsBookingsRoute
  '/_authed/dashboard/settings/cancellations': typeof AuthedDashboardSettingsCancellationsRoute
  '/_authed/dashboard/settings/chatbot': typeof AuthedDashboardSettingsChatbotRoute
  '/_authed/dashboard/settings/claire-campaigns': typeof AuthedDashboardSettingsClaireCampaignsRoute
  '/_authed/dashboard/settings/claire-memories': typeof AuthedDashboardSettingsClaireMemoriesRoute
  '/_authed/dashboard/settings/claire-whatsapp': typeof AuthedDashboardSettingsClaireWhatsappRoute
  '/_authed/dashboard/settings/consent-forms': typeof AuthedDashboardSettingsConsentFormsRoute
  '/_authed/dashboard/settings/consent-privacy': typeof AuthedDashboardSettingsConsentPrivacyRoute
  '/_authed/dashboard/settings/delete-account': typeof AuthedDashboardSettingsDeleteAccountRoute
  '/_authed/dashboard/settings/details': typeof AuthedDashboardSettingsDetailsRoute
  '/_authed/dashboard/settings/examples': typeof AuthedDashboardSettingsExamplesRoute
  '/_authed/dashboard/settings/form-templates': typeof AuthedDashboardSettingsFormTemplatesRouteWithChildren
  '/_authed/dashboard/settings/integrations': typeof AuthedDashboardSettingsIntegrationsRoute
  '/_authed/dashboard/settings/message-templates': typeof AuthedDashboardSettingsMessageTemplatesRoute
  '/_authed/dashboard/settings/notifications': typeof AuthedDashboardSettingsNotificationsRoute
  '/_authed/dashboard/settings/payments': typeof AuthedDashboardSettingsPaymentsRoute
  '/_authed/dashboard/settings/post-treatment-reviews': typeof AuthedDashboardSettingsPostTreatmentReviewsRoute
  '/_authed/dashboard/settings/reminders': typeof AuthedDashboardSettingsRemindersRoute
  '/_authed/dashboard/settings/scheduling': typeof AuthedDashboardSettingsSchedulingRoute
  '/_authed/dashboard/settings/style': typeof AuthedDashboardSettingsStyleRoute
  '/_authed/dashboard/socials/new': typeof AuthedDashboardSocialsNewRoute
  '/_authed/dashboard/socials/recent': typeof AuthedDashboardSocialsRecentRoute
  '/_authed/dashboard/socials/review': typeof AuthedDashboardSocialsReviewRoute
  '/_authed/dashboard/socials/scheduled': typeof AuthedDashboardSocialsScheduledRoute
  '/_authed/dashboard/wireframes/calendar-day': typeof AuthedDashboardWireframesCalendarDayRoute
  '/_authed/dashboard/wireframes/calendar-side-panel': typeof AuthedDashboardWireframesCalendarSidePanelRoute
  '/_authed/dashboard/wireframes/calendar-week': typeof AuthedDashboardWireframesCalendarWeekRoute
  '/_authed/dashboard/wireframes/consent-compliance': typeof AuthedDashboardWireframesConsentComplianceRoute
  '/_authed/dashboard/wireframes/data-privacy': typeof AuthedDashboardWireframesDataPrivacyRoute
  '/_authed/dashboard/wireframes/deposits': typeof AuthedDashboardWireframesDepositsRoute
  '/_authed/dashboard/wireframes/photos': typeof AuthedDashboardWireframesPhotosRoute
  '/_authed/dashboard/wireframes/reminders-settings': typeof AuthedDashboardWireframesRemindersSettingsRoute
  '/_authed/dashboard/wireframes/reports': typeof AuthedDashboardWireframesReportsRoute
  '/_authed/dashboard/wireframes/retention': typeof AuthedDashboardWireframesRetentionRoute
  '/_authed/dashboard/wireframes/reviews': typeof AuthedDashboardWireframesReviewsRoute
  '/_authed/dashboard/wireframes/search': typeof AuthedDashboardWireframesSearchRoute
  '/_authed/dashboard/wireframes/sequences': typeof AuthedDashboardWireframesSequencesRoute
  '/_authed/dashboard/wireframes/settings': typeof AuthedDashboardWireframesSettingsRoute
  '/_authed/dashboard/wireframes/skin-analysis': typeof AuthedDashboardWireframesSkinAnalysisRoute
  '/_authed/dashboard/wireframes/view-shell': typeof AuthedDashboardWireframesViewShellRoute
  '/_authed/edit/$entity/$id': typeof AuthedEditEntityIdRoute
  '/_authed/settings/claire/usage': typeof AuthedSettingsClaireUsageRoute
  '/_authed/settings/claire/whatsapp': typeof AuthedSettingsClaireWhatsappRoute
  '/_authed/team/repeating-shifts/$practitionerId': typeof AuthedTeamRepeatingShiftsPractitionerIdRoute
  '/_authed/ads/new/': typeof AuthedAdsNewIndexRoute
  '/_authed/connect/meta-ads/': typeof AuthedConnectMetaAdsIndexRoute
  '/_authed/create-video/$templateId/': typeof AuthedCreateVideoTemplateIdIndexRoute
  '/_authed/dashboard/advertising/': typeof AuthedDashboardAdvertisingIndexRoute
  '/_authed/dashboard/appointments/': typeof AuthedDashboardAppointmentsIndexRoute
  '/_authed/dashboard/content/': typeof AuthedDashboardContentIndexRoute
  '/_authed/dashboard/debug/': typeof AuthedDashboardDebugIndexRoute
  '/_authed/dashboard/more/': typeof AuthedDashboardMoreIndexRoute
  '/_authed/dashboard/services/': typeof AuthedDashboardServicesIndexRoute
  '/_authed/dashboard/settings/': typeof AuthedDashboardSettingsIndexRoute
  '/_authed/dashboard/socials/': typeof AuthedDashboardSocialsIndexRoute
  '/_authed/dashboard/wireframes/': typeof AuthedDashboardWireframesIndexRoute
  '/_authed/dashboard/appointments/new/block': typeof AuthedDashboardAppointmentsNewBlockRoute
  '/_authed/dashboard/appointments/new/client': typeof AuthedDashboardAppointmentsNewClientRoute
  '/_authed/dashboard/l/$locationId/ai-assistant': typeof AuthedDashboardLLocationIdAiAssistantRoute
  '/_authed/dashboard/l/$locationId/calendar': typeof AuthedDashboardLLocationIdCalendarRouteWithChildren
  '/_authed/dashboard/l/$locationId/clients': typeof AuthedDashboardLLocationIdClientsRouteWithChildren
  '/_authed/dashboard/l/$locationId/content-calendar': typeof AuthedDashboardLLocationIdContentCalendarRouteWithChildren
  '/_authed/dashboard/l/$locationId/customers': typeof AuthedDashboardLLocationIdCustomersRouteWithChildren
  '/_authed/dashboard/l/$locationId/deposits': typeof AuthedDashboardLLocationIdDepositsRoute
  '/_authed/dashboard/l/$locationId/home': typeof AuthedDashboardLLocationIdHomeRoute
  '/_authed/dashboard/l/$locationId/marketing': typeof AuthedDashboardLLocationIdMarketingRouteWithChildren
  '/_authed/dashboard/l/$locationId/public-site': typeof AuthedDashboardLLocationIdPublicSiteRoute
  '/_authed/dashboard/l/$locationId/sales': typeof AuthedDashboardLLocationIdSalesRouteWithChildren
  '/_authed/dashboard/l/$locationId/venue': typeof AuthedDashboardLLocationIdVenueRoute
  '/_authed/dashboard/services/$serviceId/edit': typeof AuthedDashboardServicesServiceIdEditRoute
  '/_authed/dashboard/settings/form-templates/$formId': typeof AuthedDashboardSettingsFormTemplatesFormIdRoute
  '/_authed/dashboard/socials/post/$id': typeof AuthedDashboardSocialsPostIdRoute
  '/_authed/dashboard/advertising/$id/': typeof AuthedDashboardAdvertisingIdIndexRoute
  '/_authed/dashboard/appointments/new/': typeof AuthedDashboardAppointmentsNewIndexRoute
  '/_authed/dashboard/settings/form-templates/': typeof AuthedDashboardSettingsFormTemplatesIndexRoute
  '/_authed/dashboard/l/$locationId/calendar/new': typeof AuthedDashboardLLocationIdCalendarNewRouteRouteWithChildren
  '/_authed/dashboard/advertising/$id/ads/$adId': typeof AuthedDashboardAdvertisingIdAdsAdIdRoute
  '/_authed/dashboard/l/$locationId/calendar/agenda': typeof AuthedDashboardLLocationIdCalendarAgendaRoute
  '/_authed/dashboard/l/$locationId/calendar/day': typeof AuthedDashboardLLocationIdCalendarDayRoute
  '/_authed/dashboard/l/$locationId/calendar/month': typeof AuthedDashboardLLocationIdCalendarMonthRoute
  '/_authed/dashboard/l/$locationId/calendar/rooms': typeof AuthedDashboardLLocationIdCalendarRoomsRouteWithChildren
  '/_authed/dashboard/l/$locationId/calendar/three-day': typeof AuthedDashboardLLocationIdCalendarThreeDayRoute
  '/_authed/dashboard/l/$locationId/calendar/week': typeof AuthedDashboardLLocationIdCalendarWeekRoute
  '/_authed/dashboard/l/$locationId/calendar/year': typeof AuthedDashboardLLocationIdCalendarYearRoute
  '/_authed/dashboard/l/$locationId/catalog/brands': typeof AuthedDashboardLLocationIdCatalogBrandsRoute
  '/_authed/dashboard/l/$locationId/catalog/categories': typeof AuthedDashboardLLocationIdCatalogCategoriesRoute
  '/_authed/dashboard/l/$locationId/catalog/memberships': typeof AuthedDashboardLLocationIdCatalogMembershipsRoute
  '/_authed/dashboard/l/$locationId/catalog/offers': typeof AuthedDashboardLLocationIdCatalogOffersRoute
  '/_authed/dashboard/l/$locationId/catalog/packages': typeof AuthedDashboardLLocationIdCatalogPackagesRoute
  '/_authed/dashboard/l/$locationId/catalog/products': typeof AuthedDashboardLLocationIdCatalogProductsRoute
  '/_authed/dashboard/l/$locationId/catalog/resources': typeof AuthedDashboardLLocationIdCatalogResourcesRoute
  '/_authed/dashboard/l/$locationId/catalog/services': typeof AuthedDashboardLLocationIdCatalogServicesRouteWithChildren
  '/_authed/dashboard/l/$locationId/catalog/stock-orders': typeof AuthedDashboardLLocationIdCatalogStockOrdersRoute
  '/_authed/dashboard/l/$locationId/catalog/stocktakes': typeof AuthedDashboardLLocationIdCatalogStocktakesRoute
  '/_authed/dashboard/l/$locationId/catalog/suppliers': typeof AuthedDashboardLLocationIdCatalogSuppliersRoute
  '/_authed/dashboard/l/$locationId/clients/$leadId': typeof AuthedDashboardLLocationIdClientsLeadIdRoute
  '/_authed/dashboard/l/$locationId/clients/inbox': typeof AuthedDashboardLLocationIdClientsInboxRoute
  '/_authed/dashboard/l/$locationId/clients/list': typeof AuthedDashboardLLocationIdClientsListRoute
  '/_authed/dashboard/l/$locationId/content-calendar/day': typeof AuthedDashboardLLocationIdContentCalendarDayRoute
  '/_authed/dashboard/l/$locationId/content-calendar/month': typeof AuthedDashboardLLocationIdContentCalendarMonthRoute
  '/_authed/dashboard/l/$locationId/content-calendar/three-day': typeof AuthedDashboardLLocationIdContentCalendarThreeDayRoute
  '/_authed/dashboard/l/$locationId/content-calendar/week': typeof AuthedDashboardLLocationIdContentCalendarWeekRoute
  '/_authed/dashboard/l/$locationId/customers/$leadId': typeof AuthedDashboardLLocationIdCustomersLeadIdRouteWithChildren
  '/_authed/dashboard/l/$locationId/inventory/brands': typeof AuthedDashboardLLocationIdInventoryBrandsRoute
  '/_authed/dashboard/l/$locationId/inventory/categories': typeof AuthedDashboardLLocationIdInventoryCategoriesRoute
  '/_authed/dashboard/l/$locationId/inventory/stock-orders': typeof AuthedDashboardLLocationIdInventoryStockOrdersRoute
  '/_authed/dashboard/l/$locationId/inventory/stocktakes': typeof AuthedDashboardLLocationIdInventoryStocktakesRoute
  '/_authed/dashboard/l/$locationId/inventory/suppliers': typeof AuthedDashboardLLocationIdInventorySuppliersRoute
  '/_authed/dashboard/l/$locationId/marketing/advertising': typeof AuthedDashboardLLocationIdMarketingAdvertisingRouteWithChildren
  '/_authed/dashboard/l/$locationId/marketing/lead-forms': typeof AuthedDashboardLLocationIdMarketingLeadFormsRoute
  '/_authed/dashboard/l/$locationId/marketing/sequences': typeof AuthedDashboardLLocationIdMarketingSequencesRoute
  '/_authed/dashboard/l/$locationId/marketing/socials': typeof AuthedDashboardLLocationIdMarketingSocialsRouteWithChildren
  '/_authed/dashboard/l/$locationId/sales/appointments': typeof AuthedDashboardLLocationIdSalesAppointmentsRoute
  '/_authed/dashboard/l/$locationId/sales/daily-summary': typeof AuthedDashboardLLocationIdSalesDailySummaryRoute
  '/_authed/dashboard/l/$locationId/sales/gift-cards': typeof AuthedDashboardLLocationIdSalesGiftCardsRoute
  '/_authed/dashboard/l/$locationId/sales/list': typeof AuthedDashboardLLocationIdSalesListRoute
  '/_authed/dashboard/l/$locationId/sales/memberships': typeof AuthedDashboardLLocationIdSalesMembershipsRoute
  '/_authed/dashboard/l/$locationId/sales/payments': typeof AuthedDashboardLLocationIdSalesPaymentsRoute
  '/_authed/dashboard/l/$locationId/sales/product-orders': typeof AuthedDashboardLLocationIdSalesProductOrdersRoute
  '/_authed/dashboard/l/$locationId/team/members': typeof AuthedDashboardLLocationIdTeamMembersRoute
  '/_authed/dashboard/l/$locationId/team/practitioners': typeof AuthedDashboardLLocationIdTeamPractitionersRoute
  '/_authed/dashboard/l/$locationId/team/shifts': typeof AuthedDashboardLLocationIdTeamShiftsRoute
  '/_authed/dashboard/l/$locationId/team/timesheets': typeof AuthedDashboardLLocationIdTeamTimesheetsRoute
  '/_authed/dashboard/l/$locationId/calendar/': typeof AuthedDashboardLLocationIdCalendarIndexRoute
  '/_authed/dashboard/l/$locationId/catalog/': typeof AuthedDashboardLLocationIdCatalogIndexRoute
  '/_authed/dashboard/l/$locationId/clients/': typeof AuthedDashboardLLocationIdClientsIndexRoute
  '/_authed/dashboard/l/$locationId/content-calendar/': typeof AuthedDashboardLLocationIdContentCalendarIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/': typeof AuthedDashboardLLocationIdMarketingIndexRoute
  '/_authed/dashboard/l/$locationId/sales/': typeof AuthedDashboardLLocationIdSalesIndexRoute
  '/_authed/dashboard/l/$locationId/team/': typeof AuthedDashboardLLocationIdTeamIndexRoute
  '/_authed/dashboard/l/$locationId/videos/': typeof AuthedDashboardLLocationIdVideosIndexRoute
  '/_authed/dashboard/l/$locationId/calendar/appointment/$appointmentId': typeof AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRoute
  '/_authed/dashboard/l/$locationId/calendar/new/block': typeof AuthedDashboardLLocationIdCalendarNewBlockRoute
  '/_authed/dashboard/l/$locationId/calendar/new/client': typeof AuthedDashboardLLocationIdCalendarNewClientRoute
  '/_authed/dashboard/l/$locationId/calendar/rooms/day': typeof AuthedDashboardLLocationIdCalendarRoomsDayRoute
  '/_authed/dashboard/l/$locationId/calendar/rooms/month': typeof AuthedDashboardLLocationIdCalendarRoomsMonthRoute
  '/_authed/dashboard/l/$locationId/calendar/rooms/three-day': typeof AuthedDashboardLLocationIdCalendarRoomsThreeDayRoute
  '/_authed/dashboard/l/$locationId/calendar/rooms/week': typeof AuthedDashboardLLocationIdCalendarRoomsWeekRoute
  '/_authed/dashboard/l/$locationId/customers/$leadId/form': typeof AuthedDashboardLLocationIdCustomersLeadIdFormRoute
  '/_authed/dashboard/l/$locationId/marketing/advertising/new': typeof AuthedDashboardLLocationIdMarketingAdvertisingNewRoute
  '/_authed/dashboard/l/$locationId/marketing/gallery/images': typeof AuthedDashboardLLocationIdMarketingGalleryImagesRoute
  '/_authed/dashboard/l/$locationId/marketing/gallery/library': typeof AuthedDashboardLLocationIdMarketingGalleryLibraryRoute
  '/_authed/dashboard/l/$locationId/marketing/gallery/videos': typeof AuthedDashboardLLocationIdMarketingGalleryVideosRoute
  '/_authed/dashboard/l/$locationId/marketing/socials/recent': typeof AuthedDashboardLLocationIdMarketingSocialsRecentRoute
  '/_authed/dashboard/l/$locationId/marketing/socials/review': typeof AuthedDashboardLLocationIdMarketingSocialsReviewRoute
  '/_authed/dashboard/l/$locationId/marketing/socials/scheduled': typeof AuthedDashboardLLocationIdMarketingSocialsScheduledRoute
  '/_authed/dashboard/l/$locationId/calendar/new/': typeof AuthedDashboardLLocationIdCalendarNewIndexRoute
  '/_authed/dashboard/l/$locationId/calendar/rooms/': typeof AuthedDashboardLLocationIdCalendarRoomsIndexRoute
  '/_authed/dashboard/l/$locationId/catalog/services/': typeof AuthedDashboardLLocationIdCatalogServicesIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/advertising/': typeof AuthedDashboardLLocationIdMarketingAdvertisingIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/campaigns/': typeof AuthedDashboardLLocationIdMarketingCampaignsIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/gallery/': typeof AuthedDashboardLLocationIdMarketingGalleryIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/music/': typeof AuthedDashboardLLocationIdMarketingMusicIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/socials/': typeof AuthedDashboardLLocationIdMarketingSocialsIndexRoute
  '/_authed/dashboard/l/$locationId/videos/create-from-client/': typeof AuthedDashboardLLocationIdVideosCreateFromClientIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/socials/post/$id': typeof AuthedDashboardLLocationIdMarketingSocialsPostIdRoute
  '/_authed/dashboard/l/$locationId/marketing/advertising/$id/': typeof AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/campaigns/$id/': typeof AuthedDashboardLLocationIdMarketingCampaignsIdIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/campaigns/new/': typeof AuthedDashboardLLocationIdMarketingCampaignsNewIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/campaigns/segments/': typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/gallery/new/': typeof AuthedDashboardLLocationIdMarketingGalleryNewIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/socials/new/': typeof AuthedDashboardLLocationIdMarketingSocialsNewIndexRoute
  '/_authed/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId': typeof AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRoute
  '/_authed/dashboard/l/$locationId/marketing/campaigns/segments/new/': typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/creative-lab'
    | '/creative-lab-card'
    | '/creative-lab-panel'
    | '/forgot-password'
    | '/reset-password'
    | '/restore-organization'
    | '/sign-in'
    | '/sign-up'
    | '/verify-2fa'
    | '/verify-email'
    | '/welcome'
    | '/admin'
    | '/assistant'
    | '/billing'
    | '/dashboard'
    | '/review-content'
    | '/website-preview'
    | '/wireframe-fullscreen'
    | '/onboarding'
    | '/setup-profile'
    | '/upload-assets'
    | '/connect/facebook'
    | '/connect/whatsapp'
    | '/start/$token'
    | '/welcome/'
    | '/admin/advertising'
    | '/admin/audit-log'
    | '/admin/claire-failure-groups'
    | '/admin/claire-regressions'
    | '/admin/conversations'
    | '/admin/crm-triggers'
    | '/admin/harness'
    | '/admin/imports'
    | '/admin/meta-connections'
    | '/admin/music'
    | '/admin/scraping'
    | '/admin/stock-footage'
    | '/admin/stuck-setup'
    | '/create/$entity'
    | '/dashboard/$'
    | '/dashboard/account'
    | '/dashboard/brand'
    | '/dashboard/chatbots'
    | '/dashboard/conversations'
    | '/dashboard/intake-forms'
    | '/dashboard/integrations'
    | '/dashboard/lead-forms'
    | '/dashboard/lead-management'
    | '/dashboard/locations'
    | '/dashboard/notifications'
    | '/dashboard/offers'
    | '/dashboard/organisation'
    | '/dashboard/reports'
    | '/dashboard/reset'
    | '/dashboard/retention'
    | '/dashboard/reviews'
    | '/dashboard/settings'
    | '/dashboard/template-preview'
    | '/dashboard/training-hub'
    | '/dashboard/voice-test'
    | '/dashboard/website'
    | '/dashboard/wireframes'
    | '/record/$videoId'
    | '/settings/claire'
    | '/wireframe-fullscreen/annotate'
    | '/wireframe-fullscreen/compare'
    | '/wireframe-fullscreen/consent-kiosk'
    | '/wireframe-fullscreen/scribe'
    | '/connect/stripe/done'
    | '/forms/$organizationSlug/$token'
    | '/venue/$organizationSlug/$locationSlug'
    | '/admin/'
    | '/create-video/'
    | '/dashboard/'
    | '/record/'
    | '/opt-in/$organizationSlug/'
    | '/venue/$organizationSlug/'
    | '/admin/organizations/$id'
    | '/ads/new/video-format'
    | '/dashboard/advertising/new'
    | '/dashboard/appointments/agenda'
    | '/dashboard/appointments/day'
    | '/dashboard/appointments/month'
    | '/dashboard/appointments/week'
    | '/dashboard/appointments/year'
    | '/dashboard/content/gallery'
    | '/dashboard/content/images'
    | '/dashboard/content/library'
    | '/dashboard/content/new'
    | '/dashboard/content/videos'
    | '/dashboard/debug/analysis-split-test'
    | '/dashboard/l/$locationId'
    | '/dashboard/more/$section'
    | '/dashboard/services/new'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/blocked-time-types'
    | '/dashboard/settings/bookings'
    | '/dashboard/settings/cancellations'
    | '/dashboard/settings/chatbot'
    | '/dashboard/settings/claire-campaigns'
    | '/dashboard/settings/claire-memories'
    | '/dashboard/settings/claire-whatsapp'
    | '/dashboard/settings/consent-forms'
    | '/dashboard/settings/consent-privacy'
    | '/dashboard/settings/delete-account'
    | '/dashboard/settings/details'
    | '/dashboard/settings/examples'
    | '/dashboard/settings/form-templates'
    | '/dashboard/settings/integrations'
    | '/dashboard/settings/message-templates'
    | '/dashboard/settings/notifications'
    | '/dashboard/settings/payments'
    | '/dashboard/settings/post-treatment-reviews'
    | '/dashboard/settings/reminders'
    | '/dashboard/settings/scheduling'
    | '/dashboard/settings/style'
    | '/dashboard/socials/new'
    | '/dashboard/socials/recent'
    | '/dashboard/socials/review'
    | '/dashboard/socials/scheduled'
    | '/dashboard/wireframes/calendar-day'
    | '/dashboard/wireframes/calendar-side-panel'
    | '/dashboard/wireframes/calendar-week'
    | '/dashboard/wireframes/consent-compliance'
    | '/dashboard/wireframes/data-privacy'
    | '/dashboard/wireframes/deposits'
    | '/dashboard/wireframes/photos'
    | '/dashboard/wireframes/reminders-settings'
    | '/dashboard/wireframes/reports'
    | '/dashboard/wireframes/retention'
    | '/dashboard/wireframes/reviews'
    | '/dashboard/wireframes/search'
    | '/dashboard/wireframes/sequences'
    | '/dashboard/wireframes/settings'
    | '/dashboard/wireframes/skin-analysis'
    | '/dashboard/wireframes/view-shell'
    | '/edit/$entity/$id'
    | '/settings/claire/usage'
    | '/settings/claire/whatsapp'
    | '/team/repeating-shifts/$practitionerId'
    | '/ads/new/'
    | '/connect/meta-ads/'
    | '/create-video/$templateId/'
    | '/dashboard/advertising/'
    | '/dashboard/appointments/'
    | '/dashboard/content/'
    | '/dashboard/debug/'
    | '/dashboard/more/'
    | '/dashboard/services/'
    | '/dashboard/settings/'
    | '/dashboard/socials/'
    | '/dashboard/wireframes/'
    | '/dashboard/appointments/new/block'
    | '/dashboard/appointments/new/client'
    | '/dashboard/l/$locationId/ai-assistant'
    | '/dashboard/l/$locationId/calendar'
    | '/dashboard/l/$locationId/clients'
    | '/dashboard/l/$locationId/content-calendar'
    | '/dashboard/l/$locationId/customers'
    | '/dashboard/l/$locationId/deposits'
    | '/dashboard/l/$locationId/home'
    | '/dashboard/l/$locationId/marketing'
    | '/dashboard/l/$locationId/public-site'
    | '/dashboard/l/$locationId/sales'
    | '/dashboard/l/$locationId/venue'
    | '/dashboard/services/$serviceId/edit'
    | '/dashboard/settings/form-templates/$formId'
    | '/dashboard/socials/post/$id'
    | '/dashboard/advertising/$id/'
    | '/dashboard/appointments/new/'
    | '/dashboard/settings/form-templates/'
    | '/dashboard/l/$locationId/calendar/new'
    | '/dashboard/advertising/$id/ads/$adId'
    | '/dashboard/l/$locationId/calendar/agenda'
    | '/dashboard/l/$locationId/calendar/day'
    | '/dashboard/l/$locationId/calendar/month'
    | '/dashboard/l/$locationId/calendar/rooms'
    | '/dashboard/l/$locationId/calendar/three-day'
    | '/dashboard/l/$locationId/calendar/week'
    | '/dashboard/l/$locationId/calendar/year'
    | '/dashboard/l/$locationId/catalog/brands'
    | '/dashboard/l/$locationId/catalog/categories'
    | '/dashboard/l/$locationId/catalog/memberships'
    | '/dashboard/l/$locationId/catalog/offers'
    | '/dashboard/l/$locationId/catalog/packages'
    | '/dashboard/l/$locationId/catalog/products'
    | '/dashboard/l/$locationId/catalog/resources'
    | '/dashboard/l/$locationId/catalog/services'
    | '/dashboard/l/$locationId/catalog/stock-orders'
    | '/dashboard/l/$locationId/catalog/stocktakes'
    | '/dashboard/l/$locationId/catalog/suppliers'
    | '/dashboard/l/$locationId/clients/$leadId'
    | '/dashboard/l/$locationId/clients/inbox'
    | '/dashboard/l/$locationId/clients/list'
    | '/dashboard/l/$locationId/content-calendar/day'
    | '/dashboard/l/$locationId/content-calendar/month'
    | '/dashboard/l/$locationId/content-calendar/three-day'
    | '/dashboard/l/$locationId/content-calendar/week'
    | '/dashboard/l/$locationId/customers/$leadId'
    | '/dashboard/l/$locationId/inventory/brands'
    | '/dashboard/l/$locationId/inventory/categories'
    | '/dashboard/l/$locationId/inventory/stock-orders'
    | '/dashboard/l/$locationId/inventory/stocktakes'
    | '/dashboard/l/$locationId/inventory/suppliers'
    | '/dashboard/l/$locationId/marketing/advertising'
    | '/dashboard/l/$locationId/marketing/lead-forms'
    | '/dashboard/l/$locationId/marketing/sequences'
    | '/dashboard/l/$locationId/marketing/socials'
    | '/dashboard/l/$locationId/sales/appointments'
    | '/dashboard/l/$locationId/sales/daily-summary'
    | '/dashboard/l/$locationId/sales/gift-cards'
    | '/dashboard/l/$locationId/sales/list'
    | '/dashboard/l/$locationId/sales/memberships'
    | '/dashboard/l/$locationId/sales/payments'
    | '/dashboard/l/$locationId/sales/product-orders'
    | '/dashboard/l/$locationId/team/members'
    | '/dashboard/l/$locationId/team/practitioners'
    | '/dashboard/l/$locationId/team/shifts'
    | '/dashboard/l/$locationId/team/timesheets'
    | '/dashboard/l/$locationId/calendar/'
    | '/dashboard/l/$locationId/catalog/'
    | '/dashboard/l/$locationId/clients/'
    | '/dashboard/l/$locationId/content-calendar/'
    | '/dashboard/l/$locationId/marketing/'
    | '/dashboard/l/$locationId/sales/'
    | '/dashboard/l/$locationId/team/'
    | '/dashboard/l/$locationId/videos/'
    | '/dashboard/l/$locationId/calendar/appointment/$appointmentId'
    | '/dashboard/l/$locationId/calendar/new/block'
    | '/dashboard/l/$locationId/calendar/new/client'
    | '/dashboard/l/$locationId/calendar/rooms/day'
    | '/dashboard/l/$locationId/calendar/rooms/month'
    | '/dashboard/l/$locationId/calendar/rooms/three-day'
    | '/dashboard/l/$locationId/calendar/rooms/week'
    | '/dashboard/l/$locationId/customers/$leadId/form'
    | '/dashboard/l/$locationId/marketing/advertising/new'
    | '/dashboard/l/$locationId/marketing/gallery/images'
    | '/dashboard/l/$locationId/marketing/gallery/library'
    | '/dashboard/l/$locationId/marketing/gallery/videos'
    | '/dashboard/l/$locationId/marketing/socials/recent'
    | '/dashboard/l/$locationId/marketing/socials/review'
    | '/dashboard/l/$locationId/marketing/socials/scheduled'
    | '/dashboard/l/$locationId/calendar/new/'
    | '/dashboard/l/$locationId/calendar/rooms/'
    | '/dashboard/l/$locationId/catalog/services/'
    | '/dashboard/l/$locationId/marketing/advertising/'
    | '/dashboard/l/$locationId/marketing/campaigns/'
    | '/dashboard/l/$locationId/marketing/gallery/'
    | '/dashboard/l/$locationId/marketing/music/'
    | '/dashboard/l/$locationId/marketing/socials/'
    | '/dashboard/l/$locationId/videos/create-from-client/'
    | '/dashboard/l/$locationId/marketing/socials/post/$id'
    | '/dashboard/l/$locationId/marketing/advertising/$id/'
    | '/dashboard/l/$locationId/marketing/campaigns/$id/'
    | '/dashboard/l/$locationId/marketing/campaigns/new/'
    | '/dashboard/l/$locationId/marketing/campaigns/segments/'
    | '/dashboard/l/$locationId/marketing/gallery/new/'
    | '/dashboard/l/$locationId/marketing/socials/new/'
    | '/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId'
    | '/dashboard/l/$locationId/marketing/campaigns/segments/new/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invitation'
    | '/creative-lab'
    | '/creative-lab-card'
    | '/creative-lab-panel'
    | '/forgot-password'
    | '/reset-password'
    | '/restore-organization'
    | '/sign-in'
    | '/sign-up'
    | '/verify-2fa'
    | '/verify-email'
    | '/assistant'
    | '/billing'
    | '/review-content'
    | '/website-preview'
    | '/wireframe-fullscreen'
    | '/onboarding'
    | '/setup-profile'
    | '/upload-assets'
    | '/connect/facebook'
    | '/connect/whatsapp'
    | '/start/$token'
    | '/welcome'
    | '/admin/advertising'
    | '/admin/audit-log'
    | '/admin/claire-failure-groups'
    | '/admin/claire-regressions'
    | '/admin/conversations'
    | '/admin/crm-triggers'
    | '/admin/harness'
    | '/admin/imports'
    | '/admin/meta-connections'
    | '/admin/music'
    | '/admin/scraping'
    | '/admin/stock-footage'
    | '/admin/stuck-setup'
    | '/create/$entity'
    | '/dashboard/$'
    | '/dashboard/account'
    | '/dashboard/brand'
    | '/dashboard/chatbots'
    | '/dashboard/conversations'
    | '/dashboard/intake-forms'
    | '/dashboard/integrations'
    | '/dashboard/lead-forms'
    | '/dashboard/lead-management'
    | '/dashboard/locations'
    | '/dashboard/notifications'
    | '/dashboard/offers'
    | '/dashboard/organisation'
    | '/dashboard/reports'
    | '/dashboard/reset'
    | '/dashboard/retention'
    | '/dashboard/reviews'
    | '/dashboard/template-preview'
    | '/dashboard/training-hub'
    | '/dashboard/voice-test'
    | '/dashboard/website'
    | '/record/$videoId'
    | '/settings/claire'
    | '/wireframe-fullscreen/annotate'
    | '/wireframe-fullscreen/compare'
    | '/wireframe-fullscreen/consent-kiosk'
    | '/wireframe-fullscreen/scribe'
    | '/connect/stripe/done'
    | '/forms/$organizationSlug/$token'
    | '/venue/$organizationSlug/$locationSlug'
    | '/admin'
    | '/create-video'
    | '/dashboard'
    | '/record'
    | '/opt-in/$organizationSlug'
    | '/venue/$organizationSlug'
    | '/admin/organizations/$id'
    | '/ads/new/video-format'
    | '/dashboard/advertising/new'
    | '/dashboard/appointments/agenda'
    | '/dashboard/appointments/day'
    | '/dashboard/appointments/month'
    | '/dashboard/appointments/week'
    | '/dashboard/appointments/year'
    | '/dashboard/content/gallery'
    | '/dashboard/content/images'
    | '/dashboard/content/library'
    | '/dashboard/content/new'
    | '/dashboard/content/videos'
    | '/dashboard/debug/analysis-split-test'
    | '/dashboard/l/$locationId'
    | '/dashboard/more/$section'
    | '/dashboard/services/new'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/blocked-time-types'
    | '/dashboard/settings/bookings'
    | '/dashboard/settings/cancellations'
    | '/dashboard/settings/chatbot'
    | '/dashboard/settings/claire-campaigns'
    | '/dashboard/settings/claire-memories'
    | '/dashboard/settings/claire-whatsapp'
    | '/dashboard/settings/consent-forms'
    | '/dashboard/settings/consent-privacy'
    | '/dashboard/settings/delete-account'
    | '/dashboard/settings/details'
    | '/dashboard/settings/examples'
    | '/dashboard/settings/integrations'
    | '/dashboard/settings/message-templates'
    | '/dashboard/settings/notifications'
    | '/dashboard/settings/payments'
    | '/dashboard/settings/post-treatment-reviews'
    | '/dashboard/settings/reminders'
    | '/dashboard/settings/scheduling'
    | '/dashboard/settings/style'
    | '/dashboard/socials/new'
    | '/dashboard/socials/recent'
    | '/dashboard/socials/review'
    | '/dashboard/socials/scheduled'
    | '/dashboard/wireframes/calendar-day'
    | '/dashboard/wireframes/calendar-side-panel'
    | '/dashboard/wireframes/calendar-week'
    | '/dashboard/wireframes/consent-compliance'
    | '/dashboard/wireframes/data-privacy'
    | '/dashboard/wireframes/deposits'
    | '/dashboard/wireframes/photos'
    | '/dashboard/wireframes/reminders-settings'
    | '/dashboard/wireframes/reports'
    | '/dashboard/wireframes/retention'
    | '/dashboard/wireframes/reviews'
    | '/dashboard/wireframes/search'
    | '/dashboard/wireframes/sequences'
    | '/dashboard/wireframes/settings'
    | '/dashboard/wireframes/skin-analysis'
    | '/dashboard/wireframes/view-shell'
    | '/edit/$entity/$id'
    | '/settings/claire/usage'
    | '/settings/claire/whatsapp'
    | '/team/repeating-shifts/$practitionerId'
    | '/ads/new'
    | '/connect/meta-ads'
    | '/create-video/$templateId'
    | '/dashboard/advertising'
    | '/dashboard/appointments'
    | '/dashboard/content'
    | '/dashboard/debug'
    | '/dashboard/more'
    | '/dashboard/services'
    | '/dashboard/settings'
    | '/dashboard/socials'
    | '/dashboard/wireframes'
    | '/dashboard/appointments/new/block'
    | '/dashboard/appointments/new/client'
    | '/dashboard/l/$locationId/ai-assistant'
    | '/dashboard/l/$locationId/customers'
    | '/dashboard/l/$locationId/deposits'
    | '/dashboard/l/$locationId/home'
    | '/dashboard/l/$locationId/public-site'
    | '/dashboard/l/$locationId/venue'
    | '/dashboard/services/$serviceId/edit'
    | '/dashboard/settings/form-templates/$formId'
    | '/dashboard/socials/post/$id'
    | '/dashboard/advertising/$id'
    | '/dashboard/appointments/new'
    | '/dashboard/settings/form-templates'
    | '/dashboard/advertising/$id/ads/$adId'
    | '/dashboard/l/$locationId/calendar/agenda'
    | '/dashboard/l/$locationId/calendar/day'
    | '/dashboard/l/$locationId/calendar/month'
    | '/dashboard/l/$locationId/calendar/three-day'
    | '/dashboard/l/$locationId/calendar/week'
    | '/dashboard/l/$locationId/calendar/year'
    | '/dashboard/l/$locationId/catalog/brands'
    | '/dashboard/l/$locationId/catalog/categories'
    | '/dashboard/l/$locationId/catalog/memberships'
    | '/dashboard/l/$locationId/catalog/offers'
    | '/dashboard/l/$locationId/catalog/packages'
    | '/dashboard/l/$locationId/catalog/products'
    | '/dashboard/l/$locationId/catalog/resources'
    | '/dashboard/l/$locationId/catalog/stock-orders'
    | '/dashboard/l/$locationId/catalog/stocktakes'
    | '/dashboard/l/$locationId/catalog/suppliers'
    | '/dashboard/l/$locationId/clients/$leadId'
    | '/dashboard/l/$locationId/clients/inbox'
    | '/dashboard/l/$locationId/clients/list'
    | '/dashboard/l/$locationId/content-calendar/day'
    | '/dashboard/l/$locationId/content-calendar/month'
    | '/dashboard/l/$locationId/content-calendar/three-day'
    | '/dashboard/l/$locationId/content-calendar/week'
    | '/dashboard/l/$locationId/customers/$leadId'
    | '/dashboard/l/$locationId/inventory/brands'
    | '/dashboard/l/$locationId/inventory/categories'
    | '/dashboard/l/$locationId/inventory/stock-orders'
    | '/dashboard/l/$locationId/inventory/stocktakes'
    | '/dashboard/l/$locationId/inventory/suppliers'
    | '/dashboard/l/$locationId/marketing/lead-forms'
    | '/dashboard/l/$locationId/marketing/sequences'
    | '/dashboard/l/$locationId/sales/appointments'
    | '/dashboard/l/$locationId/sales/daily-summary'
    | '/dashboard/l/$locationId/sales/gift-cards'
    | '/dashboard/l/$locationId/sales/list'
    | '/dashboard/l/$locationId/sales/memberships'
    | '/dashboard/l/$locationId/sales/payments'
    | '/dashboard/l/$locationId/sales/product-orders'
    | '/dashboard/l/$locationId/team/members'
    | '/dashboard/l/$locationId/team/practitioners'
    | '/dashboard/l/$locationId/team/shifts'
    | '/dashboard/l/$locationId/team/timesheets'
    | '/dashboard/l/$locationId/calendar'
    | '/dashboard/l/$locationId/catalog'
    | '/dashboard/l/$locationId/clients'
    | '/dashboard/l/$locationId/content-calendar'
    | '/dashboard/l/$locationId/marketing'
    | '/dashboard/l/$locationId/sales'
    | '/dashboard/l/$locationId/team'
    | '/dashboard/l/$locationId/videos'
    | '/dashboard/l/$locationId/calendar/appointment/$appointmentId'
    | '/dashboard/l/$locationId/calendar/new/block'
    | '/dashboard/l/$locationId/calendar/new/client'
    | '/dashboard/l/$locationId/calendar/rooms/day'
    | '/dashboard/l/$locationId/calendar/rooms/month'
    | '/dashboard/l/$locationId/calendar/rooms/three-day'
    | '/dashboard/l/$locationId/calendar/rooms/week'
    | '/dashboard/l/$locationId/customers/$leadId/form'
    | '/dashboard/l/$locationId/marketing/advertising/new'
    | '/dashboard/l/$locationId/marketing/gallery/images'
    | '/dashboard/l/$locationId/marketing/gallery/library'
    | '/dashboard/l/$locationId/marketing/gallery/videos'
    | '/dashboard/l/$locationId/marketing/socials/recent'
    | '/dashboard/l/$locationId/marketing/socials/review'
    | '/dashboard/l/$locationId/marketing/socials/scheduled'
    | '/dashboard/l/$locationId/calendar/new'
    | '/dashboard/l/$locationId/calendar/rooms'
    | '/dashboard/l/$locationId/catalog/services'
    | '/dashboard/l/$locationId/marketing/advertising'
    | '/dashboard/l/$locationId/marketing/campaigns'
    | '/dashboard/l/$locationId/marketing/gallery'
    | '/dashboard/l/$locationId/marketing/music'
    | '/dashboard/l/$locationId/marketing/socials'
    | '/dashboard/l/$locationId/videos/create-from-client'
    | '/dashboard/l/$locationId/marketing/socials/post/$id'
    | '/dashboard/l/$locationId/marketing/advertising/$id'
    | '/dashboard/l/$locationId/marketing/campaigns/$id'
    | '/dashboard/l/$locationId/marketing/campaigns/new'
    | '/dashboard/l/$locationId/marketing/campaigns/segments'
    | '/dashboard/l/$locationId/marketing/gallery/new'
    | '/dashboard/l/$locationId/marketing/socials/new'
    | '/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId'
    | '/dashboard/l/$locationId/marketing/campaigns/segments/new'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/_authed'
    | '/_onboarding'
    | '/accept-invitation'
    | '/creative-lab'
    | '/creative-lab-card'
    | '/creative-lab-panel'
    | '/forgot-password'
    | '/reset-password'
    | '/restore-organization'
    | '/sign-in'
    | '/sign-up'
    | '/verify-2fa'
    | '/verify-email'
    | '/welcome'
    | '/_admin/admin'
    | '/_authed/assistant'
    | '/_authed/billing'
    | '/_authed/dashboard'
    | '/_authed/review-content'
    | '/_authed/website-preview'
    | '/_authed/wireframe-fullscreen'
    | '/_onboarding/onboarding'
    | '/_onboarding/setup-profile'
    | '/_onboarding/upload-assets'
    | '/connect/facebook'
    | '/connect/whatsapp'
    | '/start/$token'
    | '/welcome/'
    | '/_admin/admin/advertising'
    | '/_admin/admin/audit-log'
    | '/_admin/admin/claire-failure-groups'
    | '/_admin/admin/claire-regressions'
    | '/_admin/admin/conversations'
    | '/_admin/admin/crm-triggers'
    | '/_admin/admin/harness'
    | '/_admin/admin/imports'
    | '/_admin/admin/meta-connections'
    | '/_admin/admin/music'
    | '/_admin/admin/scraping'
    | '/_admin/admin/stock-footage'
    | '/_admin/admin/stuck-setup'
    | '/_authed/create/$entity'
    | '/_authed/dashboard/$'
    | '/_authed/dashboard/account'
    | '/_authed/dashboard/brand'
    | '/_authed/dashboard/chatbots'
    | '/_authed/dashboard/conversations'
    | '/_authed/dashboard/intake-forms'
    | '/_authed/dashboard/integrations'
    | '/_authed/dashboard/lead-forms'
    | '/_authed/dashboard/lead-management'
    | '/_authed/dashboard/locations'
    | '/_authed/dashboard/notifications'
    | '/_authed/dashboard/offers'
    | '/_authed/dashboard/organisation'
    | '/_authed/dashboard/reports'
    | '/_authed/dashboard/reset'
    | '/_authed/dashboard/retention'
    | '/_authed/dashboard/reviews'
    | '/_authed/dashboard/settings'
    | '/_authed/dashboard/template-preview'
    | '/_authed/dashboard/training-hub'
    | '/_authed/dashboard/voice-test'
    | '/_authed/dashboard/website'
    | '/_authed/dashboard/wireframes'
    | '/_authed/record/$videoId'
    | '/_authed/settings/claire'
    | '/_authed/wireframe-fullscreen/annotate'
    | '/_authed/wireframe-fullscreen/compare'
    | '/_authed/wireframe-fullscreen/consent-kiosk'
    | '/_authed/wireframe-fullscreen/scribe'
    | '/connect/stripe/done'
    | '/forms/$organizationSlug/$token'
    | '/venue/$organizationSlug/$locationSlug'
    | '/_admin/admin/'
    | '/_authed/create-video/'
    | '/_authed/dashboard/'
    | '/_authed/record/'
    | '/opt-in/$organizationSlug/'
    | '/venue/$organizationSlug/'
    | '/_admin/admin/organizations/$id'
    | '/_authed/ads/new/video-format'
    | '/_authed/dashboard/advertising/new'
    | '/_authed/dashboard/appointments/agenda'
    | '/_authed/dashboard/appointments/day'
    | '/_authed/dashboard/appointments/month'
    | '/_authed/dashboard/appointments/week'
    | '/_authed/dashboard/appointments/year'
    | '/_authed/dashboard/content/gallery'
    | '/_authed/dashboard/content/images'
    | '/_authed/dashboard/content/library'
    | '/_authed/dashboard/content/new'
    | '/_authed/dashboard/content/videos'
    | '/_authed/dashboard/debug/analysis-split-test'
    | '/_authed/dashboard/l/$locationId'
    | '/_authed/dashboard/more/$section'
    | '/_authed/dashboard/services/new'
    | '/_authed/dashboard/settings/billing'
    | '/_authed/dashboard/settings/blocked-time-types'
    | '/_authed/dashboard/settings/bookings'
    | '/_authed/dashboard/settings/cancellations'
    | '/_authed/dashboard/settings/chatbot'
    | '/_authed/dashboard/settings/claire-campaigns'
    | '/_authed/dashboard/settings/claire-memories'
    | '/_authed/dashboard/settings/claire-whatsapp'
    | '/_authed/dashboard/settings/consent-forms'
    | '/_authed/dashboard/settings/consent-privacy'
    | '/_authed/dashboard/settings/delete-account'
    | '/_authed/dashboard/settings/details'
    | '/_authed/dashboard/settings/examples'
    | '/_authed/dashboard/settings/form-templates'
    | '/_authed/dashboard/settings/integrations'
    | '/_authed/dashboard/settings/message-templates'
    | '/_authed/dashboard/settings/notifications'
    | '/_authed/dashboard/settings/payments'
    | '/_authed/dashboard/settings/post-treatment-reviews'
    | '/_authed/dashboard/settings/reminders'
    | '/_authed/dashboard/settings/scheduling'
    | '/_authed/dashboard/settings/style'
    | '/_authed/dashboard/socials/new'
    | '/_authed/dashboard/socials/recent'
    | '/_authed/dashboard/socials/review'
    | '/_authed/dashboard/socials/scheduled'
    | '/_authed/dashboard/wireframes/calendar-day'
    | '/_authed/dashboard/wireframes/calendar-side-panel'
    | '/_authed/dashboard/wireframes/calendar-week'
    | '/_authed/dashboard/wireframes/consent-compliance'
    | '/_authed/dashboard/wireframes/data-privacy'
    | '/_authed/dashboard/wireframes/deposits'
    | '/_authed/dashboard/wireframes/photos'
    | '/_authed/dashboard/wireframes/reminders-settings'
    | '/_authed/dashboard/wireframes/reports'
    | '/_authed/dashboard/wireframes/retention'
    | '/_authed/dashboard/wireframes/reviews'
    | '/_authed/dashboard/wireframes/search'
    | '/_authed/dashboard/wireframes/sequences'
    | '/_authed/dashboard/wireframes/settings'
    | '/_authed/dashboard/wireframes/skin-analysis'
    | '/_authed/dashboard/wireframes/view-shell'
    | '/_authed/edit/$entity/$id'
    | '/_authed/settings/claire/usage'
    | '/_authed/settings/claire/whatsapp'
    | '/_authed/team/repeating-shifts/$practitionerId'
    | '/_authed/ads/new/'
    | '/_authed/connect/meta-ads/'
    | '/_authed/create-video/$templateId/'
    | '/_authed/dashboard/advertising/'
    | '/_authed/dashboard/appointments/'
    | '/_authed/dashboard/content/'
    | '/_authed/dashboard/debug/'
    | '/_authed/dashboard/more/'
    | '/_authed/dashboard/services/'
    | '/_authed/dashboard/settings/'
    | '/_authed/dashboard/socials/'
    | '/_authed/dashboard/wireframes/'
    | '/_authed/dashboard/appointments/new/block'
    | '/_authed/dashboard/appointments/new/client'
    | '/_authed/dashboard/l/$locationId/ai-assistant'
    | '/_authed/dashboard/l/$locationId/calendar'
    | '/_authed/dashboard/l/$locationId/clients'
    | '/_authed/dashboard/l/$locationId/content-calendar'
    | '/_authed/dashboard/l/$locationId/customers'
    | '/_authed/dashboard/l/$locationId/deposits'
    | '/_authed/dashboard/l/$locationId/home'
    | '/_authed/dashboard/l/$locationId/marketing'
    | '/_authed/dashboard/l/$locationId/public-site'
    | '/_authed/dashboard/l/$locationId/sales'
    | '/_authed/dashboard/l/$locationId/venue'
    | '/_authed/dashboard/services/$serviceId/edit'
    | '/_authed/dashboard/settings/form-templates/$formId'
    | '/_authed/dashboard/socials/post/$id'
    | '/_authed/dashboard/advertising/$id/'
    | '/_authed/dashboard/appointments/new/'
    | '/_authed/dashboard/settings/form-templates/'
    | '/_authed/dashboard/l/$locationId/calendar/new'
    | '/_authed/dashboard/advertising/$id/ads/$adId'
    | '/_authed/dashboard/l/$locationId/calendar/agenda'
    | '/_authed/dashboard/l/$locationId/calendar/day'
    | '/_authed/dashboard/l/$locationId/calendar/month'
    | '/_authed/dashboard/l/$locationId/calendar/rooms'
    | '/_authed/dashboard/l/$locationId/calendar/three-day'
    | '/_authed/dashboard/l/$locationId/calendar/week'
    | '/_authed/dashboard/l/$locationId/calendar/year'
    | '/_authed/dashboard/l/$locationId/catalog/brands'
    | '/_authed/dashboard/l/$locationId/catalog/categories'
    | '/_authed/dashboard/l/$locationId/catalog/memberships'
    | '/_authed/dashboard/l/$locationId/catalog/offers'
    | '/_authed/dashboard/l/$locationId/catalog/packages'
    | '/_authed/dashboard/l/$locationId/catalog/products'
    | '/_authed/dashboard/l/$locationId/catalog/resources'
    | '/_authed/dashboard/l/$locationId/catalog/services'
    | '/_authed/dashboard/l/$locationId/catalog/stock-orders'
    | '/_authed/dashboard/l/$locationId/catalog/stocktakes'
    | '/_authed/dashboard/l/$locationId/catalog/suppliers'
    | '/_authed/dashboard/l/$locationId/clients/$leadId'
    | '/_authed/dashboard/l/$locationId/clients/inbox'
    | '/_authed/dashboard/l/$locationId/clients/list'
    | '/_authed/dashboard/l/$locationId/content-calendar/day'
    | '/_authed/dashboard/l/$locationId/content-calendar/month'
    | '/_authed/dashboard/l/$locationId/content-calendar/three-day'
    | '/_authed/dashboard/l/$locationId/content-calendar/week'
    | '/_authed/dashboard/l/$locationId/customers/$leadId'
    | '/_authed/dashboard/l/$locationId/inventory/brands'
    | '/_authed/dashboard/l/$locationId/inventory/categories'
    | '/_authed/dashboard/l/$locationId/inventory/stock-orders'
    | '/_authed/dashboard/l/$locationId/inventory/stocktakes'
    | '/_authed/dashboard/l/$locationId/inventory/suppliers'
    | '/_authed/dashboard/l/$locationId/marketing/advertising'
    | '/_authed/dashboard/l/$locationId/marketing/lead-forms'
    | '/_authed/dashboard/l/$locationId/marketing/sequences'
    | '/_authed/dashboard/l/$locationId/marketing/socials'
    | '/_authed/dashboard/l/$locationId/sales/appointments'
    | '/_authed/dashboard/l/$locationId/sales/daily-summary'
    | '/_authed/dashboard/l/$locationId/sales/gift-cards'
    | '/_authed/dashboard/l/$locationId/sales/list'
    | '/_authed/dashboard/l/$locationId/sales/memberships'
    | '/_authed/dashboard/l/$locationId/sales/payments'
    | '/_authed/dashboard/l/$locationId/sales/product-orders'
    | '/_authed/dashboard/l/$locationId/team/members'
    | '/_authed/dashboard/l/$locationId/team/practitioners'
    | '/_authed/dashboard/l/$locationId/team/shifts'
    | '/_authed/dashboard/l/$locationId/team/timesheets'
    | '/_authed/dashboard/l/$locationId/calendar/'
    | '/_authed/dashboard/l/$locationId/catalog/'
    | '/_authed/dashboard/l/$locationId/clients/'
    | '/_authed/dashboard/l/$locationId/content-calendar/'
    | '/_authed/dashboard/l/$locationId/marketing/'
    | '/_authed/dashboard/l/$locationId/sales/'
    | '/_authed/dashboard/l/$locationId/team/'
    | '/_authed/dashboard/l/$locationId/videos/'
    | '/_authed/dashboard/l/$locationId/calendar/appointment/$appointmentId'
    | '/_authed/dashboard/l/$locationId/calendar/new/block'
    | '/_authed/dashboard/l/$locationId/calendar/new/client'
    | '/_authed/dashboard/l/$locationId/calendar/rooms/day'
    | '/_authed/dashboard/l/$locationId/calendar/rooms/month'
    | '/_authed/dashboard/l/$locationId/calendar/rooms/three-day'
    | '/_authed/dashboard/l/$locationId/calendar/rooms/week'
    | '/_authed/dashboard/l/$locationId/customers/$leadId/form'
    | '/_authed/dashboard/l/$locationId/marketing/advertising/new'
    | '/_authed/dashboard/l/$locationId/marketing/gallery/images'
    | '/_authed/dashboard/l/$locationId/marketing/gallery/library'
    | '/_authed/dashboard/l/$locationId/marketing/gallery/videos'
    | '/_authed/dashboard/l/$locationId/marketing/socials/recent'
    | '/_authed/dashboard/l/$locationId/marketing/socials/review'
    | '/_authed/dashboard/l/$locationId/marketing/socials/scheduled'
    | '/_authed/dashboard/l/$locationId/calendar/new/'
    | '/_authed/dashboard/l/$locationId/calendar/rooms/'
    | '/_authed/dashboard/l/$locationId/catalog/services/'
    | '/_authed/dashboard/l/$locationId/marketing/advertising/'
    | '/_authed/dashboard/l/$locationId/marketing/campaigns/'
    | '/_authed/dashboard/l/$locationId/marketing/gallery/'
    | '/_authed/dashboard/l/$locationId/marketing/music/'
    | '/_authed/dashboard/l/$locationId/marketing/socials/'
    | '/_authed/dashboard/l/$locationId/videos/create-from-client/'
    | '/_authed/dashboard/l/$locationId/marketing/socials/post/$id'
    | '/_authed/dashboard/l/$locationId/marketing/advertising/$id/'
    | '/_authed/dashboard/l/$locationId/marketing/campaigns/$id/'
    | '/_authed/dashboard/l/$locationId/marketing/campaigns/new/'
    | '/_authed/dashboard/l/$locationId/marketing/campaigns/segments/'
    | '/_authed/dashboard/l/$locationId/marketing/gallery/new/'
    | '/_authed/dashboard/l/$locationId/marketing/socials/new/'
    | '/_authed/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId'
    | '/_authed/dashboard/l/$locationId/marketing/campaigns/segments/new/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AuthedRoute: typeof AuthedRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  CreativeLabRoute: typeof CreativeLabRoute
  CreativeLabCardRoute: typeof CreativeLabCardRoute
  CreativeLabPanelRoute: typeof CreativeLabPanelRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  RestoreOrganizationRoute: typeof RestoreOrganizationRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  Verify2faRoute: typeof Verify2faRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  WelcomeRoute: typeof WelcomeRouteWithChildren
  ConnectFacebookRoute: typeof ConnectFacebookRoute
  ConnectWhatsappRoute: typeof ConnectWhatsappRoute
  StartTokenRoute: typeof StartTokenRoute
  ConnectStripeDoneRoute: typeof ConnectStripeDoneRoute
  FormsOrganizationSlugTokenRoute: typeof FormsOrganizationSlugTokenRoute
  VenueOrganizationSlugLocationSlugRoute: typeof VenueOrganizationSlugLocationSlugRoute
  OptInOrganizationSlugIndexRoute: typeof OptInOrganizationSlugIndexRoute
  VenueOrganizationSlugIndexRoute: typeof VenueOrganizationSlugIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-2fa': {
      id: '/verify-2fa'
      path: '/verify-2fa'
      fullPath: '/verify-2fa'
      preLoaderRoute: typeof Verify2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restore-organization': {
      id: '/restore-organization'
      path: '/restore-organization'
      fullPath: '/restore-organization'
      preLoaderRoute: typeof RestoreOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creative-lab-panel': {
      id: '/creative-lab-panel'
      path: '/creative-lab-panel'
      fullPath: '/creative-lab-panel'
      preLoaderRoute: typeof CreativeLabPanelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creative-lab-card': {
      id: '/creative-lab-card'
      path: '/creative-lab-card'
      fullPath: '/creative-lab-card'
      preLoaderRoute: typeof CreativeLabCardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creative-lab': {
      id: '/creative-lab'
      path: '/creative-lab'
      fullPath: '/creative-lab'
      preLoaderRoute: typeof CreativeLabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome/': {
      id: '/welcome/'
      path: '/'
      fullPath: '/welcome/'
      preLoaderRoute: typeof WelcomeIndexRouteImport
      parentRoute: typeof WelcomeRoute
    }
    '/start/$token': {
      id: '/start/$token'
      path: '/start/$token'
      fullPath: '/start/$token'
      preLoaderRoute: typeof StartTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect/whatsapp': {
      id: '/connect/whatsapp'
      path: '/connect/whatsapp'
      fullPath: '/connect/whatsapp'
      preLoaderRoute: typeof ConnectWhatsappRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect/facebook': {
      id: '/connect/facebook'
      path: '/connect/facebook'
      fullPath: '/connect/facebook'
      preLoaderRoute: typeof ConnectFacebookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding/upload-assets': {
      id: '/_onboarding/upload-assets'
      path: '/upload-assets'
      fullPath: '/upload-assets'
      preLoaderRoute: typeof OnboardingUploadAssetsRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_onboarding/setup-profile': {
      id: '/_onboarding/setup-profile'
      path: '/setup-profile'
      fullPath: '/setup-profile'
      preLoaderRoute: typeof OnboardingSetupProfileRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_onboarding/onboarding': {
      id: '/_onboarding/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingOnboardingRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_authed/wireframe-fullscreen': {
      id: '/_authed/wireframe-fullscreen'
      path: '/wireframe-fullscreen'
      fullPath: '/wireframe-fullscreen'
      preLoaderRoute: typeof AuthedWireframeFullscreenRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/website-preview': {
      id: '/_authed/website-preview'
      path: '/website-preview'
      fullPath: '/website-preview'
      preLoaderRoute: typeof AuthedWebsitePreviewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/review-content': {
      id: '/_authed/review-content'
      path: '/review-content'
      fullPath: '/review-content'
      preLoaderRoute: typeof AuthedReviewContentRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/billing': {
      id: '/_authed/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthedBillingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/assistant': {
      id: '/_authed/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AuthedAssistantRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_admin/admin': {
      id: '/_admin/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminAdminRouteImport
      parentRoute: typeof AdminRoute
    }
    '/venue/$organizationSlug/': {
      id: '/venue/$organizationSlug/'
      path: '/venue/$organizationSlug'
      fullPath: '/venue/$organizationSlug/'
      preLoaderRoute: typeof VenueOrganizationSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opt-in/$organizationSlug/': {
      id: '/opt-in/$organizationSlug/'
      path: '/opt-in/$organizationSlug'
      fullPath: '/opt-in/$organizationSlug/'
      preLoaderRoute: typeof OptInOrganizationSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/record/': {
      id: '/_authed/record/'
      path: '/record'
      fullPath: '/record/'
      preLoaderRoute: typeof AuthedRecordIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard/': {
      id: '/_authed/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthedDashboardIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/create-video/': {
      id: '/_authed/create-video/'
      path: '/create-video'
      fullPath: '/create-video/'
      preLoaderRoute: typeof AuthedCreateVideoIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_admin/admin/': {
      id: '/_admin/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminAdminIndexRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/venue/$organizationSlug/$locationSlug': {
      id: '/venue/$organizationSlug/$locationSlug'
      path: '/venue/$organizationSlug/$locationSlug'
      fullPath: '/venue/$organizationSlug/$locationSlug'
      preLoaderRoute: typeof VenueOrganizationSlugLocationSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/$organizationSlug/$token': {
      id: '/forms/$organizationSlug/$token'
      path: '/forms/$organizationSlug/$token'
      fullPath: '/forms/$organizationSlug/$token'
      preLoaderRoute: typeof FormsOrganizationSlugTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect/stripe/done': {
      id: '/connect/stripe/done'
      path: '/connect/stripe/done'
      fullPath: '/connect/stripe/done'
      preLoaderRoute: typeof ConnectStripeDoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/wireframe-fullscreen/scribe': {
      id: '/_authed/wireframe-fullscreen/scribe'
      path: '/scribe'
      fullPath: '/wireframe-fullscreen/scribe'
      preLoaderRoute: typeof AuthedWireframeFullscreenScribeRouteImport
      parentRoute: typeof AuthedWireframeFullscreenRoute
    }
    '/_authed/wireframe-fullscreen/consent-kiosk': {
      id: '/_authed/wireframe-fullscreen/consent-kiosk'
      path: '/consent-kiosk'
      fullPath: '/wireframe-fullscreen/consent-kiosk'
      preLoaderRoute: typeof AuthedWireframeFullscreenConsentKioskRouteImport
      parentRoute: typeof AuthedWireframeFullscreenRoute
    }
    '/_authed/wireframe-fullscreen/compare': {
      id: '/_authed/wireframe-fullscreen/compare'
      path: '/compare'
      fullPath: '/wireframe-fullscreen/compare'
      preLoaderRoute: typeof AuthedWireframeFullscreenCompareRouteImport
      parentRoute: typeof AuthedWireframeFullscreenRoute
    }
    '/_authed/wireframe-fullscreen/annotate': {
      id: '/_authed/wireframe-fullscreen/annotate'
      path: '/annotate'
      fullPath: '/wireframe-fullscreen/annotate'
      preLoaderRoute: typeof AuthedWireframeFullscreenAnnotateRouteImport
      parentRoute: typeof AuthedWireframeFullscreenRoute
    }
    '/_authed/settings/claire': {
      id: '/_authed/settings/claire'
      path: '/settings/claire'
      fullPath: '/settings/claire'
      preLoaderRoute: typeof AuthedSettingsClaireRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/record/$videoId': {
      id: '/_authed/record/$videoId'
      path: '/record/$videoId'
      fullPath: '/record/$videoId'
      preLoaderRoute: typeof AuthedRecordVideoIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard/wireframes': {
      id: '/_authed/dashboard/wireframes'
      path: '/wireframes'
      fullPath: '/dashboard/wireframes'
      preLoaderRoute: typeof AuthedDashboardWireframesRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/website': {
      id: '/_authed/dashboard/website'
      path: '/website'
      fullPath: '/dashboard/website'
      preLoaderRoute: typeof AuthedDashboardWebsiteRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/voice-test': {
      id: '/_authed/dashboard/voice-test'
      path: '/voice-test'
      fullPath: '/dashboard/voice-test'
      preLoaderRoute: typeof AuthedDashboardVoiceTestRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/training-hub': {
      id: '/_authed/dashboard/training-hub'
      path: '/training-hub'
      fullPath: '/dashboard/training-hub'
      preLoaderRoute: typeof AuthedDashboardTrainingHubRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/template-preview': {
      id: '/_authed/dashboard/template-preview'
      path: '/template-preview'
      fullPath: '/dashboard/template-preview'
      preLoaderRoute: typeof AuthedDashboardTemplatePreviewRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/settings': {
      id: '/_authed/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof AuthedDashboardSettingsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/reviews': {
      id: '/_authed/dashboard/reviews'
      path: '/reviews'
      fullPath: '/dashboard/reviews'
      preLoaderRoute: typeof AuthedDashboardReviewsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/retention': {
      id: '/_authed/dashboard/retention'
      path: '/retention'
      fullPath: '/dashboard/retention'
      preLoaderRoute: typeof AuthedDashboardRetentionRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/reset': {
      id: '/_authed/dashboard/reset'
      path: '/reset'
      fullPath: '/dashboard/reset'
      preLoaderRoute: typeof AuthedDashboardResetRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/reports': {
      id: '/_authed/dashboard/reports'
      path: '/reports'
      fullPath: '/dashboard/reports'
      preLoaderRoute: typeof AuthedDashboardReportsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/organisation': {
      id: '/_authed/dashboard/organisation'
      path: '/organisation'
      fullPath: '/dashboard/organisation'
      preLoaderRoute: typeof AuthedDashboardOrganisationRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/offers': {
      id: '/_authed/dashboard/offers'
      path: '/offers'
      fullPath: '/dashboard/offers'
      preLoaderRoute: typeof AuthedDashboardOffersRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/notifications': {
      id: '/_authed/dashboard/notifications'
      path: '/notifications'
      fullPath: '/dashboard/notifications'
      preLoaderRoute: typeof AuthedDashboardNotificationsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/locations': {
      id: '/_authed/dashboard/locations'
      path: '/locations'
      fullPath: '/dashboard/locations'
      preLoaderRoute: typeof AuthedDashboardLocationsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/lead-management': {
      id: '/_authed/dashboard/lead-management'
      path: '/lead-management'
      fullPath: '/dashboard/lead-management'
      preLoaderRoute: typeof AuthedDashboardLeadManagementRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/lead-forms': {
      id: '/_authed/dashboard/lead-forms'
      path: '/lead-forms'
      fullPath: '/dashboard/lead-forms'
      preLoaderRoute: typeof AuthedDashboardLeadFormsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/integrations': {
      id: '/_authed/dashboard/integrations'
      path: '/integrations'
      fullPath: '/dashboard/integrations'
      preLoaderRoute: typeof AuthedDashboardIntegrationsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/intake-forms': {
      id: '/_authed/dashboard/intake-forms'
      path: '/intake-forms'
      fullPath: '/dashboard/intake-forms'
      preLoaderRoute: typeof AuthedDashboardIntakeFormsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/conversations': {
      id: '/_authed/dashboard/conversations'
      path: '/conversations'
      fullPath: '/dashboard/conversations'
      preLoaderRoute: typeof AuthedDashboardConversationsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/chatbots': {
      id: '/_authed/dashboard/chatbots'
      path: '/chatbots'
      fullPath: '/dashboard/chatbots'
      preLoaderRoute: typeof AuthedDashboardChatbotsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/brand': {
      id: '/_authed/dashboard/brand'
      path: '/brand'
      fullPath: '/dashboard/brand'
      preLoaderRoute: typeof AuthedDashboardBrandRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/account': {
      id: '/_authed/dashboard/account'
      path: '/account'
      fullPath: '/dashboard/account'
      preLoaderRoute: typeof AuthedDashboardAccountRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/$': {
      id: '/_authed/dashboard/$'
      path: '/$'
      fullPath: '/dashboard/$'
      preLoaderRoute: typeof AuthedDashboardSplatRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/create/$entity': {
      id: '/_authed/create/$entity'
      path: '/create/$entity'
      fullPath: '/create/$entity'
      preLoaderRoute: typeof AuthedCreateEntityRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_admin/admin/stuck-setup': {
      id: '/_admin/admin/stuck-setup'
      path: '/stuck-setup'
      fullPath: '/admin/stuck-setup'
      preLoaderRoute: typeof AdminAdminStuckSetupRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/stock-footage': {
      id: '/_admin/admin/stock-footage'
      path: '/stock-footage'
      fullPath: '/admin/stock-footage'
      preLoaderRoute: typeof AdminAdminStockFootageRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/scraping': {
      id: '/_admin/admin/scraping'
      path: '/scraping'
      fullPath: '/admin/scraping'
      preLoaderRoute: typeof AdminAdminScrapingRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/music': {
      id: '/_admin/admin/music'
      path: '/music'
      fullPath: '/admin/music'
      preLoaderRoute: typeof AdminAdminMusicRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/meta-connections': {
      id: '/_admin/admin/meta-connections'
      path: '/meta-connections'
      fullPath: '/admin/meta-connections'
      preLoaderRoute: typeof AdminAdminMetaConnectionsRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/imports': {
      id: '/_admin/admin/imports'
      path: '/imports'
      fullPath: '/admin/imports'
      preLoaderRoute: typeof AdminAdminImportsRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/harness': {
      id: '/_admin/admin/harness'
      path: '/harness'
      fullPath: '/admin/harness'
      preLoaderRoute: typeof AdminAdminHarnessRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/crm-triggers': {
      id: '/_admin/admin/crm-triggers'
      path: '/crm-triggers'
      fullPath: '/admin/crm-triggers'
      preLoaderRoute: typeof AdminAdminCrmTriggersRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/conversations': {
      id: '/_admin/admin/conversations'
      path: '/conversations'
      fullPath: '/admin/conversations'
      preLoaderRoute: typeof AdminAdminConversationsRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/claire-regressions': {
      id: '/_admin/admin/claire-regressions'
      path: '/claire-regressions'
      fullPath: '/admin/claire-regressions'
      preLoaderRoute: typeof AdminAdminClaireRegressionsRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/claire-failure-groups': {
      id: '/_admin/admin/claire-failure-groups'
      path: '/claire-failure-groups'
      fullPath: '/admin/claire-failure-groups'
      preLoaderRoute: typeof AdminAdminClaireFailureGroupsRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/audit-log': {
      id: '/_admin/admin/audit-log'
      path: '/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminAdminAuditLogRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_admin/admin/advertising': {
      id: '/_admin/admin/advertising'
      path: '/advertising'
      fullPath: '/admin/advertising'
      preLoaderRoute: typeof AdminAdminAdvertisingRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_authed/dashboard/wireframes/': {
      id: '/_authed/dashboard/wireframes/'
      path: '/'
      fullPath: '/dashboard/wireframes/'
      preLoaderRoute: typeof AuthedDashboardWireframesIndexRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/socials/': {
      id: '/_authed/dashboard/socials/'
      path: '/socials'
      fullPath: '/dashboard/socials/'
      preLoaderRoute: typeof AuthedDashboardSocialsIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/settings/': {
      id: '/_authed/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof AuthedDashboardSettingsIndexRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/services/': {
      id: '/_authed/dashboard/services/'
      path: '/services'
      fullPath: '/dashboard/services/'
      preLoaderRoute: typeof AuthedDashboardServicesIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/more/': {
      id: '/_authed/dashboard/more/'
      path: '/more'
      fullPath: '/dashboard/more/'
      preLoaderRoute: typeof AuthedDashboardMoreIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/debug/': {
      id: '/_authed/dashboard/debug/'
      path: '/debug'
      fullPath: '/dashboard/debug/'
      preLoaderRoute: typeof AuthedDashboardDebugIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/content/': {
      id: '/_authed/dashboard/content/'
      path: '/content'
      fullPath: '/dashboard/content/'
      preLoaderRoute: typeof AuthedDashboardContentIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/appointments/': {
      id: '/_authed/dashboard/appointments/'
      path: '/appointments'
      fullPath: '/dashboard/appointments/'
      preLoaderRoute: typeof AuthedDashboardAppointmentsIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/advertising/': {
      id: '/_authed/dashboard/advertising/'
      path: '/advertising'
      fullPath: '/dashboard/advertising/'
      preLoaderRoute: typeof AuthedDashboardAdvertisingIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/create-video/$templateId/': {
      id: '/_authed/create-video/$templateId/'
      path: '/create-video/$templateId'
      fullPath: '/create-video/$templateId/'
      preLoaderRoute: typeof AuthedCreateVideoTemplateIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/connect/meta-ads/': {
      id: '/_authed/connect/meta-ads/'
      path: '/connect/meta-ads'
      fullPath: '/connect/meta-ads/'
      preLoaderRoute: typeof AuthedConnectMetaAdsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ads/new/': {
      id: '/_authed/ads/new/'
      path: '/ads/new'
      fullPath: '/ads/new/'
      preLoaderRoute: typeof AuthedAdsNewIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/team/repeating-shifts/$practitionerId': {
      id: '/_authed/team/repeating-shifts/$practitionerId'
      path: '/team/repeating-shifts/$practitionerId'
      fullPath: '/team/repeating-shifts/$practitionerId'
      preLoaderRoute: typeof AuthedTeamRepeatingShiftsPractitionerIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/claire/whatsapp': {
      id: '/_authed/settings/claire/whatsapp'
      path: '/whatsapp'
      fullPath: '/settings/claire/whatsapp'
      preLoaderRoute: typeof AuthedSettingsClaireWhatsappRouteImport
      parentRoute: typeof AuthedSettingsClaireRoute
    }
    '/_authed/settings/claire/usage': {
      id: '/_authed/settings/claire/usage'
      path: '/usage'
      fullPath: '/settings/claire/usage'
      preLoaderRoute: typeof AuthedSettingsClaireUsageRouteImport
      parentRoute: typeof AuthedSettingsClaireRoute
    }
    '/_authed/edit/$entity/$id': {
      id: '/_authed/edit/$entity/$id'
      path: '/edit/$entity/$id'
      fullPath: '/edit/$entity/$id'
      preLoaderRoute: typeof AuthedEditEntityIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard/wireframes/view-shell': {
      id: '/_authed/dashboard/wireframes/view-shell'
      path: '/view-shell'
      fullPath: '/dashboard/wireframes/view-shell'
      preLoaderRoute: typeof AuthedDashboardWireframesViewShellRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/skin-analysis': {
      id: '/_authed/dashboard/wireframes/skin-analysis'
      path: '/skin-analysis'
      fullPath: '/dashboard/wireframes/skin-analysis'
      preLoaderRoute: typeof AuthedDashboardWireframesSkinAnalysisRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/settings': {
      id: '/_authed/dashboard/wireframes/settings'
      path: '/settings'
      fullPath: '/dashboard/wireframes/settings'
      preLoaderRoute: typeof AuthedDashboardWireframesSettingsRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/sequences': {
      id: '/_authed/dashboard/wireframes/sequences'
      path: '/sequences'
      fullPath: '/dashboard/wireframes/sequences'
      preLoaderRoute: typeof AuthedDashboardWireframesSequencesRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/search': {
      id: '/_authed/dashboard/wireframes/search'
      path: '/search'
      fullPath: '/dashboard/wireframes/search'
      preLoaderRoute: typeof AuthedDashboardWireframesSearchRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/reviews': {
      id: '/_authed/dashboard/wireframes/reviews'
      path: '/reviews'
      fullPath: '/dashboard/wireframes/reviews'
      preLoaderRoute: typeof AuthedDashboardWireframesReviewsRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/retention': {
      id: '/_authed/dashboard/wireframes/retention'
      path: '/retention'
      fullPath: '/dashboard/wireframes/retention'
      preLoaderRoute: typeof AuthedDashboardWireframesRetentionRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/reports': {
      id: '/_authed/dashboard/wireframes/reports'
      path: '/reports'
      fullPath: '/dashboard/wireframes/reports'
      preLoaderRoute: typeof AuthedDashboardWireframesReportsRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/reminders-settings': {
      id: '/_authed/dashboard/wireframes/reminders-settings'
      path: '/reminders-settings'
      fullPath: '/dashboard/wireframes/reminders-settings'
      preLoaderRoute: typeof AuthedDashboardWireframesRemindersSettingsRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/photos': {
      id: '/_authed/dashboard/wireframes/photos'
      path: '/photos'
      fullPath: '/dashboard/wireframes/photos'
      preLoaderRoute: typeof AuthedDashboardWireframesPhotosRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/deposits': {
      id: '/_authed/dashboard/wireframes/deposits'
      path: '/deposits'
      fullPath: '/dashboard/wireframes/deposits'
      preLoaderRoute: typeof AuthedDashboardWireframesDepositsRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/data-privacy': {
      id: '/_authed/dashboard/wireframes/data-privacy'
      path: '/data-privacy'
      fullPath: '/dashboard/wireframes/data-privacy'
      preLoaderRoute: typeof AuthedDashboardWireframesDataPrivacyRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/consent-compliance': {
      id: '/_authed/dashboard/wireframes/consent-compliance'
      path: '/consent-compliance'
      fullPath: '/dashboard/wireframes/consent-compliance'
      preLoaderRoute: typeof AuthedDashboardWireframesConsentComplianceRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/calendar-week': {
      id: '/_authed/dashboard/wireframes/calendar-week'
      path: '/calendar-week'
      fullPath: '/dashboard/wireframes/calendar-week'
      preLoaderRoute: typeof AuthedDashboardWireframesCalendarWeekRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/calendar-side-panel': {
      id: '/_authed/dashboard/wireframes/calendar-side-panel'
      path: '/calendar-side-panel'
      fullPath: '/dashboard/wireframes/calendar-side-panel'
      preLoaderRoute: typeof AuthedDashboardWireframesCalendarSidePanelRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/wireframes/calendar-day': {
      id: '/_authed/dashboard/wireframes/calendar-day'
      path: '/calendar-day'
      fullPath: '/dashboard/wireframes/calendar-day'
      preLoaderRoute: typeof AuthedDashboardWireframesCalendarDayRouteImport
      parentRoute: typeof AuthedDashboardWireframesRoute
    }
    '/_authed/dashboard/socials/scheduled': {
      id: '/_authed/dashboard/socials/scheduled'
      path: '/socials/scheduled'
      fullPath: '/dashboard/socials/scheduled'
      preLoaderRoute: typeof AuthedDashboardSocialsScheduledRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/socials/review': {
      id: '/_authed/dashboard/socials/review'
      path: '/socials/review'
      fullPath: '/dashboard/socials/review'
      preLoaderRoute: typeof AuthedDashboardSocialsReviewRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/socials/recent': {
      id: '/_authed/dashboard/socials/recent'
      path: '/socials/recent'
      fullPath: '/dashboard/socials/recent'
      preLoaderRoute: typeof AuthedDashboardSocialsRecentRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/socials/new': {
      id: '/_authed/dashboard/socials/new'
      path: '/socials/new'
      fullPath: '/dashboard/socials/new'
      preLoaderRoute: typeof AuthedDashboardSocialsNewRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/settings/style': {
      id: '/_authed/dashboard/settings/style'
      path: '/style'
      fullPath: '/dashboard/settings/style'
      preLoaderRoute: typeof AuthedDashboardSettingsStyleRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/scheduling': {
      id: '/_authed/dashboard/settings/scheduling'
      path: '/scheduling'
      fullPath: '/dashboard/settings/scheduling'
      preLoaderRoute: typeof AuthedDashboardSettingsSchedulingRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/reminders': {
      id: '/_authed/dashboard/settings/reminders'
      path: '/reminders'
      fullPath: '/dashboard/settings/reminders'
      preLoaderRoute: typeof AuthedDashboardSettingsRemindersRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/post-treatment-reviews': {
      id: '/_authed/dashboard/settings/post-treatment-reviews'
      path: '/post-treatment-reviews'
      fullPath: '/dashboard/settings/post-treatment-reviews'
      preLoaderRoute: typeof AuthedDashboardSettingsPostTreatmentReviewsRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/payments': {
      id: '/_authed/dashboard/settings/payments'
      path: '/payments'
      fullPath: '/dashboard/settings/payments'
      preLoaderRoute: typeof AuthedDashboardSettingsPaymentsRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/notifications': {
      id: '/_authed/dashboard/settings/notifications'
      path: '/notifications'
      fullPath: '/dashboard/settings/notifications'
      preLoaderRoute: typeof AuthedDashboardSettingsNotificationsRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/message-templates': {
      id: '/_authed/dashboard/settings/message-templates'
      path: '/message-templates'
      fullPath: '/dashboard/settings/message-templates'
      preLoaderRoute: typeof AuthedDashboardSettingsMessageTemplatesRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/integrations': {
      id: '/_authed/dashboard/settings/integrations'
      path: '/integrations'
      fullPath: '/dashboard/settings/integrations'
      preLoaderRoute: typeof AuthedDashboardSettingsIntegrationsRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/form-templates': {
      id: '/_authed/dashboard/settings/form-templates'
      path: '/form-templates'
      fullPath: '/dashboard/settings/form-templates'
      preLoaderRoute: typeof AuthedDashboardSettingsFormTemplatesRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/examples': {
      id: '/_authed/dashboard/settings/examples'
      path: '/examples'
      fullPath: '/dashboard/settings/examples'
      preLoaderRoute: typeof AuthedDashboardSettingsExamplesRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/details': {
      id: '/_authed/dashboard/settings/details'
      path: '/details'
      fullPath: '/dashboard/settings/details'
      preLoaderRoute: typeof AuthedDashboardSettingsDetailsRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/delete-account': {
      id: '/_authed/dashboard/settings/delete-account'
      path: '/delete-account'
      fullPath: '/dashboard/settings/delete-account'
      preLoaderRoute: typeof AuthedDashboardSettingsDeleteAccountRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/consent-privacy': {
      id: '/_authed/dashboard/settings/consent-privacy'
      path: '/consent-privacy'
      fullPath: '/dashboard/settings/consent-privacy'
      preLoaderRoute: typeof AuthedDashboardSettingsConsentPrivacyRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/consent-forms': {
      id: '/_authed/dashboard/settings/consent-forms'
      path: '/consent-forms'
      fullPath: '/dashboard/settings/consent-forms'
      preLoaderRoute: typeof AuthedDashboardSettingsConsentFormsRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/claire-whatsapp': {
      id: '/_authed/dashboard/settings/claire-whatsapp'
      path: '/claire-whatsapp'
      fullPath: '/dashboard/settings/claire-whatsapp'
      preLoaderRoute: typeof AuthedDashboardSettingsClaireWhatsappRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/claire-memories': {
      id: '/_authed/dashboard/settings/claire-memories'
      path: '/claire-memories'
      fullPath: '/dashboard/settings/claire-memories'
      preLoaderRoute: typeof AuthedDashboardSettingsClaireMemoriesRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/claire-campaigns': {
      id: '/_authed/dashboard/settings/claire-campaigns'
      path: '/claire-campaigns'
      fullPath: '/dashboard/settings/claire-campaigns'
      preLoaderRoute: typeof AuthedDashboardSettingsClaireCampaignsRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/chatbot': {
      id: '/_authed/dashboard/settings/chatbot'
      path: '/chatbot'
      fullPath: '/dashboard/settings/chatbot'
      preLoaderRoute: typeof AuthedDashboardSettingsChatbotRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/cancellations': {
      id: '/_authed/dashboard/settings/cancellations'
      path: '/cancellations'
      fullPath: '/dashboard/settings/cancellations'
      preLoaderRoute: typeof AuthedDashboardSettingsCancellationsRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/bookings': {
      id: '/_authed/dashboard/settings/bookings'
      path: '/bookings'
      fullPath: '/dashboard/settings/bookings'
      preLoaderRoute: typeof AuthedDashboardSettingsBookingsRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/blocked-time-types': {
      id: '/_authed/dashboard/settings/blocked-time-types'
      path: '/blocked-time-types'
      fullPath: '/dashboard/settings/blocked-time-types'
      preLoaderRoute: typeof AuthedDashboardSettingsBlockedTimeTypesRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/settings/billing': {
      id: '/_authed/dashboard/settings/billing'
      path: '/billing'
      fullPath: '/dashboard/settings/billing'
      preLoaderRoute: typeof AuthedDashboardSettingsBillingRouteImport
      parentRoute: typeof AuthedDashboardSettingsRoute
    }
    '/_authed/dashboard/services/new': {
      id: '/_authed/dashboard/services/new'
      path: '/services/new'
      fullPath: '/dashboard/services/new'
      preLoaderRoute: typeof AuthedDashboardServicesNewRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/more/$section': {
      id: '/_authed/dashboard/more/$section'
      path: '/more/$section'
      fullPath: '/dashboard/more/$section'
      preLoaderRoute: typeof AuthedDashboardMoreSectionRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/l/$locationId': {
      id: '/_authed/dashboard/l/$locationId'
      path: '/l/$locationId'
      fullPath: '/dashboard/l/$locationId'
      preLoaderRoute: typeof AuthedDashboardLLocationIdRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/debug/analysis-split-test': {
      id: '/_authed/dashboard/debug/analysis-split-test'
      path: '/debug/analysis-split-test'
      fullPath: '/dashboard/debug/analysis-split-test'
      preLoaderRoute: typeof AuthedDashboardDebugAnalysisSplitTestRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/content/videos': {
      id: '/_authed/dashboard/content/videos'
      path: '/content/videos'
      fullPath: '/dashboard/content/videos'
      preLoaderRoute: typeof AuthedDashboardContentVideosRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/content/new': {
      id: '/_authed/dashboard/content/new'
      path: '/content/new'
      fullPath: '/dashboard/content/new'
      preLoaderRoute: typeof AuthedDashboardContentNewRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/content/library': {
      id: '/_authed/dashboard/content/library'
      path: '/content/library'
      fullPath: '/dashboard/content/library'
      preLoaderRoute: typeof AuthedDashboardContentLibraryRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/content/images': {
      id: '/_authed/dashboard/content/images'
      path: '/content/images'
      fullPath: '/dashboard/content/images'
      preLoaderRoute: typeof AuthedDashboardContentImagesRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/content/gallery': {
      id: '/_authed/dashboard/content/gallery'
      path: '/content/gallery'
      fullPath: '/dashboard/content/gallery'
      preLoaderRoute: typeof AuthedDashboardContentGalleryRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/appointments/year': {
      id: '/_authed/dashboard/appointments/year'
      path: '/appointments/year'
      fullPath: '/dashboard/appointments/year'
      preLoaderRoute: typeof AuthedDashboardAppointmentsYearRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/appointments/week': {
      id: '/_authed/dashboard/appointments/week'
      path: '/appointments/week'
      fullPath: '/dashboard/appointments/week'
      preLoaderRoute: typeof AuthedDashboardAppointmentsWeekRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/appointments/month': {
      id: '/_authed/dashboard/appointments/month'
      path: '/appointments/month'
      fullPath: '/dashboard/appointments/month'
      preLoaderRoute: typeof AuthedDashboardAppointmentsMonthRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/appointments/day': {
      id: '/_authed/dashboard/appointments/day'
      path: '/appointments/day'
      fullPath: '/dashboard/appointments/day'
      preLoaderRoute: typeof AuthedDashboardAppointmentsDayRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/appointments/agenda': {
      id: '/_authed/dashboard/appointments/agenda'
      path: '/appointments/agenda'
      fullPath: '/dashboard/appointments/agenda'
      preLoaderRoute: typeof AuthedDashboardAppointmentsAgendaRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/advertising/new': {
      id: '/_authed/dashboard/advertising/new'
      path: '/advertising/new'
      fullPath: '/dashboard/advertising/new'
      preLoaderRoute: typeof AuthedDashboardAdvertisingNewRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/ads/new/video-format': {
      id: '/_authed/ads/new/video-format'
      path: '/ads/new/video-format'
      fullPath: '/ads/new/video-format'
      preLoaderRoute: typeof AuthedAdsNewVideoFormatRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_admin/admin/organizations/$id': {
      id: '/_admin/admin/organizations/$id'
      path: '/organizations/$id'
      fullPath: '/admin/organizations/$id'
      preLoaderRoute: typeof AdminAdminOrganizationsIdRouteImport
      parentRoute: typeof AdminAdminRoute
    }
    '/_authed/dashboard/settings/form-templates/': {
      id: '/_authed/dashboard/settings/form-templates/'
      path: '/'
      fullPath: '/dashboard/settings/form-templates/'
      preLoaderRoute: typeof AuthedDashboardSettingsFormTemplatesIndexRouteImport
      parentRoute: typeof AuthedDashboardSettingsFormTemplatesRoute
    }
    '/_authed/dashboard/appointments/new/': {
      id: '/_authed/dashboard/appointments/new/'
      path: '/appointments/new'
      fullPath: '/dashboard/appointments/new/'
      preLoaderRoute: typeof AuthedDashboardAppointmentsNewIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/advertising/$id/': {
      id: '/_authed/dashboard/advertising/$id/'
      path: '/advertising/$id'
      fullPath: '/dashboard/advertising/$id/'
      preLoaderRoute: typeof AuthedDashboardAdvertisingIdIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/socials/post/$id': {
      id: '/_authed/dashboard/socials/post/$id'
      path: '/socials/post/$id'
      fullPath: '/dashboard/socials/post/$id'
      preLoaderRoute: typeof AuthedDashboardSocialsPostIdRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/settings/form-templates/$formId': {
      id: '/_authed/dashboard/settings/form-templates/$formId'
      path: '/$formId'
      fullPath: '/dashboard/settings/form-templates/$formId'
      preLoaderRoute: typeof AuthedDashboardSettingsFormTemplatesFormIdRouteImport
      parentRoute: typeof AuthedDashboardSettingsFormTemplatesRoute
    }
    '/_authed/dashboard/services/$serviceId/edit': {
      id: '/_authed/dashboard/services/$serviceId/edit'
      path: '/services/$serviceId/edit'
      fullPath: '/dashboard/services/$serviceId/edit'
      preLoaderRoute: typeof AuthedDashboardServicesServiceIdEditRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/l/$locationId/venue': {
      id: '/_authed/dashboard/l/$locationId/venue'
      path: '/venue'
      fullPath: '/dashboard/l/$locationId/venue'
      preLoaderRoute: typeof AuthedDashboardLLocationIdVenueRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/sales': {
      id: '/_authed/dashboard/l/$locationId/sales'
      path: '/sales'
      fullPath: '/dashboard/l/$locationId/sales'
      preLoaderRoute: typeof AuthedDashboardLLocationIdSalesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/public-site': {
      id: '/_authed/dashboard/l/$locationId/public-site'
      path: '/public-site'
      fullPath: '/dashboard/l/$locationId/public-site'
      preLoaderRoute: typeof AuthedDashboardLLocationIdPublicSiteRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/marketing': {
      id: '/_authed/dashboard/l/$locationId/marketing'
      path: '/marketing'
      fullPath: '/dashboard/l/$locationId/marketing'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/home': {
      id: '/_authed/dashboard/l/$locationId/home'
      path: '/home'
      fullPath: '/dashboard/l/$locationId/home'
      preLoaderRoute: typeof AuthedDashboardLLocationIdHomeRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/deposits': {
      id: '/_authed/dashboard/l/$locationId/deposits'
      path: '/deposits'
      fullPath: '/dashboard/l/$locationId/deposits'
      preLoaderRoute: typeof AuthedDashboardLLocationIdDepositsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/customers': {
      id: '/_authed/dashboard/l/$locationId/customers'
      path: '/customers'
      fullPath: '/dashboard/l/$locationId/customers'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCustomersRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/content-calendar': {
      id: '/_authed/dashboard/l/$locationId/content-calendar'
      path: '/content-calendar'
      fullPath: '/dashboard/l/$locationId/content-calendar'
      preLoaderRoute: typeof AuthedDashboardLLocationIdContentCalendarRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/clients': {
      id: '/_authed/dashboard/l/$locationId/clients'
      path: '/clients'
      fullPath: '/dashboard/l/$locationId/clients'
      preLoaderRoute: typeof AuthedDashboardLLocationIdClientsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/calendar': {
      id: '/_authed/dashboard/l/$locationId/calendar'
      path: '/calendar'
      fullPath: '/dashboard/l/$locationId/calendar'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/ai-assistant': {
      id: '/_authed/dashboard/l/$locationId/ai-assistant'
      path: '/ai-assistant'
      fullPath: '/dashboard/l/$locationId/ai-assistant'
      preLoaderRoute: typeof AuthedDashboardLLocationIdAiAssistantRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/appointments/new/client': {
      id: '/_authed/dashboard/appointments/new/client'
      path: '/appointments/new/client'
      fullPath: '/dashboard/appointments/new/client'
      preLoaderRoute: typeof AuthedDashboardAppointmentsNewClientRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/appointments/new/block': {
      id: '/_authed/dashboard/appointments/new/block'
      path: '/appointments/new/block'
      fullPath: '/dashboard/appointments/new/block'
      preLoaderRoute: typeof AuthedDashboardAppointmentsNewBlockRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/l/$locationId/videos/': {
      id: '/_authed/dashboard/l/$locationId/videos/'
      path: '/videos'
      fullPath: '/dashboard/l/$locationId/videos/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdVideosIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/team/': {
      id: '/_authed/dashboard/l/$locationId/team/'
      path: '/team'
      fullPath: '/dashboard/l/$locationId/team/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdTeamIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/sales/': {
      id: '/_authed/dashboard/l/$locationId/sales/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/sales/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdSalesIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdSalesRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/': {
      id: '/_authed/dashboard/l/$locationId/marketing/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/marketing/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/content-calendar/': {
      id: '/_authed/dashboard/l/$locationId/content-calendar/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/content-calendar/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdContentCalendarIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdContentCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/clients/': {
      id: '/_authed/dashboard/l/$locationId/clients/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/clients/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdClientsIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdClientsRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/': {
      id: '/_authed/dashboard/l/$locationId/catalog/'
      path: '/catalog'
      fullPath: '/dashboard/l/$locationId/catalog/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/': {
      id: '/_authed/dashboard/l/$locationId/calendar/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/calendar/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/team/timesheets': {
      id: '/_authed/dashboard/l/$locationId/team/timesheets'
      path: '/team/timesheets'
      fullPath: '/dashboard/l/$locationId/team/timesheets'
      preLoaderRoute: typeof AuthedDashboardLLocationIdTeamTimesheetsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/team/shifts': {
      id: '/_authed/dashboard/l/$locationId/team/shifts'
      path: '/team/shifts'
      fullPath: '/dashboard/l/$locationId/team/shifts'
      preLoaderRoute: typeof AuthedDashboardLLocationIdTeamShiftsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/team/practitioners': {
      id: '/_authed/dashboard/l/$locationId/team/practitioners'
      path: '/team/practitioners'
      fullPath: '/dashboard/l/$locationId/team/practitioners'
      preLoaderRoute: typeof AuthedDashboardLLocationIdTeamPractitionersRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/team/members': {
      id: '/_authed/dashboard/l/$locationId/team/members'
      path: '/team/members'
      fullPath: '/dashboard/l/$locationId/team/members'
      preLoaderRoute: typeof AuthedDashboardLLocationIdTeamMembersRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/sales/product-orders': {
      id: '/_authed/dashboard/l/$locationId/sales/product-orders'
      path: '/product-orders'
      fullPath: '/dashboard/l/$locationId/sales/product-orders'
      preLoaderRoute: typeof AuthedDashboardLLocationIdSalesProductOrdersRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdSalesRoute
    }
    '/_authed/dashboard/l/$locationId/sales/payments': {
      id: '/_authed/dashboard/l/$locationId/sales/payments'
      path: '/payments'
      fullPath: '/dashboard/l/$locationId/sales/payments'
      preLoaderRoute: typeof AuthedDashboardLLocationIdSalesPaymentsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdSalesRoute
    }
    '/_authed/dashboard/l/$locationId/sales/memberships': {
      id: '/_authed/dashboard/l/$locationId/sales/memberships'
      path: '/memberships'
      fullPath: '/dashboard/l/$locationId/sales/memberships'
      preLoaderRoute: typeof AuthedDashboardLLocationIdSalesMembershipsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdSalesRoute
    }
    '/_authed/dashboard/l/$locationId/sales/list': {
      id: '/_authed/dashboard/l/$locationId/sales/list'
      path: '/list'
      fullPath: '/dashboard/l/$locationId/sales/list'
      preLoaderRoute: typeof AuthedDashboardLLocationIdSalesListRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdSalesRoute
    }
    '/_authed/dashboard/l/$locationId/sales/gift-cards': {
      id: '/_authed/dashboard/l/$locationId/sales/gift-cards'
      path: '/gift-cards'
      fullPath: '/dashboard/l/$locationId/sales/gift-cards'
      preLoaderRoute: typeof AuthedDashboardLLocationIdSalesGiftCardsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdSalesRoute
    }
    '/_authed/dashboard/l/$locationId/sales/daily-summary': {
      id: '/_authed/dashboard/l/$locationId/sales/daily-summary'
      path: '/daily-summary'
      fullPath: '/dashboard/l/$locationId/sales/daily-summary'
      preLoaderRoute: typeof AuthedDashboardLLocationIdSalesDailySummaryRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdSalesRoute
    }
    '/_authed/dashboard/l/$locationId/sales/appointments': {
      id: '/_authed/dashboard/l/$locationId/sales/appointments'
      path: '/appointments'
      fullPath: '/dashboard/l/$locationId/sales/appointments'
      preLoaderRoute: typeof AuthedDashboardLLocationIdSalesAppointmentsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdSalesRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/socials': {
      id: '/_authed/dashboard/l/$locationId/marketing/socials'
      path: '/socials'
      fullPath: '/dashboard/l/$locationId/marketing/socials'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/sequences': {
      id: '/_authed/dashboard/l/$locationId/marketing/sequences'
      path: '/sequences'
      fullPath: '/dashboard/l/$locationId/marketing/sequences'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingSequencesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/lead-forms': {
      id: '/_authed/dashboard/l/$locationId/marketing/lead-forms'
      path: '/lead-forms'
      fullPath: '/dashboard/l/$locationId/marketing/lead-forms'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingLeadFormsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/advertising': {
      id: '/_authed/dashboard/l/$locationId/marketing/advertising'
      path: '/advertising'
      fullPath: '/dashboard/l/$locationId/marketing/advertising'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/inventory/suppliers': {
      id: '/_authed/dashboard/l/$locationId/inventory/suppliers'
      path: '/inventory/suppliers'
      fullPath: '/dashboard/l/$locationId/inventory/suppliers'
      preLoaderRoute: typeof AuthedDashboardLLocationIdInventorySuppliersRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/inventory/stocktakes': {
      id: '/_authed/dashboard/l/$locationId/inventory/stocktakes'
      path: '/inventory/stocktakes'
      fullPath: '/dashboard/l/$locationId/inventory/stocktakes'
      preLoaderRoute: typeof AuthedDashboardLLocationIdInventoryStocktakesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/inventory/stock-orders': {
      id: '/_authed/dashboard/l/$locationId/inventory/stock-orders'
      path: '/inventory/stock-orders'
      fullPath: '/dashboard/l/$locationId/inventory/stock-orders'
      preLoaderRoute: typeof AuthedDashboardLLocationIdInventoryStockOrdersRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/inventory/categories': {
      id: '/_authed/dashboard/l/$locationId/inventory/categories'
      path: '/inventory/categories'
      fullPath: '/dashboard/l/$locationId/inventory/categories'
      preLoaderRoute: typeof AuthedDashboardLLocationIdInventoryCategoriesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/inventory/brands': {
      id: '/_authed/dashboard/l/$locationId/inventory/brands'
      path: '/inventory/brands'
      fullPath: '/dashboard/l/$locationId/inventory/brands'
      preLoaderRoute: typeof AuthedDashboardLLocationIdInventoryBrandsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/customers/$leadId': {
      id: '/_authed/dashboard/l/$locationId/customers/$leadId'
      path: '/$leadId'
      fullPath: '/dashboard/l/$locationId/customers/$leadId'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCustomersLeadIdRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCustomersRoute
    }
    '/_authed/dashboard/l/$locationId/content-calendar/week': {
      id: '/_authed/dashboard/l/$locationId/content-calendar/week'
      path: '/week'
      fullPath: '/dashboard/l/$locationId/content-calendar/week'
      preLoaderRoute: typeof AuthedDashboardLLocationIdContentCalendarWeekRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdContentCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/content-calendar/three-day': {
      id: '/_authed/dashboard/l/$locationId/content-calendar/three-day'
      path: '/three-day'
      fullPath: '/dashboard/l/$locationId/content-calendar/three-day'
      preLoaderRoute: typeof AuthedDashboardLLocationIdContentCalendarThreeDayRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdContentCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/content-calendar/month': {
      id: '/_authed/dashboard/l/$locationId/content-calendar/month'
      path: '/month'
      fullPath: '/dashboard/l/$locationId/content-calendar/month'
      preLoaderRoute: typeof AuthedDashboardLLocationIdContentCalendarMonthRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdContentCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/content-calendar/day': {
      id: '/_authed/dashboard/l/$locationId/content-calendar/day'
      path: '/day'
      fullPath: '/dashboard/l/$locationId/content-calendar/day'
      preLoaderRoute: typeof AuthedDashboardLLocationIdContentCalendarDayRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdContentCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/clients/list': {
      id: '/_authed/dashboard/l/$locationId/clients/list'
      path: '/list'
      fullPath: '/dashboard/l/$locationId/clients/list'
      preLoaderRoute: typeof AuthedDashboardLLocationIdClientsListRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdClientsRoute
    }
    '/_authed/dashboard/l/$locationId/clients/inbox': {
      id: '/_authed/dashboard/l/$locationId/clients/inbox'
      path: '/inbox'
      fullPath: '/dashboard/l/$locationId/clients/inbox'
      preLoaderRoute: typeof AuthedDashboardLLocationIdClientsInboxRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdClientsRoute
    }
    '/_authed/dashboard/l/$locationId/clients/$leadId': {
      id: '/_authed/dashboard/l/$locationId/clients/$leadId'
      path: '/$leadId'
      fullPath: '/dashboard/l/$locationId/clients/$leadId'
      preLoaderRoute: typeof AuthedDashboardLLocationIdClientsLeadIdRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdClientsRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/suppliers': {
      id: '/_authed/dashboard/l/$locationId/catalog/suppliers'
      path: '/catalog/suppliers'
      fullPath: '/dashboard/l/$locationId/catalog/suppliers'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogSuppliersRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/stocktakes': {
      id: '/_authed/dashboard/l/$locationId/catalog/stocktakes'
      path: '/catalog/stocktakes'
      fullPath: '/dashboard/l/$locationId/catalog/stocktakes'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogStocktakesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/stock-orders': {
      id: '/_authed/dashboard/l/$locationId/catalog/stock-orders'
      path: '/catalog/stock-orders'
      fullPath: '/dashboard/l/$locationId/catalog/stock-orders'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogStockOrdersRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/services': {
      id: '/_authed/dashboard/l/$locationId/catalog/services'
      path: '/catalog/services'
      fullPath: '/dashboard/l/$locationId/catalog/services'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogServicesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/resources': {
      id: '/_authed/dashboard/l/$locationId/catalog/resources'
      path: '/catalog/resources'
      fullPath: '/dashboard/l/$locationId/catalog/resources'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogResourcesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/products': {
      id: '/_authed/dashboard/l/$locationId/catalog/products'
      path: '/catalog/products'
      fullPath: '/dashboard/l/$locationId/catalog/products'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogProductsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/packages': {
      id: '/_authed/dashboard/l/$locationId/catalog/packages'
      path: '/catalog/packages'
      fullPath: '/dashboard/l/$locationId/catalog/packages'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogPackagesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/offers': {
      id: '/_authed/dashboard/l/$locationId/catalog/offers'
      path: '/catalog/offers'
      fullPath: '/dashboard/l/$locationId/catalog/offers'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogOffersRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/memberships': {
      id: '/_authed/dashboard/l/$locationId/catalog/memberships'
      path: '/catalog/memberships'
      fullPath: '/dashboard/l/$locationId/catalog/memberships'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogMembershipsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/categories': {
      id: '/_authed/dashboard/l/$locationId/catalog/categories'
      path: '/catalog/categories'
      fullPath: '/dashboard/l/$locationId/catalog/categories'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogCategoriesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/brands': {
      id: '/_authed/dashboard/l/$locationId/catalog/brands'
      path: '/catalog/brands'
      fullPath: '/dashboard/l/$locationId/catalog/brands'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogBrandsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/year': {
      id: '/_authed/dashboard/l/$locationId/calendar/year'
      path: '/year'
      fullPath: '/dashboard/l/$locationId/calendar/year'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarYearRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/week': {
      id: '/_authed/dashboard/l/$locationId/calendar/week'
      path: '/week'
      fullPath: '/dashboard/l/$locationId/calendar/week'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarWeekRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/three-day': {
      id: '/_authed/dashboard/l/$locationId/calendar/three-day'
      path: '/three-day'
      fullPath: '/dashboard/l/$locationId/calendar/three-day'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarThreeDayRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/rooms': {
      id: '/_authed/dashboard/l/$locationId/calendar/rooms'
      path: '/rooms'
      fullPath: '/dashboard/l/$locationId/calendar/rooms'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarRoomsRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/month': {
      id: '/_authed/dashboard/l/$locationId/calendar/month'
      path: '/month'
      fullPath: '/dashboard/l/$locationId/calendar/month'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarMonthRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/day': {
      id: '/_authed/dashboard/l/$locationId/calendar/day'
      path: '/day'
      fullPath: '/dashboard/l/$locationId/calendar/day'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarDayRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/agenda': {
      id: '/_authed/dashboard/l/$locationId/calendar/agenda'
      path: '/agenda'
      fullPath: '/dashboard/l/$locationId/calendar/agenda'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarAgendaRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/advertising/$id/ads/$adId': {
      id: '/_authed/dashboard/advertising/$id/ads/$adId'
      path: '/advertising/$id/ads/$adId'
      fullPath: '/dashboard/advertising/$id/ads/$adId'
      preLoaderRoute: typeof AuthedDashboardAdvertisingIdAdsAdIdRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/new': {
      id: '/_authed/dashboard/l/$locationId/calendar/new'
      path: '/new'
      fullPath: '/dashboard/l/$locationId/calendar/new'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarNewRouteRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/videos/create-from-client/': {
      id: '/_authed/dashboard/l/$locationId/videos/create-from-client/'
      path: '/videos/create-from-client'
      fullPath: '/dashboard/l/$locationId/videos/create-from-client/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdVideosCreateFromClientIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/socials/': {
      id: '/_authed/dashboard/l/$locationId/marketing/socials/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/marketing/socials/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingSocialsIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/music/': {
      id: '/_authed/dashboard/l/$locationId/marketing/music/'
      path: '/music'
      fullPath: '/dashboard/l/$locationId/marketing/music/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingMusicIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/gallery/': {
      id: '/_authed/dashboard/l/$locationId/marketing/gallery/'
      path: '/gallery'
      fullPath: '/dashboard/l/$locationId/marketing/gallery/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingGalleryIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/campaigns/': {
      id: '/_authed/dashboard/l/$locationId/marketing/campaigns/'
      path: '/campaigns'
      fullPath: '/dashboard/l/$locationId/marketing/campaigns/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/advertising/': {
      id: '/_authed/dashboard/l/$locationId/marketing/advertising/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/marketing/advertising/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingRoute
    }
    '/_authed/dashboard/l/$locationId/catalog/services/': {
      id: '/_authed/dashboard/l/$locationId/catalog/services/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/catalog/services/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCatalogServicesIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCatalogServicesRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/rooms/': {
      id: '/_authed/dashboard/l/$locationId/calendar/rooms/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/calendar/rooms/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarRoomsIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoomsRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/new/': {
      id: '/_authed/dashboard/l/$locationId/calendar/new/'
      path: '/'
      fullPath: '/dashboard/l/$locationId/calendar/new/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarNewIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarNewRouteRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/socials/scheduled': {
      id: '/_authed/dashboard/l/$locationId/marketing/socials/scheduled'
      path: '/scheduled'
      fullPath: '/dashboard/l/$locationId/marketing/socials/scheduled'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingSocialsScheduledRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/socials/review': {
      id: '/_authed/dashboard/l/$locationId/marketing/socials/review'
      path: '/review'
      fullPath: '/dashboard/l/$locationId/marketing/socials/review'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingSocialsReviewRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/socials/recent': {
      id: '/_authed/dashboard/l/$locationId/marketing/socials/recent'
      path: '/recent'
      fullPath: '/dashboard/l/$locationId/marketing/socials/recent'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRecentRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/gallery/videos': {
      id: '/_authed/dashboard/l/$locationId/marketing/gallery/videos'
      path: '/gallery/videos'
      fullPath: '/dashboard/l/$locationId/marketing/gallery/videos'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingGalleryVideosRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/gallery/library': {
      id: '/_authed/dashboard/l/$locationId/marketing/gallery/library'
      path: '/gallery/library'
      fullPath: '/dashboard/l/$locationId/marketing/gallery/library'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingGalleryLibraryRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/gallery/images': {
      id: '/_authed/dashboard/l/$locationId/marketing/gallery/images'
      path: '/gallery/images'
      fullPath: '/dashboard/l/$locationId/marketing/gallery/images'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingGalleryImagesRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/advertising/new': {
      id: '/_authed/dashboard/l/$locationId/marketing/advertising/new'
      path: '/new'
      fullPath: '/dashboard/l/$locationId/marketing/advertising/new'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingNewRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingRoute
    }
    '/_authed/dashboard/l/$locationId/customers/$leadId/form': {
      id: '/_authed/dashboard/l/$locationId/customers/$leadId/form'
      path: '/form'
      fullPath: '/dashboard/l/$locationId/customers/$leadId/form'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCustomersLeadIdFormRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCustomersLeadIdRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/rooms/week': {
      id: '/_authed/dashboard/l/$locationId/calendar/rooms/week'
      path: '/week'
      fullPath: '/dashboard/l/$locationId/calendar/rooms/week'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarRoomsWeekRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoomsRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/rooms/three-day': {
      id: '/_authed/dashboard/l/$locationId/calendar/rooms/three-day'
      path: '/three-day'
      fullPath: '/dashboard/l/$locationId/calendar/rooms/three-day'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarRoomsThreeDayRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoomsRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/rooms/month': {
      id: '/_authed/dashboard/l/$locationId/calendar/rooms/month'
      path: '/month'
      fullPath: '/dashboard/l/$locationId/calendar/rooms/month'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarRoomsMonthRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoomsRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/rooms/day': {
      id: '/_authed/dashboard/l/$locationId/calendar/rooms/day'
      path: '/day'
      fullPath: '/dashboard/l/$locationId/calendar/rooms/day'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarRoomsDayRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoomsRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/new/client': {
      id: '/_authed/dashboard/l/$locationId/calendar/new/client'
      path: '/client'
      fullPath: '/dashboard/l/$locationId/calendar/new/client'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarNewClientRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarNewRouteRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/new/block': {
      id: '/_authed/dashboard/l/$locationId/calendar/new/block'
      path: '/block'
      fullPath: '/dashboard/l/$locationId/calendar/new/block'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarNewBlockRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarNewRouteRoute
    }
    '/_authed/dashboard/l/$locationId/calendar/appointment/$appointmentId': {
      id: '/_authed/dashboard/l/$locationId/calendar/appointment/$appointmentId'
      path: '/appointment/$appointmentId'
      fullPath: '/dashboard/l/$locationId/calendar/appointment/$appointmentId'
      preLoaderRoute: typeof AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdCalendarRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/socials/new/': {
      id: '/_authed/dashboard/l/$locationId/marketing/socials/new/'
      path: '/new'
      fullPath: '/dashboard/l/$locationId/marketing/socials/new/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingSocialsNewIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/gallery/new/': {
      id: '/_authed/dashboard/l/$locationId/marketing/gallery/new/'
      path: '/gallery/new'
      fullPath: '/dashboard/l/$locationId/marketing/gallery/new/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingGalleryNewIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/campaigns/segments/': {
      id: '/_authed/dashboard/l/$locationId/marketing/campaigns/segments/'
      path: '/campaigns/segments'
      fullPath: '/dashboard/l/$locationId/marketing/campaigns/segments/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/campaigns/new/': {
      id: '/_authed/dashboard/l/$locationId/marketing/campaigns/new/'
      path: '/campaigns/new'
      fullPath: '/dashboard/l/$locationId/marketing/campaigns/new/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsNewIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/campaigns/$id/': {
      id: '/_authed/dashboard/l/$locationId/marketing/campaigns/$id/'
      path: '/campaigns/$id'
      fullPath: '/dashboard/l/$locationId/marketing/campaigns/$id/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsIdIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/advertising/$id/': {
      id: '/_authed/dashboard/l/$locationId/marketing/advertising/$id/'
      path: '/$id'
      fullPath: '/dashboard/l/$locationId/marketing/advertising/$id/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/socials/post/$id': {
      id: '/_authed/dashboard/l/$locationId/marketing/socials/post/$id'
      path: '/post/$id'
      fullPath: '/dashboard/l/$locationId/marketing/socials/post/$id'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingSocialsPostIdRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/campaigns/segments/new/': {
      id: '/_authed/dashboard/l/$locationId/marketing/campaigns/segments/new/'
      path: '/campaigns/segments/new'
      fullPath: '/dashboard/l/$locationId/marketing/campaigns/segments/new/'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingRoute
    }
    '/_authed/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId': {
      id: '/_authed/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId'
      path: '/$id/ads/$adId'
      fullPath: '/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId'
      preLoaderRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRouteImport
      parentRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingRoute
    }
  }
}

interface AdminAdminRouteChildren {
  AdminAdminAdvertisingRoute: typeof AdminAdminAdvertisingRoute
  AdminAdminAuditLogRoute: typeof AdminAdminAuditLogRoute
  AdminAdminClaireFailureGroupsRoute: typeof AdminAdminClaireFailureGroupsRoute
  AdminAdminClaireRegressionsRoute: typeof AdminAdminClaireRegressionsRoute
  AdminAdminConversationsRoute: typeof AdminAdminConversationsRoute
  AdminAdminCrmTriggersRoute: typeof AdminAdminCrmTriggersRoute
  AdminAdminHarnessRoute: typeof AdminAdminHarnessRoute
  AdminAdminImportsRoute: typeof AdminAdminImportsRoute
  AdminAdminMetaConnectionsRoute: typeof AdminAdminMetaConnectionsRoute
  AdminAdminMusicRoute: typeof AdminAdminMusicRoute
  AdminAdminScrapingRoute: typeof AdminAdminScrapingRoute
  AdminAdminStockFootageRoute: typeof AdminAdminStockFootageRoute
  AdminAdminStuckSetupRoute: typeof AdminAdminStuckSetupRoute
  AdminAdminIndexRoute: typeof AdminAdminIndexRoute
  AdminAdminOrganizationsIdRoute: typeof AdminAdminOrganizationsIdRoute
}

const AdminAdminRouteChildren: AdminAdminRouteChildren = {
  AdminAdminAdvertisingRoute: AdminAdminAdvertisingRoute,
  AdminAdminAuditLogRoute: AdminAdminAuditLogRoute,
  AdminAdminClaireFailureGroupsRoute: AdminAdminClaireFailureGroupsRoute,
  AdminAdminClaireRegressionsRoute: AdminAdminClaireRegressionsRoute,
  AdminAdminConversationsRoute: AdminAdminConversationsRoute,
  AdminAdminCrmTriggersRoute: AdminAdminCrmTriggersRoute,
  AdminAdminHarnessRoute: AdminAdminHarnessRoute,
  AdminAdminImportsRoute: AdminAdminImportsRoute,
  AdminAdminMetaConnectionsRoute: AdminAdminMetaConnectionsRoute,
  AdminAdminMusicRoute: AdminAdminMusicRoute,
  AdminAdminScrapingRoute: AdminAdminScrapingRoute,
  AdminAdminStockFootageRoute: AdminAdminStockFootageRoute,
  AdminAdminStuckSetupRoute: AdminAdminStuckSetupRoute,
  AdminAdminIndexRoute: AdminAdminIndexRoute,
  AdminAdminOrganizationsIdRoute: AdminAdminOrganizationsIdRoute,
}

const AdminAdminRouteWithChildren = AdminAdminRoute._addFileChildren(
  AdminAdminRouteChildren,
)

interface AdminRouteChildren {
  AdminAdminRoute: typeof AdminAdminRouteWithChildren
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminRoute: AdminAdminRouteWithChildren,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AuthedDashboardSettingsFormTemplatesRouteChildren {
  AuthedDashboardSettingsFormTemplatesFormIdRoute: typeof AuthedDashboardSettingsFormTemplatesFormIdRoute
  AuthedDashboardSettingsFormTemplatesIndexRoute: typeof AuthedDashboardSettingsFormTemplatesIndexRoute
}

const AuthedDashboardSettingsFormTemplatesRouteChildren: AuthedDashboardSettingsFormTemplatesRouteChildren =
  {
    AuthedDashboardSettingsFormTemplatesFormIdRoute:
      AuthedDashboardSettingsFormTemplatesFormIdRoute,
    AuthedDashboardSettingsFormTemplatesIndexRoute:
      AuthedDashboardSettingsFormTemplatesIndexRoute,
  }

const AuthedDashboardSettingsFormTemplatesRouteWithChildren =
  AuthedDashboardSettingsFormTemplatesRoute._addFileChildren(
    AuthedDashboardSettingsFormTemplatesRouteChildren,
  )

interface AuthedDashboardSettingsRouteChildren {
  AuthedDashboardSettingsBillingRoute: typeof AuthedDashboardSettingsBillingRoute
  AuthedDashboardSettingsBlockedTimeTypesRoute: typeof AuthedDashboardSettingsBlockedTimeTypesRoute
  AuthedDashboardSettingsBookingsRoute: typeof AuthedDashboardSettingsBookingsRoute
  AuthedDashboardSettingsCancellationsRoute: typeof AuthedDashboardSettingsCancellationsRoute
  AuthedDashboardSettingsChatbotRoute: typeof AuthedDashboardSettingsChatbotRoute
  AuthedDashboardSettingsClaireCampaignsRoute: typeof AuthedDashboardSettingsClaireCampaignsRoute
  AuthedDashboardSettingsClaireMemoriesRoute: typeof AuthedDashboardSettingsClaireMemoriesRoute
  AuthedDashboardSettingsClaireWhatsappRoute: typeof AuthedDashboardSettingsClaireWhatsappRoute
  AuthedDashboardSettingsConsentFormsRoute: typeof AuthedDashboardSettingsConsentFormsRoute
  AuthedDashboardSettingsConsentPrivacyRoute: typeof AuthedDashboardSettingsConsentPrivacyRoute
  AuthedDashboardSettingsDeleteAccountRoute: typeof AuthedDashboardSettingsDeleteAccountRoute
  AuthedDashboardSettingsDetailsRoute: typeof AuthedDashboardSettingsDetailsRoute
  AuthedDashboardSettingsExamplesRoute: typeof AuthedDashboardSettingsExamplesRoute
  AuthedDashboardSettingsFormTemplatesRoute: typeof AuthedDashboardSettingsFormTemplatesRouteWithChildren
  AuthedDashboardSettingsIntegrationsRoute: typeof AuthedDashboardSettingsIntegrationsRoute
  AuthedDashboardSettingsMessageTemplatesRoute: typeof AuthedDashboardSettingsMessageTemplatesRoute
  AuthedDashboardSettingsNotificationsRoute: typeof AuthedDashboardSettingsNotificationsRoute
  AuthedDashboardSettingsPaymentsRoute: typeof AuthedDashboardSettingsPaymentsRoute
  AuthedDashboardSettingsPostTreatmentReviewsRoute: typeof AuthedDashboardSettingsPostTreatmentReviewsRoute
  AuthedDashboardSettingsRemindersRoute: typeof AuthedDashboardSettingsRemindersRoute
  AuthedDashboardSettingsSchedulingRoute: typeof AuthedDashboardSettingsSchedulingRoute
  AuthedDashboardSettingsStyleRoute: typeof AuthedDashboardSettingsStyleRoute
  AuthedDashboardSettingsIndexRoute: typeof AuthedDashboardSettingsIndexRoute
}

const AuthedDashboardSettingsRouteChildren: AuthedDashboardSettingsRouteChildren =
  {
    AuthedDashboardSettingsBillingRoute: AuthedDashboardSettingsBillingRoute,
    AuthedDashboardSettingsBlockedTimeTypesRoute:
      AuthedDashboardSettingsBlockedTimeTypesRoute,
    AuthedDashboardSettingsBookingsRoute: AuthedDashboardSettingsBookingsRoute,
    AuthedDashboardSettingsCancellationsRoute:
      AuthedDashboardSettingsCancellationsRoute,
    AuthedDashboardSettingsChatbotRoute: AuthedDashboardSettingsChatbotRoute,
    AuthedDashboardSettingsClaireCampaignsRoute:
      AuthedDashboardSettingsClaireCampaignsRoute,
    AuthedDashboardSettingsClaireMemoriesRoute:
      AuthedDashboardSettingsClaireMemoriesRoute,
    AuthedDashboardSettingsClaireWhatsappRoute:
      AuthedDashboardSettingsClaireWhatsappRoute,
    AuthedDashboardSettingsConsentFormsRoute:
      AuthedDashboardSettingsConsentFormsRoute,
    AuthedDashboardSettingsConsentPrivacyRoute:
      AuthedDashboardSettingsConsentPrivacyRoute,
    AuthedDashboardSettingsDeleteAccountRoute:
      AuthedDashboardSettingsDeleteAccountRoute,
    AuthedDashboardSettingsDetailsRoute: AuthedDashboardSettingsDetailsRoute,
    AuthedDashboardSettingsExamplesRoute: AuthedDashboardSettingsExamplesRoute,
    AuthedDashboardSettingsFormTemplatesRoute:
      AuthedDashboardSettingsFormTemplatesRouteWithChildren,
    AuthedDashboardSettingsIntegrationsRoute:
      AuthedDashboardSettingsIntegrationsRoute,
    AuthedDashboardSettingsMessageTemplatesRoute:
      AuthedDashboardSettingsMessageTemplatesRoute,
    AuthedDashboardSettingsNotificationsRoute:
      AuthedDashboardSettingsNotificationsRoute,
    AuthedDashboardSettingsPaymentsRoute: AuthedDashboardSettingsPaymentsRoute,
    AuthedDashboardSettingsPostTreatmentReviewsRoute:
      AuthedDashboardSettingsPostTreatmentReviewsRoute,
    AuthedDashboardSettingsRemindersRoute:
      AuthedDashboardSettingsRemindersRoute,
    AuthedDashboardSettingsSchedulingRoute:
      AuthedDashboardSettingsSchedulingRoute,
    AuthedDashboardSettingsStyleRoute: AuthedDashboardSettingsStyleRoute,
    AuthedDashboardSettingsIndexRoute: AuthedDashboardSettingsIndexRoute,
  }

const AuthedDashboardSettingsRouteWithChildren =
  AuthedDashboardSettingsRoute._addFileChildren(
    AuthedDashboardSettingsRouteChildren,
  )

interface AuthedDashboardWireframesRouteChildren {
  AuthedDashboardWireframesCalendarDayRoute: typeof AuthedDashboardWireframesCalendarDayRoute
  AuthedDashboardWireframesCalendarSidePanelRoute: typeof AuthedDashboardWireframesCalendarSidePanelRoute
  AuthedDashboardWireframesCalendarWeekRoute: typeof AuthedDashboardWireframesCalendarWeekRoute
  AuthedDashboardWireframesConsentComplianceRoute: typeof AuthedDashboardWireframesConsentComplianceRoute
  AuthedDashboardWireframesDataPrivacyRoute: typeof AuthedDashboardWireframesDataPrivacyRoute
  AuthedDashboardWireframesDepositsRoute: typeof AuthedDashboardWireframesDepositsRoute
  AuthedDashboardWireframesPhotosRoute: typeof AuthedDashboardWireframesPhotosRoute
  AuthedDashboardWireframesRemindersSettingsRoute: typeof AuthedDashboardWireframesRemindersSettingsRoute
  AuthedDashboardWireframesReportsRoute: typeof AuthedDashboardWireframesReportsRoute
  AuthedDashboardWireframesRetentionRoute: typeof AuthedDashboardWireframesRetentionRoute
  AuthedDashboardWireframesReviewsRoute: typeof AuthedDashboardWireframesReviewsRoute
  AuthedDashboardWireframesSearchRoute: typeof AuthedDashboardWireframesSearchRoute
  AuthedDashboardWireframesSequencesRoute: typeof AuthedDashboardWireframesSequencesRoute
  AuthedDashboardWireframesSettingsRoute: typeof AuthedDashboardWireframesSettingsRoute
  AuthedDashboardWireframesSkinAnalysisRoute: typeof AuthedDashboardWireframesSkinAnalysisRoute
  AuthedDashboardWireframesViewShellRoute: typeof AuthedDashboardWireframesViewShellRoute
  AuthedDashboardWireframesIndexRoute: typeof AuthedDashboardWireframesIndexRoute
}

const AuthedDashboardWireframesRouteChildren: AuthedDashboardWireframesRouteChildren =
  {
    AuthedDashboardWireframesCalendarDayRoute:
      AuthedDashboardWireframesCalendarDayRoute,
    AuthedDashboardWireframesCalendarSidePanelRoute:
      AuthedDashboardWireframesCalendarSidePanelRoute,
    AuthedDashboardWireframesCalendarWeekRoute:
      AuthedDashboardWireframesCalendarWeekRoute,
    AuthedDashboardWireframesConsentComplianceRoute:
      AuthedDashboardWireframesConsentComplianceRoute,
    AuthedDashboardWireframesDataPrivacyRoute:
      AuthedDashboardWireframesDataPrivacyRoute,
    AuthedDashboardWireframesDepositsRoute:
      AuthedDashboardWireframesDepositsRoute,
    AuthedDashboardWireframesPhotosRoute: AuthedDashboardWireframesPhotosRoute,
    AuthedDashboardWireframesRemindersSettingsRoute:
      AuthedDashboardWireframesRemindersSettingsRoute,
    AuthedDashboardWireframesReportsRoute:
      AuthedDashboardWireframesReportsRoute,
    AuthedDashboardWireframesRetentionRoute:
      AuthedDashboardWireframesRetentionRoute,
    AuthedDashboardWireframesReviewsRoute:
      AuthedDashboardWireframesReviewsRoute,
    AuthedDashboardWireframesSearchRoute: AuthedDashboardWireframesSearchRoute,
    AuthedDashboardWireframesSequencesRoute:
      AuthedDashboardWireframesSequencesRoute,
    AuthedDashboardWireframesSettingsRoute:
      AuthedDashboardWireframesSettingsRoute,
    AuthedDashboardWireframesSkinAnalysisRoute:
      AuthedDashboardWireframesSkinAnalysisRoute,
    AuthedDashboardWireframesViewShellRoute:
      AuthedDashboardWireframesViewShellRoute,
    AuthedDashboardWireframesIndexRoute: AuthedDashboardWireframesIndexRoute,
  }

const AuthedDashboardWireframesRouteWithChildren =
  AuthedDashboardWireframesRoute._addFileChildren(
    AuthedDashboardWireframesRouteChildren,
  )

interface AuthedDashboardLLocationIdCalendarNewRouteRouteChildren {
  AuthedDashboardLLocationIdCalendarNewBlockRoute: typeof AuthedDashboardLLocationIdCalendarNewBlockRoute
  AuthedDashboardLLocationIdCalendarNewClientRoute: typeof AuthedDashboardLLocationIdCalendarNewClientRoute
  AuthedDashboardLLocationIdCalendarNewIndexRoute: typeof AuthedDashboardLLocationIdCalendarNewIndexRoute
}

const AuthedDashboardLLocationIdCalendarNewRouteRouteChildren: AuthedDashboardLLocationIdCalendarNewRouteRouteChildren =
  {
    AuthedDashboardLLocationIdCalendarNewBlockRoute:
      AuthedDashboardLLocationIdCalendarNewBlockRoute,
    AuthedDashboardLLocationIdCalendarNewClientRoute:
      AuthedDashboardLLocationIdCalendarNewClientRoute,
    AuthedDashboardLLocationIdCalendarNewIndexRoute:
      AuthedDashboardLLocationIdCalendarNewIndexRoute,
  }

const AuthedDashboardLLocationIdCalendarNewRouteRouteWithChildren =
  AuthedDashboardLLocationIdCalendarNewRouteRoute._addFileChildren(
    AuthedDashboardLLocationIdCalendarNewRouteRouteChildren,
  )

interface AuthedDashboardLLocationIdCalendarRoomsRouteChildren {
  AuthedDashboardLLocationIdCalendarRoomsDayRoute: typeof AuthedDashboardLLocationIdCalendarRoomsDayRoute
  AuthedDashboardLLocationIdCalendarRoomsMonthRoute: typeof AuthedDashboardLLocationIdCalendarRoomsMonthRoute
  AuthedDashboardLLocationIdCalendarRoomsThreeDayRoute: typeof AuthedDashboardLLocationIdCalendarRoomsThreeDayRoute
  AuthedDashboardLLocationIdCalendarRoomsWeekRoute: typeof AuthedDashboardLLocationIdCalendarRoomsWeekRoute
  AuthedDashboardLLocationIdCalendarRoomsIndexRoute: typeof AuthedDashboardLLocationIdCalendarRoomsIndexRoute
}

const AuthedDashboardLLocationIdCalendarRoomsRouteChildren: AuthedDashboardLLocationIdCalendarRoomsRouteChildren =
  {
    AuthedDashboardLLocationIdCalendarRoomsDayRoute:
      AuthedDashboardLLocationIdCalendarRoomsDayRoute,
    AuthedDashboardLLocationIdCalendarRoomsMonthRoute:
      AuthedDashboardLLocationIdCalendarRoomsMonthRoute,
    AuthedDashboardLLocationIdCalendarRoomsThreeDayRoute:
      AuthedDashboardLLocationIdCalendarRoomsThreeDayRoute,
    AuthedDashboardLLocationIdCalendarRoomsWeekRoute:
      AuthedDashboardLLocationIdCalendarRoomsWeekRoute,
    AuthedDashboardLLocationIdCalendarRoomsIndexRoute:
      AuthedDashboardLLocationIdCalendarRoomsIndexRoute,
  }

const AuthedDashboardLLocationIdCalendarRoomsRouteWithChildren =
  AuthedDashboardLLocationIdCalendarRoomsRoute._addFileChildren(
    AuthedDashboardLLocationIdCalendarRoomsRouteChildren,
  )

interface AuthedDashboardLLocationIdCalendarRouteChildren {
  AuthedDashboardLLocationIdCalendarNewRouteRoute: typeof AuthedDashboardLLocationIdCalendarNewRouteRouteWithChildren
  AuthedDashboardLLocationIdCalendarAgendaRoute: typeof AuthedDashboardLLocationIdCalendarAgendaRoute
  AuthedDashboardLLocationIdCalendarDayRoute: typeof AuthedDashboardLLocationIdCalendarDayRoute
  AuthedDashboardLLocationIdCalendarMonthRoute: typeof AuthedDashboardLLocationIdCalendarMonthRoute
  AuthedDashboardLLocationIdCalendarRoomsRoute: typeof AuthedDashboardLLocationIdCalendarRoomsRouteWithChildren
  AuthedDashboardLLocationIdCalendarThreeDayRoute: typeof AuthedDashboardLLocationIdCalendarThreeDayRoute
  AuthedDashboardLLocationIdCalendarWeekRoute: typeof AuthedDashboardLLocationIdCalendarWeekRoute
  AuthedDashboardLLocationIdCalendarYearRoute: typeof AuthedDashboardLLocationIdCalendarYearRoute
  AuthedDashboardLLocationIdCalendarIndexRoute: typeof AuthedDashboardLLocationIdCalendarIndexRoute
  AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRoute: typeof AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRoute
}

const AuthedDashboardLLocationIdCalendarRouteChildren: AuthedDashboardLLocationIdCalendarRouteChildren =
  {
    AuthedDashboardLLocationIdCalendarNewRouteRoute:
      AuthedDashboardLLocationIdCalendarNewRouteRouteWithChildren,
    AuthedDashboardLLocationIdCalendarAgendaRoute:
      AuthedDashboardLLocationIdCalendarAgendaRoute,
    AuthedDashboardLLocationIdCalendarDayRoute:
      AuthedDashboardLLocationIdCalendarDayRoute,
    AuthedDashboardLLocationIdCalendarMonthRoute:
      AuthedDashboardLLocationIdCalendarMonthRoute,
    AuthedDashboardLLocationIdCalendarRoomsRoute:
      AuthedDashboardLLocationIdCalendarRoomsRouteWithChildren,
    AuthedDashboardLLocationIdCalendarThreeDayRoute:
      AuthedDashboardLLocationIdCalendarThreeDayRoute,
    AuthedDashboardLLocationIdCalendarWeekRoute:
      AuthedDashboardLLocationIdCalendarWeekRoute,
    AuthedDashboardLLocationIdCalendarYearRoute:
      AuthedDashboardLLocationIdCalendarYearRoute,
    AuthedDashboardLLocationIdCalendarIndexRoute:
      AuthedDashboardLLocationIdCalendarIndexRoute,
    AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRoute:
      AuthedDashboardLLocationIdCalendarAppointmentAppointmentIdRoute,
  }

const AuthedDashboardLLocationIdCalendarRouteWithChildren =
  AuthedDashboardLLocationIdCalendarRoute._addFileChildren(
    AuthedDashboardLLocationIdCalendarRouteChildren,
  )

interface AuthedDashboardLLocationIdClientsRouteChildren {
  AuthedDashboardLLocationIdClientsLeadIdRoute: typeof AuthedDashboardLLocationIdClientsLeadIdRoute
  AuthedDashboardLLocationIdClientsInboxRoute: typeof AuthedDashboardLLocationIdClientsInboxRoute
  AuthedDashboardLLocationIdClientsListRoute: typeof AuthedDashboardLLocationIdClientsListRoute
  AuthedDashboardLLocationIdClientsIndexRoute: typeof AuthedDashboardLLocationIdClientsIndexRoute
}

const AuthedDashboardLLocationIdClientsRouteChildren: AuthedDashboardLLocationIdClientsRouteChildren =
  {
    AuthedDashboardLLocationIdClientsLeadIdRoute:
      AuthedDashboardLLocationIdClientsLeadIdRoute,
    AuthedDashboardLLocationIdClientsInboxRoute:
      AuthedDashboardLLocationIdClientsInboxRoute,
    AuthedDashboardLLocationIdClientsListRoute:
      AuthedDashboardLLocationIdClientsListRoute,
    AuthedDashboardLLocationIdClientsIndexRoute:
      AuthedDashboardLLocationIdClientsIndexRoute,
  }

const AuthedDashboardLLocationIdClientsRouteWithChildren =
  AuthedDashboardLLocationIdClientsRoute._addFileChildren(
    AuthedDashboardLLocationIdClientsRouteChildren,
  )

interface AuthedDashboardLLocationIdContentCalendarRouteChildren {
  AuthedDashboardLLocationIdContentCalendarDayRoute: typeof AuthedDashboardLLocationIdContentCalendarDayRoute
  AuthedDashboardLLocationIdContentCalendarMonthRoute: typeof AuthedDashboardLLocationIdContentCalendarMonthRoute
  AuthedDashboardLLocationIdContentCalendarThreeDayRoute: typeof AuthedDashboardLLocationIdContentCalendarThreeDayRoute
  AuthedDashboardLLocationIdContentCalendarWeekRoute: typeof AuthedDashboardLLocationIdContentCalendarWeekRoute
  AuthedDashboardLLocationIdContentCalendarIndexRoute: typeof AuthedDashboardLLocationIdContentCalendarIndexRoute
}

const AuthedDashboardLLocationIdContentCalendarRouteChildren: AuthedDashboardLLocationIdContentCalendarRouteChildren =
  {
    AuthedDashboardLLocationIdContentCalendarDayRoute:
      AuthedDashboardLLocationIdContentCalendarDayRoute,
    AuthedDashboardLLocationIdContentCalendarMonthRoute:
      AuthedDashboardLLocationIdContentCalendarMonthRoute,
    AuthedDashboardLLocationIdContentCalendarThreeDayRoute:
      AuthedDashboardLLocationIdContentCalendarThreeDayRoute,
    AuthedDashboardLLocationIdContentCalendarWeekRoute:
      AuthedDashboardLLocationIdContentCalendarWeekRoute,
    AuthedDashboardLLocationIdContentCalendarIndexRoute:
      AuthedDashboardLLocationIdContentCalendarIndexRoute,
  }

const AuthedDashboardLLocationIdContentCalendarRouteWithChildren =
  AuthedDashboardLLocationIdContentCalendarRoute._addFileChildren(
    AuthedDashboardLLocationIdContentCalendarRouteChildren,
  )

interface AuthedDashboardLLocationIdCustomersLeadIdRouteChildren {
  AuthedDashboardLLocationIdCustomersLeadIdFormRoute: typeof AuthedDashboardLLocationIdCustomersLeadIdFormRoute
}

const AuthedDashboardLLocationIdCustomersLeadIdRouteChildren: AuthedDashboardLLocationIdCustomersLeadIdRouteChildren =
  {
    AuthedDashboardLLocationIdCustomersLeadIdFormRoute:
      AuthedDashboardLLocationIdCustomersLeadIdFormRoute,
  }

const AuthedDashboardLLocationIdCustomersLeadIdRouteWithChildren =
  AuthedDashboardLLocationIdCustomersLeadIdRoute._addFileChildren(
    AuthedDashboardLLocationIdCustomersLeadIdRouteChildren,
  )

interface AuthedDashboardLLocationIdCustomersRouteChildren {
  AuthedDashboardLLocationIdCustomersLeadIdRoute: typeof AuthedDashboardLLocationIdCustomersLeadIdRouteWithChildren
}

const AuthedDashboardLLocationIdCustomersRouteChildren: AuthedDashboardLLocationIdCustomersRouteChildren =
  {
    AuthedDashboardLLocationIdCustomersLeadIdRoute:
      AuthedDashboardLLocationIdCustomersLeadIdRouteWithChildren,
  }

const AuthedDashboardLLocationIdCustomersRouteWithChildren =
  AuthedDashboardLLocationIdCustomersRoute._addFileChildren(
    AuthedDashboardLLocationIdCustomersRouteChildren,
  )

interface AuthedDashboardLLocationIdMarketingAdvertisingRouteChildren {
  AuthedDashboardLLocationIdMarketingAdvertisingNewRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingNewRoute
  AuthedDashboardLLocationIdMarketingAdvertisingIndexRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingIndexRoute
  AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRoute
  AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRoute
}

const AuthedDashboardLLocationIdMarketingAdvertisingRouteChildren: AuthedDashboardLLocationIdMarketingAdvertisingRouteChildren =
  {
    AuthedDashboardLLocationIdMarketingAdvertisingNewRoute:
      AuthedDashboardLLocationIdMarketingAdvertisingNewRoute,
    AuthedDashboardLLocationIdMarketingAdvertisingIndexRoute:
      AuthedDashboardLLocationIdMarketingAdvertisingIndexRoute,
    AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRoute:
      AuthedDashboardLLocationIdMarketingAdvertisingIdIndexRoute,
    AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRoute:
      AuthedDashboardLLocationIdMarketingAdvertisingIdAdsAdIdRoute,
  }

const AuthedDashboardLLocationIdMarketingAdvertisingRouteWithChildren =
  AuthedDashboardLLocationIdMarketingAdvertisingRoute._addFileChildren(
    AuthedDashboardLLocationIdMarketingAdvertisingRouteChildren,
  )

interface AuthedDashboardLLocationIdMarketingSocialsRouteChildren {
  AuthedDashboardLLocationIdMarketingSocialsRecentRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRecentRoute
  AuthedDashboardLLocationIdMarketingSocialsReviewRoute: typeof AuthedDashboardLLocationIdMarketingSocialsReviewRoute
  AuthedDashboardLLocationIdMarketingSocialsScheduledRoute: typeof AuthedDashboardLLocationIdMarketingSocialsScheduledRoute
  AuthedDashboardLLocationIdMarketingSocialsIndexRoute: typeof AuthedDashboardLLocationIdMarketingSocialsIndexRoute
  AuthedDashboardLLocationIdMarketingSocialsPostIdRoute: typeof AuthedDashboardLLocationIdMarketingSocialsPostIdRoute
  AuthedDashboardLLocationIdMarketingSocialsNewIndexRoute: typeof AuthedDashboardLLocationIdMarketingSocialsNewIndexRoute
}

const AuthedDashboardLLocationIdMarketingSocialsRouteChildren: AuthedDashboardLLocationIdMarketingSocialsRouteChildren =
  {
    AuthedDashboardLLocationIdMarketingSocialsRecentRoute:
      AuthedDashboardLLocationIdMarketingSocialsRecentRoute,
    AuthedDashboardLLocationIdMarketingSocialsReviewRoute:
      AuthedDashboardLLocationIdMarketingSocialsReviewRoute,
    AuthedDashboardLLocationIdMarketingSocialsScheduledRoute:
      AuthedDashboardLLocationIdMarketingSocialsScheduledRoute,
    AuthedDashboardLLocationIdMarketingSocialsIndexRoute:
      AuthedDashboardLLocationIdMarketingSocialsIndexRoute,
    AuthedDashboardLLocationIdMarketingSocialsPostIdRoute:
      AuthedDashboardLLocationIdMarketingSocialsPostIdRoute,
    AuthedDashboardLLocationIdMarketingSocialsNewIndexRoute:
      AuthedDashboardLLocationIdMarketingSocialsNewIndexRoute,
  }

const AuthedDashboardLLocationIdMarketingSocialsRouteWithChildren =
  AuthedDashboardLLocationIdMarketingSocialsRoute._addFileChildren(
    AuthedDashboardLLocationIdMarketingSocialsRouteChildren,
  )

interface AuthedDashboardLLocationIdMarketingRouteChildren {
  AuthedDashboardLLocationIdMarketingAdvertisingRoute: typeof AuthedDashboardLLocationIdMarketingAdvertisingRouteWithChildren
  AuthedDashboardLLocationIdMarketingLeadFormsRoute: typeof AuthedDashboardLLocationIdMarketingLeadFormsRoute
  AuthedDashboardLLocationIdMarketingSequencesRoute: typeof AuthedDashboardLLocationIdMarketingSequencesRoute
  AuthedDashboardLLocationIdMarketingSocialsRoute: typeof AuthedDashboardLLocationIdMarketingSocialsRouteWithChildren
  AuthedDashboardLLocationIdMarketingIndexRoute: typeof AuthedDashboardLLocationIdMarketingIndexRoute
  AuthedDashboardLLocationIdMarketingGalleryImagesRoute: typeof AuthedDashboardLLocationIdMarketingGalleryImagesRoute
  AuthedDashboardLLocationIdMarketingGalleryLibraryRoute: typeof AuthedDashboardLLocationIdMarketingGalleryLibraryRoute
  AuthedDashboardLLocationIdMarketingGalleryVideosRoute: typeof AuthedDashboardLLocationIdMarketingGalleryVideosRoute
  AuthedDashboardLLocationIdMarketingCampaignsIndexRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsIndexRoute
  AuthedDashboardLLocationIdMarketingGalleryIndexRoute: typeof AuthedDashboardLLocationIdMarketingGalleryIndexRoute
  AuthedDashboardLLocationIdMarketingMusicIndexRoute: typeof AuthedDashboardLLocationIdMarketingMusicIndexRoute
  AuthedDashboardLLocationIdMarketingCampaignsIdIndexRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsIdIndexRoute
  AuthedDashboardLLocationIdMarketingCampaignsNewIndexRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsNewIndexRoute
  AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRoute
  AuthedDashboardLLocationIdMarketingGalleryNewIndexRoute: typeof AuthedDashboardLLocationIdMarketingGalleryNewIndexRoute
  AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRoute: typeof AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRoute
}

const AuthedDashboardLLocationIdMarketingRouteChildren: AuthedDashboardLLocationIdMarketingRouteChildren =
  {
    AuthedDashboardLLocationIdMarketingAdvertisingRoute:
      AuthedDashboardLLocationIdMarketingAdvertisingRouteWithChildren,
    AuthedDashboardLLocationIdMarketingLeadFormsRoute:
      AuthedDashboardLLocationIdMarketingLeadFormsRoute,
    AuthedDashboardLLocationIdMarketingSequencesRoute:
      AuthedDashboardLLocationIdMarketingSequencesRoute,
    AuthedDashboardLLocationIdMarketingSocialsRoute:
      AuthedDashboardLLocationIdMarketingSocialsRouteWithChildren,
    AuthedDashboardLLocationIdMarketingIndexRoute:
      AuthedDashboardLLocationIdMarketingIndexRoute,
    AuthedDashboardLLocationIdMarketingGalleryImagesRoute:
      AuthedDashboardLLocationIdMarketingGalleryImagesRoute,
    AuthedDashboardLLocationIdMarketingGalleryLibraryRoute:
      AuthedDashboardLLocationIdMarketingGalleryLibraryRoute,
    AuthedDashboardLLocationIdMarketingGalleryVideosRoute:
      AuthedDashboardLLocationIdMarketingGalleryVideosRoute,
    AuthedDashboardLLocationIdMarketingCampaignsIndexRoute:
      AuthedDashboardLLocationIdMarketingCampaignsIndexRoute,
    AuthedDashboardLLocationIdMarketingGalleryIndexRoute:
      AuthedDashboardLLocationIdMarketingGalleryIndexRoute,
    AuthedDashboardLLocationIdMarketingMusicIndexRoute:
      AuthedDashboardLLocationIdMarketingMusicIndexRoute,
    AuthedDashboardLLocationIdMarketingCampaignsIdIndexRoute:
      AuthedDashboardLLocationIdMarketingCampaignsIdIndexRoute,
    AuthedDashboardLLocationIdMarketingCampaignsNewIndexRoute:
      AuthedDashboardLLocationIdMarketingCampaignsNewIndexRoute,
    AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRoute:
      AuthedDashboardLLocationIdMarketingCampaignsSegmentsIndexRoute,
    AuthedDashboardLLocationIdMarketingGalleryNewIndexRoute:
      AuthedDashboardLLocationIdMarketingGalleryNewIndexRoute,
    AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRoute:
      AuthedDashboardLLocationIdMarketingCampaignsSegmentsNewIndexRoute,
  }

const AuthedDashboardLLocationIdMarketingRouteWithChildren =
  AuthedDashboardLLocationIdMarketingRoute._addFileChildren(
    AuthedDashboardLLocationIdMarketingRouteChildren,
  )

interface AuthedDashboardLLocationIdSalesRouteChildren {
  AuthedDashboardLLocationIdSalesAppointmentsRoute: typeof AuthedDashboardLLocationIdSalesAppointmentsRoute
  AuthedDashboardLLocationIdSalesDailySummaryRoute: typeof AuthedDashboardLLocationIdSalesDailySummaryRoute
  AuthedDashboardLLocationIdSalesGiftCardsRoute: typeof AuthedDashboardLLocationIdSalesGiftCardsRoute
  AuthedDashboardLLocationIdSalesListRoute: typeof AuthedDashboardLLocationIdSalesListRoute
  AuthedDashboardLLocationIdSalesMembershipsRoute: typeof AuthedDashboardLLocationIdSalesMembershipsRoute
  AuthedDashboardLLocationIdSalesPaymentsRoute: typeof AuthedDashboardLLocationIdSalesPaymentsRoute
  AuthedDashboardLLocationIdSalesProductOrdersRoute: typeof AuthedDashboardLLocationIdSalesProductOrdersRoute
  AuthedDashboardLLocationIdSalesIndexRoute: typeof AuthedDashboardLLocationIdSalesIndexRoute
}

const AuthedDashboardLLocationIdSalesRouteChildren: AuthedDashboardLLocationIdSalesRouteChildren =
  {
    AuthedDashboardLLocationIdSalesAppointmentsRoute:
      AuthedDashboardLLocationIdSalesAppointmentsRoute,
    AuthedDashboardLLocationIdSalesDailySummaryRoute:
      AuthedDashboardLLocationIdSalesDailySummaryRoute,
    AuthedDashboardLLocationIdSalesGiftCardsRoute:
      AuthedDashboardLLocationIdSalesGiftCardsRoute,
    AuthedDashboardLLocationIdSalesListRoute:
      AuthedDashboardLLocationIdSalesListRoute,
    AuthedDashboardLLocationIdSalesMembershipsRoute:
      AuthedDashboardLLocationIdSalesMembershipsRoute,
    AuthedDashboardLLocationIdSalesPaymentsRoute:
      AuthedDashboardLLocationIdSalesPaymentsRoute,
    AuthedDashboardLLocationIdSalesProductOrdersRoute:
      AuthedDashboardLLocationIdSalesProductOrdersRoute,
    AuthedDashboardLLocationIdSalesIndexRoute:
      AuthedDashboardLLocationIdSalesIndexRoute,
  }

const AuthedDashboardLLocationIdSalesRouteWithChildren =
  AuthedDashboardLLocationIdSalesRoute._addFileChildren(
    AuthedDashboardLLocationIdSalesRouteChildren,
  )

interface AuthedDashboardLLocationIdCatalogServicesRouteChildren {
  AuthedDashboardLLocationIdCatalogServicesIndexRoute: typeof AuthedDashboardLLocationIdCatalogServicesIndexRoute
}

const AuthedDashboardLLocationIdCatalogServicesRouteChildren: AuthedDashboardLLocationIdCatalogServicesRouteChildren =
  {
    AuthedDashboardLLocationIdCatalogServicesIndexRoute:
      AuthedDashboardLLocationIdCatalogServicesIndexRoute,
  }

const AuthedDashboardLLocationIdCatalogServicesRouteWithChildren =
  AuthedDashboardLLocationIdCatalogServicesRoute._addFileChildren(
    AuthedDashboardLLocationIdCatalogServicesRouteChildren,
  )

interface AuthedDashboardLLocationIdRouteChildren {
  AuthedDashboardLLocationIdAiAssistantRoute: typeof AuthedDashboardLLocationIdAiAssistantRoute
  AuthedDashboardLLocationIdCalendarRoute: typeof AuthedDashboardLLocationIdCalendarRouteWithChildren
  AuthedDashboardLLocationIdClientsRoute: typeof AuthedDashboardLLocationIdClientsRouteWithChildren
  AuthedDashboardLLocationIdContentCalendarRoute: typeof AuthedDashboardLLocationIdContentCalendarRouteWithChildren
  AuthedDashboardLLocationIdCustomersRoute: typeof AuthedDashboardLLocationIdCustomersRouteWithChildren
  AuthedDashboardLLocationIdDepositsRoute: typeof AuthedDashboardLLocationIdDepositsRoute
  AuthedDashboardLLocationIdHomeRoute: typeof AuthedDashboardLLocationIdHomeRoute
  AuthedDashboardLLocationIdMarketingRoute: typeof AuthedDashboardLLocationIdMarketingRouteWithChildren
  AuthedDashboardLLocationIdPublicSiteRoute: typeof AuthedDashboardLLocationIdPublicSiteRoute
  AuthedDashboardLLocationIdSalesRoute: typeof AuthedDashboardLLocationIdSalesRouteWithChildren
  AuthedDashboardLLocationIdVenueRoute: typeof AuthedDashboardLLocationIdVenueRoute
  AuthedDashboardLLocationIdCatalogBrandsRoute: typeof AuthedDashboardLLocationIdCatalogBrandsRoute
  AuthedDashboardLLocationIdCatalogCategoriesRoute: typeof AuthedDashboardLLocationIdCatalogCategoriesRoute
  AuthedDashboardLLocationIdCatalogMembershipsRoute: typeof AuthedDashboardLLocationIdCatalogMembershipsRoute
  AuthedDashboardLLocationIdCatalogOffersRoute: typeof AuthedDashboardLLocationIdCatalogOffersRoute
  AuthedDashboardLLocationIdCatalogPackagesRoute: typeof AuthedDashboardLLocationIdCatalogPackagesRoute
  AuthedDashboardLLocationIdCatalogProductsRoute: typeof AuthedDashboardLLocationIdCatalogProductsRoute
  AuthedDashboardLLocationIdCatalogResourcesRoute: typeof AuthedDashboardLLocationIdCatalogResourcesRoute
  AuthedDashboardLLocationIdCatalogServicesRoute: typeof AuthedDashboardLLocationIdCatalogServicesRouteWithChildren
  AuthedDashboardLLocationIdCatalogStockOrdersRoute: typeof AuthedDashboardLLocationIdCatalogStockOrdersRoute
  AuthedDashboardLLocationIdCatalogStocktakesRoute: typeof AuthedDashboardLLocationIdCatalogStocktakesRoute
  AuthedDashboardLLocationIdCatalogSuppliersRoute: typeof AuthedDashboardLLocationIdCatalogSuppliersRoute
  AuthedDashboardLLocationIdInventoryBrandsRoute: typeof AuthedDashboardLLocationIdInventoryBrandsRoute
  AuthedDashboardLLocationIdInventoryCategoriesRoute: typeof AuthedDashboardLLocationIdInventoryCategoriesRoute
  AuthedDashboardLLocationIdInventoryStockOrdersRoute: typeof AuthedDashboardLLocationIdInventoryStockOrdersRoute
  AuthedDashboardLLocationIdInventoryStocktakesRoute: typeof AuthedDashboardLLocationIdInventoryStocktakesRoute
  AuthedDashboardLLocationIdInventorySuppliersRoute: typeof AuthedDashboardLLocationIdInventorySuppliersRoute
  AuthedDashboardLLocationIdTeamMembersRoute: typeof AuthedDashboardLLocationIdTeamMembersRoute
  AuthedDashboardLLocationIdTeamPractitionersRoute: typeof AuthedDashboardLLocationIdTeamPractitionersRoute
  AuthedDashboardLLocationIdTeamShiftsRoute: typeof AuthedDashboardLLocationIdTeamShiftsRoute
  AuthedDashboardLLocationIdTeamTimesheetsRoute: typeof AuthedDashboardLLocationIdTeamTimesheetsRoute
  AuthedDashboardLLocationIdCatalogIndexRoute: typeof AuthedDashboardLLocationIdCatalogIndexRoute
  AuthedDashboardLLocationIdTeamIndexRoute: typeof AuthedDashboardLLocationIdTeamIndexRoute
  AuthedDashboardLLocationIdVideosIndexRoute: typeof AuthedDashboardLLocationIdVideosIndexRoute
  AuthedDashboardLLocationIdVideosCreateFromClientIndexRoute: typeof AuthedDashboardLLocationIdVideosCreateFromClientIndexRoute
}

const AuthedDashboardLLocationIdRouteChildren: AuthedDashboardLLocationIdRouteChildren =
  {
    AuthedDashboardLLocationIdAiAssistantRoute:
      AuthedDashboardLLocationIdAiAssistantRoute,
    AuthedDashboardLLocationIdCalendarRoute:
      AuthedDashboardLLocationIdCalendarRouteWithChildren,
    AuthedDashboardLLocationIdClientsRoute:
      AuthedDashboardLLocationIdClientsRouteWithChildren,
    AuthedDashboardLLocationIdContentCalendarRoute:
      AuthedDashboardLLocationIdContentCalendarRouteWithChildren,
    AuthedDashboardLLocationIdCustomersRoute:
      AuthedDashboardLLocationIdCustomersRouteWithChildren,
    AuthedDashboardLLocationIdDepositsRoute:
      AuthedDashboardLLocationIdDepositsRoute,
    AuthedDashboardLLocationIdHomeRoute: AuthedDashboardLLocationIdHomeRoute,
    AuthedDashboardLLocationIdMarketingRoute:
      AuthedDashboardLLocationIdMarketingRouteWithChildren,
    AuthedDashboardLLocationIdPublicSiteRoute:
      AuthedDashboardLLocationIdPublicSiteRoute,
    AuthedDashboardLLocationIdSalesRoute:
      AuthedDashboardLLocationIdSalesRouteWithChildren,
    AuthedDashboardLLocationIdVenueRoute: AuthedDashboardLLocationIdVenueRoute,
    AuthedDashboardLLocationIdCatalogBrandsRoute:
      AuthedDashboardLLocationIdCatalogBrandsRoute,
    AuthedDashboardLLocationIdCatalogCategoriesRoute:
      AuthedDashboardLLocationIdCatalogCategoriesRoute,
    AuthedDashboardLLocationIdCatalogMembershipsRoute:
      AuthedDashboardLLocationIdCatalogMembershipsRoute,
    AuthedDashboardLLocationIdCatalogOffersRoute:
      AuthedDashboardLLocationIdCatalogOffersRoute,
    AuthedDashboardLLocationIdCatalogPackagesRoute:
      AuthedDashboardLLocationIdCatalogPackagesRoute,
    AuthedDashboardLLocationIdCatalogProductsRoute:
      AuthedDashboardLLocationIdCatalogProductsRoute,
    AuthedDashboardLLocationIdCatalogResourcesRoute:
      AuthedDashboardLLocationIdCatalogResourcesRoute,
    AuthedDashboardLLocationIdCatalogServicesRoute:
      AuthedDashboardLLocationIdCatalogServicesRouteWithChildren,
    AuthedDashboardLLocationIdCatalogStockOrdersRoute:
      AuthedDashboardLLocationIdCatalogStockOrdersRoute,
    AuthedDashboardLLocationIdCatalogStocktakesRoute:
      AuthedDashboardLLocationIdCatalogStocktakesRoute,
    AuthedDashboardLLocationIdCatalogSuppliersRoute:
      AuthedDashboardLLocationIdCatalogSuppliersRoute,
    AuthedDashboardLLocationIdInventoryBrandsRoute:
      AuthedDashboardLLocationIdInventoryBrandsRoute,
    AuthedDashboardLLocationIdInventoryCategoriesRoute:
      AuthedDashboardLLocationIdInventoryCategoriesRoute,
    AuthedDashboardLLocationIdInventoryStockOrdersRoute:
      AuthedDashboardLLocationIdInventoryStockOrdersRoute,
    AuthedDashboardLLocationIdInventoryStocktakesRoute:
      AuthedDashboardLLocationIdInventoryStocktakesRoute,
    AuthedDashboardLLocationIdInventorySuppliersRoute:
      AuthedDashboardLLocationIdInventorySuppliersRoute,
    AuthedDashboardLLocationIdTeamMembersRoute:
      AuthedDashboardLLocationIdTeamMembersRoute,
    AuthedDashboardLLocationIdTeamPractitionersRoute:
      AuthedDashboardLLocationIdTeamPractitionersRoute,
    AuthedDashboardLLocationIdTeamShiftsRoute:
      AuthedDashboardLLocationIdTeamShiftsRoute,
    AuthedDashboardLLocationIdTeamTimesheetsRoute:
      AuthedDashboardLLocationIdTeamTimesheetsRoute,
    AuthedDashboardLLocationIdCatalogIndexRoute:
      AuthedDashboardLLocationIdCatalogIndexRoute,
    AuthedDashboardLLocationIdTeamIndexRoute:
      AuthedDashboardLLocationIdTeamIndexRoute,
    AuthedDashboardLLocationIdVideosIndexRoute:
      AuthedDashboardLLocationIdVideosIndexRoute,
    AuthedDashboardLLocationIdVideosCreateFromClientIndexRoute:
      AuthedDashboardLLocationIdVideosCreateFromClientIndexRoute,
  }

const AuthedDashboardLLocationIdRouteWithChildren =
  AuthedDashboardLLocationIdRoute._addFileChildren(
    AuthedDashboardLLocationIdRouteChildren,
  )

interface AuthedDashboardRouteChildren {
  AuthedDashboardSplatRoute: typeof AuthedDashboardSplatRoute
  AuthedDashboardAccountRoute: typeof AuthedDashboardAccountRoute
  AuthedDashboardBrandRoute: typeof AuthedDashboardBrandRoute
  AuthedDashboardChatbotsRoute: typeof AuthedDashboardChatbotsRoute
  AuthedDashboardConversationsRoute: typeof AuthedDashboardConversationsRoute
  AuthedDashboardIntakeFormsRoute: typeof AuthedDashboardIntakeFormsRoute
  AuthedDashboardIntegrationsRoute: typeof AuthedDashboardIntegrationsRoute
  AuthedDashboardLeadFormsRoute: typeof AuthedDashboardLeadFormsRoute
  AuthedDashboardLeadManagementRoute: typeof AuthedDashboardLeadManagementRoute
  AuthedDashboardLocationsRoute: typeof AuthedDashboardLocationsRoute
  AuthedDashboardNotificationsRoute: typeof AuthedDashboardNotificationsRoute
  AuthedDashboardOffersRoute: typeof AuthedDashboardOffersRoute
  AuthedDashboardOrganisationRoute: typeof AuthedDashboardOrganisationRoute
  AuthedDashboardReportsRoute: typeof AuthedDashboardReportsRoute
  AuthedDashboardResetRoute: typeof AuthedDashboardResetRoute
  AuthedDashboardRetentionRoute: typeof AuthedDashboardRetentionRoute
  AuthedDashboardReviewsRoute: typeof AuthedDashboardReviewsRoute
  AuthedDashboardSettingsRoute: typeof AuthedDashboardSettingsRouteWithChildren
  AuthedDashboardTemplatePreviewRoute: typeof AuthedDashboardTemplatePreviewRoute
  AuthedDashboardTrainingHubRoute: typeof AuthedDashboardTrainingHubRoute
  AuthedDashboardVoiceTestRoute: typeof AuthedDashboardVoiceTestRoute
  AuthedDashboardWebsiteRoute: typeof AuthedDashboardWebsiteRoute
  AuthedDashboardWireframesRoute: typeof AuthedDashboardWireframesRouteWithChildren
  AuthedDashboardIndexRoute: typeof AuthedDashboardIndexRoute
  AuthedDashboardAdvertisingNewRoute: typeof AuthedDashboardAdvertisingNewRoute
  AuthedDashboardAppointmentsAgendaRoute: typeof AuthedDashboardAppointmentsAgendaRoute
  AuthedDashboardAppointmentsDayRoute: typeof AuthedDashboardAppointmentsDayRoute
  AuthedDashboardAppointmentsMonthRoute: typeof AuthedDashboardAppointmentsMonthRoute
  AuthedDashboardAppointmentsWeekRoute: typeof AuthedDashboardAppointmentsWeekRoute
  AuthedDashboardAppointmentsYearRoute: typeof AuthedDashboardAppointmentsYearRoute
  AuthedDashboardContentGalleryRoute: typeof AuthedDashboardContentGalleryRoute
  AuthedDashboardContentImagesRoute: typeof AuthedDashboardContentImagesRoute
  AuthedDashboardContentLibraryRoute: typeof AuthedDashboardContentLibraryRoute
  AuthedDashboardContentNewRoute: typeof AuthedDashboardContentNewRoute
  AuthedDashboardContentVideosRoute: typeof AuthedDashboardContentVideosRoute
  AuthedDashboardDebugAnalysisSplitTestRoute: typeof AuthedDashboardDebugAnalysisSplitTestRoute
  AuthedDashboardLLocationIdRoute: typeof AuthedDashboardLLocationIdRouteWithChildren
  AuthedDashboardMoreSectionRoute: typeof AuthedDashboardMoreSectionRoute
  AuthedDashboardServicesNewRoute: typeof AuthedDashboardServicesNewRoute
  AuthedDashboardSocialsNewRoute: typeof AuthedDashboardSocialsNewRoute
  AuthedDashboardSocialsRecentRoute: typeof AuthedDashboardSocialsRecentRoute
  AuthedDashboardSocialsReviewRoute: typeof AuthedDashboardSocialsReviewRoute
  AuthedDashboardSocialsScheduledRoute: typeof AuthedDashboardSocialsScheduledRoute
  AuthedDashboardAdvertisingIndexRoute: typeof AuthedDashboardAdvertisingIndexRoute
  AuthedDashboardAppointmentsIndexRoute: typeof AuthedDashboardAppointmentsIndexRoute
  AuthedDashboardContentIndexRoute: typeof AuthedDashboardContentIndexRoute
  AuthedDashboardDebugIndexRoute: typeof AuthedDashboardDebugIndexRoute
  AuthedDashboardMoreIndexRoute: typeof AuthedDashboardMoreIndexRoute
  AuthedDashboardServicesIndexRoute: typeof AuthedDashboardServicesIndexRoute
  AuthedDashboardSocialsIndexRoute: typeof AuthedDashboardSocialsIndexRoute
  AuthedDashboardAppointmentsNewBlockRoute: typeof AuthedDashboardAppointmentsNewBlockRoute
  AuthedDashboardAppointmentsNewClientRoute: typeof AuthedDashboardAppointmentsNewClientRoute
  AuthedDashboardServicesServiceIdEditRoute: typeof AuthedDashboardServicesServiceIdEditRoute
  AuthedDashboardSocialsPostIdRoute: typeof AuthedDashboardSocialsPostIdRoute
  AuthedDashboardAdvertisingIdIndexRoute: typeof AuthedDashboardAdvertisingIdIndexRoute
  AuthedDashboardAppointmentsNewIndexRoute: typeof AuthedDashboardAppointmentsNewIndexRoute
  AuthedDashboardAdvertisingIdAdsAdIdRoute: typeof AuthedDashboardAdvertisingIdAdsAdIdRoute
}

const AuthedDashboardRouteChildren: AuthedDashboardRouteChildren = {
  AuthedDashboardSplatRoute: AuthedDashboardSplatRoute,
  AuthedDashboardAccountRoute: AuthedDashboardAccountRoute,
  AuthedDashboardBrandRoute: AuthedDashboardBrandRoute,
  AuthedDashboardChatbotsRoute: AuthedDashboardChatbotsRoute,
  AuthedDashboardConversationsRoute: AuthedDashboardConversationsRoute,
  AuthedDashboardIntakeFormsRoute: AuthedDashboardIntakeFormsRoute,
  AuthedDashboardIntegrationsRoute: AuthedDashboardIntegrationsRoute,
  AuthedDashboardLeadFormsRoute: AuthedDashboardLeadFormsRoute,
  AuthedDashboardLeadManagementRoute: AuthedDashboardLeadManagementRoute,
  AuthedDashboardLocationsRoute: AuthedDashboardLocationsRoute,
  AuthedDashboardNotificationsRoute: AuthedDashboardNotificationsRoute,
  AuthedDashboardOffersRoute: AuthedDashboardOffersRoute,
  AuthedDashboardOrganisationRoute: AuthedDashboardOrganisationRoute,
  AuthedDashboardReportsRoute: AuthedDashboardReportsRoute,
  AuthedDashboardResetRoute: AuthedDashboardResetRoute,
  AuthedDashboardRetentionRoute: AuthedDashboardRetentionRoute,
  AuthedDashboardReviewsRoute: AuthedDashboardReviewsRoute,
  AuthedDashboardSettingsRoute: AuthedDashboardSettingsRouteWithChildren,
  AuthedDashboardTemplatePreviewRoute: AuthedDashboardTemplatePreviewRoute,
  AuthedDashboardTrainingHubRoute: AuthedDashboardTrainingHubRoute,
  AuthedDashboardVoiceTestRoute: AuthedDashboardVoiceTestRoute,
  AuthedDashboardWebsiteRoute: AuthedDashboardWebsiteRoute,
  AuthedDashboardWireframesRoute: AuthedDashboardWireframesRouteWithChildren,
  AuthedDashboardIndexRoute: AuthedDashboardIndexRoute,
  AuthedDashboardAdvertisingNewRoute: AuthedDashboardAdvertisingNewRoute,
  AuthedDashboardAppointmentsAgendaRoute:
    AuthedDashboardAppointmentsAgendaRoute,
  AuthedDashboardAppointmentsDayRoute: AuthedDashboardAppointmentsDayRoute,
  AuthedDashboardAppointmentsMonthRoute: AuthedDashboardAppointmentsMonthRoute,
  AuthedDashboardAppointmentsWeekRoute: AuthedDashboardAppointmentsWeekRoute,
  AuthedDashboardAppointmentsYearRoute: AuthedDashboardAppointmentsYearRoute,
  AuthedDashboardContentGalleryRoute: AuthedDashboardContentGalleryRoute,
  AuthedDashboardContentImagesRoute: AuthedDashboardContentImagesRoute,
  AuthedDashboardContentLibraryRoute: AuthedDashboardContentLibraryRoute,
  AuthedDashboardContentNewRoute: AuthedDashboardContentNewRoute,
  AuthedDashboardContentVideosRoute: AuthedDashboardContentVideosRoute,
  AuthedDashboardDebugAnalysisSplitTestRoute:
    AuthedDashboardDebugAnalysisSplitTestRoute,
  AuthedDashboardLLocationIdRoute: AuthedDashboardLLocationIdRouteWithChildren,
  AuthedDashboardMoreSectionRoute: AuthedDashboardMoreSectionRoute,
  AuthedDashboardServicesNewRoute: AuthedDashboardServicesNewRoute,
  AuthedDashboardSocialsNewRoute: AuthedDashboardSocialsNewRoute,
  AuthedDashboardSocialsRecentRoute: AuthedDashboardSocialsRecentRoute,
  AuthedDashboardSocialsReviewRoute: AuthedDashboardSocialsReviewRoute,
  AuthedDashboardSocialsScheduledRoute: AuthedDashboardSocialsScheduledRoute,
  AuthedDashboardAdvertisingIndexRoute: AuthedDashboardAdvertisingIndexRoute,
  AuthedDashboardAppointmentsIndexRoute: AuthedDashboardAppointmentsIndexRoute,
  AuthedDashboardContentIndexRoute: AuthedDashboardContentIndexRoute,
  AuthedDashboardDebugIndexRoute: AuthedDashboardDebugIndexRoute,
  AuthedDashboardMoreIndexRoute: AuthedDashboardMoreIndexRoute,
  AuthedDashboardServicesIndexRoute: AuthedDashboardServicesIndexRoute,
  AuthedDashboardSocialsIndexRoute: AuthedDashboardSocialsIndexRoute,
  AuthedDashboardAppointmentsNewBlockRoute:
    AuthedDashboardAppointmentsNewBlockRoute,
  AuthedDashboardAppointmentsNewClientRoute:
    AuthedDashboardAppointmentsNewClientRoute,
  AuthedDashboardServicesServiceIdEditRoute:
    AuthedDashboardServicesServiceIdEditRoute,
  AuthedDashboardSocialsPostIdRoute: AuthedDashboardSocialsPostIdRoute,
  AuthedDashboardAdvertisingIdIndexRoute:
    AuthedDashboardAdvertisingIdIndexRoute,
  AuthedDashboardAppointmentsNewIndexRoute:
    AuthedDashboardAppointmentsNewIndexRoute,
  AuthedDashboardAdvertisingIdAdsAdIdRoute:
    AuthedDashboardAdvertisingIdAdsAdIdRoute,
}

const AuthedDashboardRouteWithChildren = AuthedDashboardRoute._addFileChildren(
  AuthedDashboardRouteChildren,
)

interface AuthedWireframeFullscreenRouteChildren {
  AuthedWireframeFullscreenAnnotateRoute: typeof AuthedWireframeFullscreenAnnotateRoute
  AuthedWireframeFullscreenCompareRoute: typeof AuthedWireframeFullscreenCompareRoute
  AuthedWireframeFullscreenConsentKioskRoute: typeof AuthedWireframeFullscreenConsentKioskRoute
  AuthedWireframeFullscreenScribeRoute: typeof AuthedWireframeFullscreenScribeRoute
}

const AuthedWireframeFullscreenRouteChildren: AuthedWireframeFullscreenRouteChildren =
  {
    AuthedWireframeFullscreenAnnotateRoute:
      AuthedWireframeFullscreenAnnotateRoute,
    AuthedWireframeFullscreenCompareRoute:
      AuthedWireframeFullscreenCompareRoute,
    AuthedWireframeFullscreenConsentKioskRoute:
      AuthedWireframeFullscreenConsentKioskRoute,
    AuthedWireframeFullscreenScribeRoute: AuthedWireframeFullscreenScribeRoute,
  }

const AuthedWireframeFullscreenRouteWithChildren =
  AuthedWireframeFullscreenRoute._addFileChildren(
    AuthedWireframeFullscreenRouteChildren,
  )

interface AuthedSettingsClaireRouteChildren {
  AuthedSettingsClaireUsageRoute: typeof AuthedSettingsClaireUsageRoute
  AuthedSettingsClaireWhatsappRoute: typeof AuthedSettingsClaireWhatsappRoute
}

const AuthedSettingsClaireRouteChildren: AuthedSettingsClaireRouteChildren = {
  AuthedSettingsClaireUsageRoute: AuthedSettingsClaireUsageRoute,
  AuthedSettingsClaireWhatsappRoute: AuthedSettingsClaireWhatsappRoute,
}

const AuthedSettingsClaireRouteWithChildren =
  AuthedSettingsClaireRoute._addFileChildren(AuthedSettingsClaireRouteChildren)

interface AuthedRouteChildren {
  AuthedAssistantRoute: typeof AuthedAssistantRoute
  AuthedBillingRoute: typeof AuthedBillingRoute
  AuthedDashboardRoute: typeof AuthedDashboardRouteWithChildren
  AuthedReviewContentRoute: typeof AuthedReviewContentRoute
  AuthedWebsitePreviewRoute: typeof AuthedWebsitePreviewRoute
  AuthedWireframeFullscreenRoute: typeof AuthedWireframeFullscreenRouteWithChildren
  AuthedCreateEntityRoute: typeof AuthedCreateEntityRoute
  AuthedRecordVideoIdRoute: typeof AuthedRecordVideoIdRoute
  AuthedSettingsClaireRoute: typeof AuthedSettingsClaireRouteWithChildren
  AuthedCreateVideoIndexRoute: typeof AuthedCreateVideoIndexRoute
  AuthedRecordIndexRoute: typeof AuthedRecordIndexRoute
  AuthedAdsNewVideoFormatRoute: typeof AuthedAdsNewVideoFormatRoute
  AuthedEditEntityIdRoute: typeof AuthedEditEntityIdRoute
  AuthedTeamRepeatingShiftsPractitionerIdRoute: typeof AuthedTeamRepeatingShiftsPractitionerIdRoute
  AuthedAdsNewIndexRoute: typeof AuthedAdsNewIndexRoute
  AuthedConnectMetaAdsIndexRoute: typeof AuthedConnectMetaAdsIndexRoute
  AuthedCreateVideoTemplateIdIndexRoute: typeof AuthedCreateVideoTemplateIdIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAssistantRoute: AuthedAssistantRoute,
  AuthedBillingRoute: AuthedBillingRoute,
  AuthedDashboardRoute: AuthedDashboardRouteWithChildren,
  AuthedReviewContentRoute: AuthedReviewContentRoute,
  AuthedWebsitePreviewRoute: AuthedWebsitePreviewRoute,
  AuthedWireframeFullscreenRoute: AuthedWireframeFullscreenRouteWithChildren,
  AuthedCreateEntityRoute: AuthedCreateEntityRoute,
  AuthedRecordVideoIdRoute: AuthedRecordVideoIdRoute,
  AuthedSettingsClaireRoute: AuthedSettingsClaireRouteWithChildren,
  AuthedCreateVideoIndexRoute: AuthedCreateVideoIndexRoute,
  AuthedRecordIndexRoute: AuthedRecordIndexRoute,
  AuthedAdsNewVideoFormatRoute: AuthedAdsNewVideoFormatRoute,
  AuthedEditEntityIdRoute: AuthedEditEntityIdRoute,
  AuthedTeamRepeatingShiftsPractitionerIdRoute:
    AuthedTeamRepeatingShiftsPractitionerIdRoute,
  AuthedAdsNewIndexRoute: AuthedAdsNewIndexRoute,
  AuthedConnectMetaAdsIndexRoute: AuthedConnectMetaAdsIndexRoute,
  AuthedCreateVideoTemplateIdIndexRoute: AuthedCreateVideoTemplateIdIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface OnboardingRouteChildren {
  OnboardingOnboardingRoute: typeof OnboardingOnboardingRoute
  OnboardingSetupProfileRoute: typeof OnboardingSetupProfileRoute
  OnboardingUploadAssetsRoute: typeof OnboardingUploadAssetsRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingOnboardingRoute: OnboardingOnboardingRoute,
  OnboardingSetupProfileRoute: OnboardingSetupProfileRoute,
  OnboardingUploadAssetsRoute: OnboardingUploadAssetsRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface WelcomeRouteChildren {
  WelcomeIndexRoute: typeof WelcomeIndexRoute
}

const WelcomeRouteChildren: WelcomeRouteChildren = {
  WelcomeIndexRoute: WelcomeIndexRoute,
}

const WelcomeRouteWithChildren =
  WelcomeRoute._addFileChildren(WelcomeRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AuthedRoute: AuthedRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  CreativeLabRoute: CreativeLabRoute,
  CreativeLabCardRoute: CreativeLabCardRoute,
  CreativeLabPanelRoute: CreativeLabPanelRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  RestoreOrganizationRoute: RestoreOrganizationRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  Verify2faRoute: Verify2faRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  WelcomeRoute: WelcomeRouteWithChildren,
  ConnectFacebookRoute: ConnectFacebookRoute,
  ConnectWhatsappRoute: ConnectWhatsappRoute,
  StartTokenRoute: StartTokenRoute,
  ConnectStripeDoneRoute: ConnectStripeDoneRoute,
  FormsOrganizationSlugTokenRoute: FormsOrganizationSlugTokenRoute,
  VenueOrganizationSlugLocationSlugRoute:
    VenueOrganizationSlugLocationSlugRoute,
  OptInOrganizationSlugIndexRoute: OptInOrganizationSlugIndexRoute,
  VenueOrganizationSlugIndexRoute: VenueOrganizationSlugIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
